// Extra i18n keys for newer pages/components not covered by the legacy dictionaries.
// Merged at runtime into the main i18next resources (see `src/translate/languages/index.js`).
export const customTranslations = {
  es: {
    common: {
      save: "Guardar",
      cancel: "Cancelar",
      back: "Volver",
      next: "Siguiente",
      previous: "Anterior",
      create: "Crear",
      update: "Actualizar",
      add: "Agregar",
      edit: "Editar",
      import: "Importar",
      export: "Exportar",
      confirm: "Confirmar",
      close: "Cerrar",
      delete: "Eliminar",
      duplicate: "Duplicar",
      refresh: "Actualizar",
      search: "Buscar",
      configure: "Configurar",
      upgradePlan: "Mejorar plan",
      company: "Empresa",
      package: "Paquete",
      assignCredits: "Asignar créditos",
      copied: "Copiado",
      yes: "Sí",
      no: "No",
      active: "Activo",
      inactive: "Inactivo",
      actions: "Acciones",
      status: "Estado",
      source: "Fuente",
      date: "Fecha",
      id: "ID",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      notes: "Notas",
      description: "Descripción",
      price: "Precio",
      tokens: "Tokens",
      clear: "Limpiar",
      deactivate: "Desactivar",
      activate: "Activar",
      anErrorOccurred: "Ocurrió un error.",
      loading: "Cargando...",
      ok: "OK",
      total: "Total",
      other: "Otro",
      send: "Enviar",
      chat: "Conversar",
      placeholders: {
        emailAddress: "Dirección de email",
      },
      alt: {
        thumbnail: "Miniatura",
      },
      validation: {
        required: "Obligatorio.",
        tooShort: "Demasiado corto.",
        tooLong: "Demasiado largo.",
        passwordRequired: "La contraseña es obligatoria.",
        invalidEmail: "Email inválido.",
        apiKeyRequired: "La API Key es obligatoria.",
        voiceModeRequired: "El modo de voz es obligatorio.",
        ratingRequired: "La calificación es obligatoria.",
        passwordsMustMatch: "Las contraseñas deben coincidir.",
        invalidOption: "Opción inválida.",
        minValue: "Mínimo {{min}}.",
        maxValue: "Máximo {{max}}.",
      },
      errors: {
        loadRecords: "No se pudo cargar la lista de registros.",
        noPermissionRedirect:
          "Esta empresa no tiene permiso para acceder a esta página. Te estamos redirigiendo.",
        operationFailed: "No se pudo completar la operación.",
        operationFailedDuplicateOrInvalid:
          "No se pudo completar la operación. Verifica los datos e intenta nuevamente.",
      },
      toasts: {
        success: "Operación realizada con éxito.",
        clickSaveToApplyChanges: 'Haz clic en "Guardar" para aplicar los cambios.',
      },
      confirmationModal: {
        deleteTitle: "Eliminar registro",
        deleteMessage: "¿Deseas realmente eliminar este registro?",
      },
    },
    backendErrors: {
      plan_limit_exceeded:
        "Has alcanzado el límite de conexiones de tu membresía. Actualiza tu plan para agregar más.",
    },
    connections: {
      table: {
        channel: "Canal",
      },
    },
    compaies: {
      table: {
        folderSize: "Tamaño de carpeta",
        totalFiles: "Total de archivos",
        lastFolderUpdate: "Última actualización de carpeta",
      },
    },
    qrCode: {
      waiting: "Esperando el código QR",
    },
    chatbots: {
      toasts: {
        saved: "Chatbot guardado con éxito.",
        deleted: "Chatbot eliminado con éxito.",
      },
      confirmationModal: {
        deleteMessage:
          "¿Estás seguro? Todas las opciones internas también se eliminarán.",
      },
      validation: {
        optionNameMin: "El nombre de la opción debe tener al menos 4 caracteres.",
        optionNameRequired: "El nombre de la opción es obligatorio.",
        optionsRequired: "Debes agregar al menos una opción.",
      },
    },
    contactImportWpModal: {
      status: {
        completed: "Importación completada con éxito.",
        inProgress:
          "Importación en curso {{current}} de {{total}}. No salgas de esta pantalla hasta que finalice la importación.",
      },
    },
    tagsKanban: {
      form: {
        stage: "Etapa Kanban",
      },
    },
    filters: {
      placeholders: {
        contacts: "Contactos",
        connections: "Conexiones",
        departments: "Departamentos",
        statusFilter: "Filtrar por estado",
        tagsFilter: "Filtrar por etiquetas",
        tags: "Tags",
      },
    },
    tagsContainer: {
      errors: {
        tooShort: "Etiqueta demasiado corta.",
      },
    },
    tickets: {
      search: {
        filterConectionsOptions: {
          groups: "Grupos",
        },
      },
      simulateIncoming: {
        channelFallback: "canal",
        body: "Mensaje de prueba ({{channel}})",
        menuLabel: "Simular mensaje entrante",
        toasts: {
          success: "Mensaje entrante simulado.",
        },
      },
    },
    messageUploadMedias: {
      placeholders: {
        caption: "Leyenda (opcional)",
      },
      fallback: {
        unavailable: "Vista previa no disponible",
      },
      alt: {
        image: "Imagen {{index}}",
      },
    },
    ticket: {
      chat: {
        searchPlaceholder: "Buscar en este chat...",
      },
    },
    messagesList: {
      deletedMessage: "🚫 _Mensaje eliminado_",
      deletedText: "🚫 Mensaje eliminado",
      deletedByContactText: "🚫 Este mensaje fue eliminado por el contacto",
      forwarded: "Reenviado",
      reacted: "Reaccionaste... {{reaction}}",
      editedAt: "Editado {{time}}",
      empty: {
        startConversation: "¡Di hola a tu nuevo contacto!",
      },
      dragDrop: {
        dropHere: "Suelta el archivo aquí",
      },
      facebookPolicy24h:
        "Tienes 24 h para responder después de recibir un mensaje, de acuerdo con las políticas de Facebook.",
    },
    recurrence: {
      title: "Recurrencia",
      description:
        "Puedes elegir enviar el mensaje de forma recurrente y elegir el intervalo. Si es un mensaje que se enviará solo una vez, no cambies nada en esta sección.",
      interval: {
        label: "Intervalo",
        valueLabel: "Valor del intervalo",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      sendCount: {
        label: "Enviar cuántas veces",
      },
      businessDaysPolicy: {
        label: "Días no laborables",
        options: {
          normal: "Enviar normalmente en días no laborables",
          before: "Enviar un día laborable antes",
          after: "Enviar un día laborable después",
        },
      },
      showUser: "Mostrar usuario",
    },
    whatsappModal: {
      flowbuilder: {
        welcomeFlow: {
          title: "Flujo de bienvenida",
          description:
            "Este flujo se dispara solo para nuevos contactos: personas que no están en tu lista de contactos y que enviaron un mensaje.",
        },
        defaultResponseFlow: {
          title: "Flujo de respuesta predeterminada",
          description:
            "La respuesta predeterminada se envía con cualquier carácter distinto de una palabra clave. Atención: se disparará si la atención ya está cerrada.",
        },
      },
    },
    ticketsList: {
      preview: {
        title: "Vista previa de la conversación",
      },
      loadingMessages: "Cargando mensajes...",
      tooltips: {
        previewConversation: "Vista previa de la conversación",
      },
      adClick: "Clic del anuncio",
    },
    userModal: {
      form: {
        profiles: {
          admin: "Administrador",
          user: "Usuario",
        },
      },
    },
    contactNotesEditModal: {
      title: "Editar nota",
      fields: {
        note: "Nota",
      },
    },
    updateNotification: {
      title: "¡Nueva versión disponible!",
      subtitle: "Hay una actualización del sistema disponible.",
      versionLabel: "Versión: {{version}}",
      instruction: 'Haz clic en "Actualizar ahora" para cargar la nueva versión.',
      buttons: {
        later: "Más tarde",
        updateNow: "Actualizar ahora",
      },
    },
    settings: {
      tabs: {
        sla: "SLA",
        schedules: "Horarios",
        companies: "Empresas",
        modules: "Módulos",
        planModules: "Plan-Módulos",
        companyModules: "Módulos Empresa",
        aiTokens: "Tokens IA",
        whitelabel: "Whitelabel",
      },
      settings: {
        customMessages: {
          transferMessageDefault:
            `Su atención fue transferida al sector \${queue.name}. Por favor, espere...`,
        },
        options: {
          text: "Texto",
        },
      },
      whitelabel: {
        fields: {
          primaryColorLight: "Color primario (modo claro)",
          primaryColorDark: "Color primario (modo oscuro)",
          systemName: "Nombre del sistema",
          logoLight: "Logotipo claro",
          logoDark: "Logotipo oscuro",
          favicon: "Favicon",
        },
        errors: {
          uploadImage: "No se pudo subir la imagen.",
        },
      },
    },
    aiTokens: {
      title: "Tokens IA",
      packages: {
        form: {
          name: "Nombre",
          tokens: "Tokens",
          price: "Precio",
          active: "Activo",
        },
        table: {
          name: "Nombre",
          tokens: "Tokens",
          price: "Precio",
          active: "Activo",
        },
        buttons: {
          clear: "Limpiar",
          save: "Guardar",
          deactivate: "Desactivar",
          assignCredits: "Asignar créditos",
        },
        credit: {
          company: "Empresa",
          package: "Paquete IA",
        },
        confirm: {
          deactivateTitle: "Desactivar paquete",
          deactivateMessage: "¿Deseas desactivar este paquete de IA?",
        },
        toasts: {
          companiesLoadError: "No se pudieron cargar empresas.",
          packagesLoadError: "No fue posible cargar paquetes.",
          packageSaved: "Paquete guardado.",
          packageSaveError: "No fue posible guardar el paquete.",
          packageDeactivated: "Paquete desactivado.",
          packageDeactivateError: "No fue posible desactivar el paquete.",
          selectCompanyAndPackage: "Selecciona empresa y paquete.",
          creditsAssigned: "Créditos IA asignados.",
          creditsAssignError: "No se pudieron asignar créditos.",
        },
      },
    },
    leads: {
      title: "Gestión de Leads",
      subtitle: "Administra tus oportunidades de venta",
      buttons: {
        refresh: "Actualizar",
        new: "Nuevo Lead",
        cancel: "Cancelar",
        create: "Crear",
        update: "Actualizar",
      },
      stats: {
        total: "Total Leads",
        new: "Nuevos",
        qualified: "Calificados",
        contacted: "Contactados",
      },
      filters: {
        searchPlaceholder: "Buscar leads...",
        status: "Estado",
        source: "Fuente",
        all: "Todos",
        allFeminine: "Todas",
      },
      table: {
        name: "Nombre",
        contact: "Contacto",
        status: "Estado",
        source: "Fuente",
        score: "Score",
        date: "Fecha",
        actions: "Acciones",
        empty: "No hay leads para mostrar",
      },
      pagination: {
        rowsPerPage: "Filas por página",
        displayedRows: "{{from}}-{{to}} de {{count}}",
        moreThan: "más de {{to}}",
      },
      dialog: {
        addTitle: "Nuevo Lead",
        editTitle: "Editar Lead",
      },
      form: {
        name: "Nombre",
        nameRequired: "El nombre es requerido",
        email: "Email",
        phone: "Teléfono",
        phonePlaceholder: "+51987654321",
        status: "Estado",
        source: "Fuente",
        score: "Score (0-100)",
        notes: "Notas",
      },
      confirm: {
        delete: "¿Estás seguro de eliminar este lead?",
      },
      status: {
        new: "Nuevo",
        contacted: "Contactado",
        qualified: "Calificado",
        converted: "Convertido",
        lost: "Perdido",
      },
      sources: {
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        website: "Web",
        referral: "Referido",
        cold_call: "Llamada",
        email: "Email",
        other: "Otro",
      },
      contactActions: {
        whatsapp: "WhatsApp",
        call: "Llamar",
        email: "Email",
      },
      toasts: {
        loadError: "Error al cargar leads.",
        saveError: "Error al guardar lead.",
        deleteError: "Error al eliminar lead.",
        updated: "Lead actualizado exitosamente.",
        created: "Lead creado exitosamente.",
        deleted: "Lead eliminado exitosamente.",
      },
    },
    abTesting: {
      title: "A/B Testing IA",
      subtitle: "Optimiza las respuestas de IA con experimentos controlados",
      actions: {
        refresh: "Actualizar",
      },
      errors: {
        loadData: "Error al cargar los datos de A/B Testing",
      },
      stats: {
        totalExperiments: "Total Experimentos",
        activeLabel: "{{count}} activos",
        totalImpressions: "Impresiones Totales",
        conversions: "Conversiones",
        conversionRate: "Tasa de Conversión",
      },
      table: {
        title: "Experimentos",
        idLabel: "ID: {{id}}",
        headers: {
          experiment: "Experimento",
          description: "Descripción",
          variants: "Variantes",
          impressions: "Impresiones",
          status: "Estado",
          actions: "Acciones",
        },
        status: {
          active: "Activo",
          stopped: "Detenido",
        },
        tooltips: {
          viewDetails: "Ver detalles",
          stopExperiment: "Detener experimento",
        },
      },
      dialog: {
        progressTitle: "Progreso del Experimento",
        samples: "{{count}} muestras",
        goal: "Meta: {{count}}",
        significant: "El experimento ha alcanzado significancia estadística",
        winnerTitle: "Ganador Actual: {{name}}",
        score: "Score: {{score}}",
        variantsTitle: "Variantes",
        variantsHeaders: {
          variant: "Variante",
          impressions: "Impresiones",
          conversions: "Conversiones",
          conversionRate: "Tasa Conv.",
          satisfaction: "Satisfacción",
          escalations: "Escalaciones",
        },
        control: "Control",
        actions: {
          close: "Cerrar",
          stop: "Detener Experimento",
        },
      },
    },
    registerClient: {
      title: "Registrar Nuevo Cliente",
      subtitle: "Completa la información para dar de alta un nuevo cliente",
      steps: {
        company: "Datos de la Empresa",
        contact: "Persona de Contacto",
        plan: "Plan y Servicios",
      },
      industries: {
        retail: "Retail",
        restaurant: "Restaurante",
        healthcare: "Salud",
        education: "Educación",
        technology: "Tecnología",
        services: "Servicios",
        ecommerce: "E-commerce",
        realEstate: "Inmobiliaria",
        other: "Otro",
      },
      company: {
        title: "Información de la Empresa",
        fields: {
          name: "Nombre de la Empresa",
          industry: "Industria",
          email: "Email de la Empresa",
          phone: "Teléfono de la Empresa",
          address: "Dirección",
          website: "Sitio Web",
        },
      },
      contact: {
        title: "Persona de Contacto",
        fields: {
          name: "Nombre Completo",
          position: "Cargo/Posición",
          email: "Email del Contacto",
          phone: "Teléfono del Contacto",
        },
      },
      plan: {
        title: "Seleccionar Plan",
        includes: {
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
        },
        perMonth: "/mes",
        billingCycle: "Ciclo de Facturación",
        billingMonthly: "Mensual",
        billingAnnual: "Anual (2 meses gratis)",
      },
      addons: {
        title: "Servicios Adicionales",
        pricePerMonth: `+\${{amount}}/mes`,
      },
      notes: {
        title: "Notas Adicionales",
        placeholder: "Agrega cualquier nota o comentario sobre este cliente...",
      },
      total: {
        label: "Total a Facturar",
        perYear: "/año",
        perMonth: "/mes",
      },
      buttons: {
        back: "Atrás",
        next: "Siguiente",
        submit: "Registrar Cliente",
      },
      toasts: {
        stepCompanyRequired: "Por favor completa todos los campos obligatorios.",
        stepContactRequired: "Por favor completa los datos del contacto.",
        success: "¡Cliente registrado exitosamente!",
        error: "Error al registrar cliente.",
      },
    },
    subscription: {
      free: "Gratis",
      license: {
        noExpiration: "Sin vencimiento",
        expiresToday: "Tu licencia vence hoy",
        expiredOn: "Licencia vencida el {{date}}",
        expiresIn: "Tu licencia vence en {{days}} {{dayWord}} ({{date}})",
        day: "día",
        days: "días",
      },
      fields: {
        dueDate: "Vencimiento",
        billingEmail: "Email de cobro",
        currentPlan: "Plan actual",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Filas",
        price: "Precio",
      },
      upgrade: {
        title: "Mejorar plan",
        button: "Actualizar plan",
        updating: "Actualizando...",
      },
      contact: {
        button: "Suscribirse ahora",
      },
      toasts: {
        planUpdated: "Plan actualizado correctamente",
      },
    },
    configApis: {
      title: "Conectar APIs",
      channels: {
        whatsappTitle: "WhatsApp Cloud API",
        facebookTitle: "Facebook Messenger",
        instagramTitle: "Instagram Messaging",
      },
      summary: {
        title: "Resumen",
        activeConnections: "Conexiones activas (Meta APIs):",
        planLimit: "Límite de tu membresía:",
        limitReached: "Límite alcanzado: para agregar más conexiones, mejora tu plan.",
      },
      channelCard: {
        activeConnections: "Conexiones activas:",
        configure: "Configurar",
        upgradePlan: "Mejorar plan",
      },
      actions: {
        refresh: "Actualizar",
      },
      subtitles: {
        whatsapp:
          "Identificador de número de teléfono + Token Permanente (Admin token) + URL de devolución de llamada",
        facebook: "Página + Access Token + Webhook",
        instagram: "Cuenta + Access Token + Webhook",
      },
      empty: {
        title: "Conectar APIs",
        subtitle: "Tu plan no tiene habilitados los módulos de Meta.",
        button: "Ver planes",
      },
    },
    whatsappApi: {
      title: "Conectar WhatsApp API",
      actions: {
        copyWebhook: "Copiar webhook",
        newConnection: "Nueva conexión",
        copy: "Copiar",
        save: "Guardar",
        saving: "Guardando...",
        rotating: "Rotando...",
        rotateVerifyToken: "Rotar Verify Token",
        rotateSecrets: "Rotar WebhookKey + Verify Token",
      },
      toasts: {
        copied: "Copiado",
        connectionUpdated: "Conexión actualizada.",
        connectionCreated: "Conexión creada.",
        connectionDeleted: "Conexión eliminada.",
        connectionSavedButMetaSubscribeFailed:
          "Conexión guardada, pero no se pudo completar la suscripción automática en Meta. {{reason}}",
        metaSubscribeOk: "Suscripción en Meta completada.",
        metaSubscribeFailed: "No se pudo completar la suscripción en Meta. {{reason}}",
        verifyTokenRotated: "Verify Token actualizado. Actualízalo en Meta y vuelve a verificar.",
        secretsRotated: "WebhookKey y Verify Token actualizados. Actualízalos en Meta y vuelve a verificar.",
      },
      modal: {
        editTitle: "Editar conexión de WhatsApp API",
        newTitle: "Nueva conexión de WhatsApp API",
      },
      form: {
        name: "Nombre",
        phoneNumberId: "Identificador de número de teléfono",
        phoneNumberIdHelper: "Ej: 123456789012345",
        wabaIdOptional: "Identificador de la cuenta de WhatsApp Business",
        accessToken: "Token Permanente (Admin token)",
        accessTokenEditHint: "Token Permanente (Admin token) - dejar vacío para no cambiar",
        useAsDefault: "Usar como predeterminada",
        cancel: "Cancelar",
      },
      validation: {
        nameMin: "El nombre debe tener al menos 2 caracteres",
        nameRequired: "El nombre es obligatorio",
        phoneNumberIdRequired: "El identificador de número de teléfono es obligatorio",
        wabaIdRequired: "El identificador de la cuenta de WhatsApp Business es obligatorio",
        accessTokenRequired: "El Token Permanente (Admin token) es obligatorio",
      },
      errors: {
        missingWabaId: "Falta el WABA ID. Agrégalo y vuelve a guardar para suscribir automáticamente en Meta.",
        missingAccessToken: "Falta el Access Token. Agrégalo y vuelve a guardar.",
        appNotSubscribed:
          "La app no aparece suscrita al WABA. Revisa permisos del token o suscríbelo manualmente en Meta.",
      },
      confirm: {
        deleteTitle: "Eliminar conexión",
        deleteMessage: "¿Eliminar la conexión {{name}}?",
      },
      rotateVerifyToken: {
        title: "Rotar Verify Token",
        message:
          "Vas a generar un nuevo Verify Token. El token anterior dejará de usarse. Luego debes actualizarlo en Meta Developer y re-verificar el webhook. ¿Continuar?",
      },
      rotateSecrets: {
        title: "Rotar WebhookKey + Verify Token",
        message:
          "Vas a generar un nuevo WebhookKey y un nuevo Verify Token. La URL del webhook cambiará y el token anterior dejará de usarse. Luego debes actualizar ambos en Meta Developer y re-verificar el webhook. ¿Continuar?",
      },
      table: {
        name: "Nombre",
        phoneNumberId: "Identificador de número de teléfono",
        wabaId: "Identificador de la cuenta de WhatsApp Business",
        meta: "Meta",
        default: "Predeterminada",
        webhook: "Webhook",
        actions: "Acciones",
      },
      values: {
        yes: "Sí",
        no: "No",
        verified: "Verificado",
        pending: "Pendiente",
        metaSubscribed: "Suscrito",
        metaError: "Error",
        metaUnknown: "Pendiente",
      },
      empty: "No hay conexiones. Crea una para empezar.",
      helper: {
        title: "Datos para Meta (únicos por cliente)",
        step1: "En Meta Developer, configura el webhook usando:",
        webhookUrl: "URL de devolución de llamada:",
        verifyToken: "Token de verificación:",
        step2: "Suscríbete al evento messages. Al guardar/activar, Klorum intenta suscribir tu app al WABA automáticamente.",
        step3: "Cuando Meta verifique, verás el estado Verificado.",
        step4: "Los mensajes entrantes llegarán a WhatsApp (Tickets) y podrás responder desde el chat.",
        user: "Usuario:",
      },
      tooltips: {
        retryMetaSubscribe: "Reintentar suscripción en Meta",
        edit: "Editar",
        delete: "Eliminar",
      },
    },
    dashboard: {
      errors: {
        loadData: "No fue posible cargar los datos del dashboard.",
      },
      filters: {
        title: "Filtros",
      },
      export: {
        agentsSheet: "ReporteDeAgentes",
        agentsFile: "reporte-de-agentes.xlsx",
        error: "Error al exportar a Excel.",
      },
      charts: {
        errors: {
          loadTicketsInfo: "No se pudo cargar la información de tickets.",
        },
        perHour: {
          title: "Atenciones por hora",
        },
        ticketsLabel: "Tickets",
        empty: {
          noData: "No hay datos para mostrar.",
          noDataForPeriod: "No hay datos para el período seleccionado.",
        },
      },
      membership: {
        title: "Mi membresía",
        details: "Ver detalles",
        availablePlansTitle: "Membresías disponibles",
        availablePlansSubtitle:
          "Tu plan actual se aplica automáticamente a los límites y módulos del sistema.",
        loadingPlans: "Cargando planes...",
        noPublicPlans: "No hay planes públicos disponibles en este momento.",
        planLabel: "Plan",
        activeBadge: "ACTIVO",
        channelsLabel: "Canales",
        buttons: {
          current: "Plan actual",
          upgrade: "Mejorar",
          view: "Ver",
        },
        license: {
          noExpiration: "Sin vencimiento",
          expiresToday: "Vence hoy",
          expiredOn: "Vencida el {{date}}",
          expiresOn: "Vence el {{date}}",
        },
      },
      channels: {
        titleOverline: "Canales",
        title: "Estado de canales",
        subtitle: "Conexiones activas y última sincronización por canal.",
        configureApis: "Configurar APIs",
        loading: "Cargando estado de canales...",
        empty: "No hay información de canales disponible.",
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          error: "Error",
        },
        errors: {
          load: "No se pudo cargar el estado de canales.",
        },
      },
      analytics: {
        title: "Analíticas (mes actual)",
        period: "Período: {{from}} a {{to}}",
        chips: {
          unavailable: "No disponible",
          realData: "Datos reales",
        },
        disabledMessage:
          "Tu plan actual no incluye el módulo de Analíticas. Mejora tu plan para ver estas métricas.",
        loading: "Cargando analíticas...",
        metrics: {
          monthlyRevenue: "Ingresos (mes)",
          totalRevenue: "Ingresos (total)",
          conversion: "Conversión",
          firstResponse: "1ra respuesta (min)",
          activeUsers: "Usuarios activos",
          newLeads: "Nuevos leads",
          closings: "Cierres",
        },
        activity: {
          title: "Actividad reciente",
          loading: "Cargando actividad...",
          empty: "No hay actividad reciente disponible.",
          fallbackTitle: "Actividad",
        },
        errors: {
          metrics: "No se pudieron cargar las métricas de empresa.",
          activity: "No se pudo cargar la actividad reciente.",
        },
      },
    },
    flowBuilder: {
      defaultFlowName: "Nuevo Flujo",
      copySuffix: "(Copia)",
      list: {
        title: "Flujos de conversación",
        addFlow: "Agregar flujo",
        searchPlaceholder: "Buscar flujo...",
        empty: "Aún no tienes flujos.",
        noMatches: "No hay resultados para tu búsqueda.",
        status: {
          active: "Activo",
          inactive: "Desactivado",
        },
        menu: {
          editName: "Editar nombre",
          editFlow: "Editar flujo",
          duplicate: "Duplicar",
          delete: "Eliminar",
        },
        confirm: {
          deleteTitle: "¿Eliminar el flujo {{name}}?",
          deleteBody:
            "¿Estás seguro de eliminar este flujo? Todas las integraciones relacionadas se perderán.",
          duplicateTitle: "¿Duplicar el flujo {{name}}?",
          duplicateBody: "¿Estás seguro de duplicar este flujo?",
        },
        toasts: {
          deleted: "Flujo eliminado con éxito",
          duplicated: "Flujo duplicado con éxito",
        },
      },
      modals: {
        question: {
          titleCreate: "Agregar pregunta al flujo",
          titleEdit: "Editar pregunta",
          fields: {
            message: "Mensaje",
            answerKey: "Guardar respuesta como",
          },
        },
        text: {
          titleCreate: "Agregar mensaje al flujo",
          titleEdit: "Editar mensaje",
          fields: {
            message: "Mensaje",
          },
        },
        image: {
          titleCreate: "Agregar imagen al flujo",
          titleEdit: "Editar imagen",
          buttons: {
            upload: "Subir imagen",
          },
          errors: {
            fileTooLarge: "El archivo es demasiado grande. Máximo 2MB.",
          },
          toasts: {
            created: "Imagen agregada con éxito.",
            updated: "Imagen actualizada con éxito.",
          },
        },
        audio: {
          titleCreate: "Agregar audio al flujo",
          titleEdit: "Editar audio",
          buttons: {
            upload: "Subir audio",
          },
          fields: {
            record: "Enviar como audio grabado en el momento",
          },
          fallback: "Tu navegador no soporta HTML5",
          errors: {
            fileTooLarge: "El archivo es demasiado grande. Máximo 5MB.",
          },
          toasts: {
            created: "Audio agregado con éxito.",
            updated: "Audio actualizado con éxito.",
          },
        },
        video: {
          titleCreate: "Agregar video al flujo",
          titleEdit: "Editar video",
          buttons: {
            upload: "Subir video",
          },
          warnings: {
            onlyMp4: "ATENCIÓN: solo videos en MP4.",
          },
          fallback: "Tu navegador no soporta HTML5",
          errors: {
            fileTooLarge: "El archivo es demasiado grande. Máximo 20MB.",
          },
          toasts: {
            created: "Video agregado con éxito.",
            updated: "Video actualizado con éxito.",
          },
        },
        openai: {
          titleCreate: "Agregar OpenAI/Gemini al flujo",
          titleEdit: "Editar OpenAI/Gemini",
          voice: {
            text: "Texto",
          },
        },
        interval: {
          titleCreate: "Agregar intervalo al flujo",
          titleEdit: "Editar intervalo",
          fields: {
            seconds: "Tiempo en segundos",
          },
          errors: {
            required: "Agrega un valor de intervalo.",
            maxSeconds: "Tiempo máximo: 120 segundos.",
          },
        },
        condition: {
          titleCreate: "Agregar condición al flujo",
          titleEdit: "Editar condición",
          fields: {
            key: "Campo de condición (escribe solo 1 clave)",
            rule: "Regla de validación",
            value: "Valor de la condición a analizar",
          },
        },
        ticket: {
          titleCreate: "Agregar cola al flujo",
          titleEdit: "Editar cola",
          placeholders: {
            selectQueue: "Selecciona una cola",
          },
          errors: {
            requiredQueue: "Selecciona una cola.",
          },
        },
        menu: {
          titleCreate: "Agregar menú al flujo",
          titleEdit: "Editar menú",
          fields: {
            message: "Mensaje de explicación del menú",
          },
          buttons: {
            addOption: "Agregar opción",
          },
          optionPrompt: "Escribe {{number}}",
          placeholders: {
            option: "Escribe opción",
          },
        },
        randomizer: {
          titleCreate: "Agregar randomizador al flujo",
          titleEdit: "Editar randomizador",
          aria: {
            slider: "Porcentaje",
          },
          errors: {
            required: "Agrega un porcentaje.",
            maxPercent: "Porcentaje máximo: 100.",
          },
        },
        typebot: {
          titleCreate: "Agregar Typebot al flujo",
          titleEdit: "Editar Typebot",
        },
        singleBlock: {
          titleCreate: "Agregar contenido al flujo",
          titleEdit: "Editar contenido",
          elements: {
            text: "Texto",
            interval: "Intervalo",
            image: "Imagen",
            audio: "Audio",
            video: "Video",
            document: "Documento",
          },
          buttons: {
            uploadImage: "Subir imagen",
            uploadAudio: "Subir audio",
            uploadVideo: "Subir video",
            uploadDocument: "Subir documento",
          },
          fields: {
            message: "Mensaje",
            seconds: "Tiempo en segundos",
            recordAudio: "Enviar como audio grabado en el momento",
            variables: "Variables",
          },
          file: {
            noFileSelected: "Ningún archivo seleccionado",
          },
          loading: {
            uploading: "Subiendo archivos y creando el contenido...",
          },
          toasts: {
            saved: "Contenido guardado con éxito.",
          },
          errors: {
            messageEmpty: "El campo de mensaje está vacío.",
            intervalInvalid: "El intervalo no puede ser 0 ni mayor que 120.",
            fileTooLarge: "El archivo es demasiado grande. Máximo {{maxMb}}MB.",
            pendingUploads:
              "Elimina las tarjetas vacías o sube los archivos pendientes.",
          },
        },
      },
    },
    flowBuilderCanvas: {
      back: "Volver",
      title: "FlowBuilder Canvas",
      testFlow: "Probar Flujo",
      save: "Guardar",
      alerts: {
        saved: "Flujo guardado exitosamente",
        saveError: "Error guardando flujo",
        testSoon: "Función de prueba próximamente",
        confirmDeleteNode: "¿Estás seguro de eliminar este nodo?",
      },
      nodeConfig: {
        sections: {
          basic: "Configuración básica",
          advanced: "Opciones avanzadas",
        },
        fields: {
          nodeName: "Nombre del nodo",
          model: "Modelo",
          systemPrompt: "Prompt del sistema",
          temperatureLabel: "Temperatura: {{value}}",
          maxTokens: "Máx. tokens",
          intents: "Intenciones posibles (separadas por coma)",
          confidenceLabel: "Umbral de confianza: {{value}}",
          webhookUrl: "URL del webhook",
          httpMethod: "Método HTTP",
          requireAuth: "Requiere autenticación",
          secretKey: "Clave secreta",
          scheduleType: "Tipo de programación",
          cronExpression: "Expresión cron",
          messageTemplate: "Plantilla de mensaje",
          includeMedia: "Incluir media",
          mediaUrl: "URL de media",
          emailSubject: "Asunto",
          emailBody: "Cuerpo del correo (HTML)",
          fromEmail: "Email remitente",
          conditionType: "Tipo de condición",
          fieldToCheck: "Campo a validar",
          operator: "Operador",
          valueToCompare: "Valor a comparar",
          jsExpression: "Expresión JavaScript",
          continueOnError: "Continuar si hay error",
          retryOnFailure: "Reintentar si falla",
        },
        placeholders: {
          nodeName: "Ingresa el nombre del nodo...",
          systemPrompt: "Eres un asistente útil...",
          intents: "compra, consulta, reclamo...",
          secretKey: "Ingresa la clave secreta...",
          cronExpression: "0 9 * * * (Todos los días a las 9:00)",
          messageTemplate: "Hola {{name}}, gracias por contactarnos...",
          emailSubject: "Asunto del correo...",
          emailBody: "<h1>Hola {{name}}</h1><p>...</p>",
          fieldToCheck: "Ej: user.age, message.text",
          valueToCompare: "Ingresa un valor...",
        },
        defaults: {
          intents: "compra, consulta, reclamo, cancelación",
        },
        options: {
          scheduleType: {
            cron: "Expresión cron",
            interval: "Intervalo",
            specific: "Fecha/hora específica",
          },
          intervalUnit: {
            minutes: "Minutos",
            hours: "Horas",
            days: "Días",
          },
          conditionType: {
            simple: "Simple (A == B)",
            multiple: "Múltiple (AND/OR)",
            expression: "Expresión JavaScript",
          },
          operator: {
            equals: "Igual (==)",
            notEquals: "Distinto (!=)",
            greater: "Mayor que (>)",
            less: "Menor que (<)",
            contains: "Contiene",
            startsWith: "Empieza con",
            endsWith: "Termina con",
          },
        },
        helpers: {
          temperature:
            "Valores altos = más creativo. Valores bajos = más determinístico.",
          cronExpression:
            'Ejemplo: "0 9 * * *" ejecuta todos los días a las 9:00',
          variables: "Usa {{variable}} para variables dinámicas",
        },
        empty: {
          noSpecificConfig:
            "No hay configuración específica para este tipo de nodo.",
          connectHelp: "Arrastra conexiones para vincular con otros nodos.",
        },
        confirmDelete: "¿Eliminar este nodo?",
      },
    },
    kanban: {
      ticketLabel: "Ticket n.º {{id}}",
      filters: {
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
      },
      toasts: {
        tagRemoved: "¡Etiqueta removida del ticket!",
        tagAdded: "¡Etiqueta agregada al ticket!",
      },
      actions: {
        search: "Buscar",
        viewTicket: "Ver Ticket",
        addColumns: "+ Agregar columnas",
      },
    },
    moments: {
      title: "Panel de Atendimientos",
    },
    todoList: {
      newTask: "Nueva tarea",
      add: "Agregar",
      save: "Guardar",
    },
    facebookInstagram: {
      titleAll: "Facebook e Instagram",
      subtitle: "Gestiona tus integraciones con Meta",
      actions: {
        newConnection: "Nueva conexión",
        connectFacebook: "Conectar Facebook",
        connectInstagram: "Conectar Instagram",
      },
      meta: {
        title: "Datos para Meta (únicos por cliente)",
        step1: "1. En Meta Developer, configura el producto Webhooks usando:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        copy: "Copiar",
        step2: "2. Suscríbete a los objetos/campos:",
        objectWord: "objeto",
        fieldsWord: "campos",
        step3:
          "3. Cuando Meta verifique, verás el estado guardado en tu App. Luego, los mensajes entrantes llegarán a Tickets y podrás responder desde el chat.",
        user: "Usuario:",
      },
      filters: {
        title: "Filtros",
        searchLabel: "Buscar (nombre o ID)",
        category: "Categoría",
        from: "Desde",
        to: "Hasta",
        inactiveShort: "Inact.",
      },
      table: {
        title: "Conexiones",
        empty: "No hay conexiones para mostrar.",
        headers: {
          platform: "Plataforma",
          name: "Nombre",
          id: "ID",
          category: "Categoría",
          status: "Estado",
          webhook: "Webhook",
          created: "Creado",
          active: "Activo",
          actions: "Acciones",
        },
      },
      labels: {
        pageId: "ID de Página",
        instagramAccountId: "ID de cuenta de Instagram",
      },
      status: {
        connected: "Conectada",
        disconnected: "Desconectada",
        error: "Error",
        verified: "Verificado",
        pending: "Pendiente",
      },
      tooltips: {
        edit: "Editar",
        disconnect: "Desconectar",
      },
      dialog: {
        newTitle: "Nueva conexión {{platform}}",
        editTitle: "Editar conexión {{platform}}",
        info: "Esta pantalla crea una conexión API manual. Debes pegar el Access Token y el ID correspondiente.",
        fields: {
          name: "Nombre",
          categoryOptional: "Categoría (opcional)",
          accessToken: "Access Token",
          accessTokenEditHint: "Access Token (dejar vacío para no cambiar)",
        },
        saving: "Guardando...",
      },
      validations: {
        selectValidChannel: "Selecciona un canal válido",
        nameRequired: "El nombre es obligatorio",
        idRequired: "{{idLabel}} es obligatorio",
        accessTokenRequired: "Access Token es obligatorio",
      },
      confirm: {
        disconnect: "¿Estás seguro de desconectar esta cuenta?",
      },
      toasts: {
        copied: "Copiado",
        accountActivated: "Cuenta activada exitosamente",
        accountDeactivated: "Cuenta desactivada exitosamente",
        statusToggleError: "Error al cambiar estado de cuenta",
        disconnectSuccess: "¡Cuenta desconectada exitosamente!",
        disconnectError: "Error al desconectar cuenta",
        connectionUpdated: "Conexión actualizada",
        connectionCreated: "Conexión creada",
        saveError: "Error al guardar conexión",
      },
    },
    salesDashboard: {
      title: "Dashboard de Ventas",
      subtitle: "Bienvenido, {{name}} - Aquí está tu rendimiento",
      errors: {
        load: "Error al cargar datos de ventas",
      },
      metrics: {
        totalLeads: "Total leads",
        convertedClients: "Clientes convertidos",
        totalRevenue: "Ingresos totales",
        ranking: "Ranking vendedores",
        thisMonth: "Este mes",
        cumulative: "Acumulado",
        conversionSubtitle: "{{rate}}% conversión",
        rankingSubtitle: "Top 3 del equipo",
      },
      goal: {
        title: "Meta mensual",
        progress: "Progreso: {{percent}}%",
        reached: "¡Meta alcanzada! 🎉",
        remaining: "Faltan {{amount}} para alcanzar la meta",
      },
      topProduct: {
        title: "Producto más vendido",
        salesThisMonth: "{{count}} ventas este mes",
        conversionRate: "Tasa de conversión",
        avgValue: "Valor promedio",
      },
      quickActions: {
        title: "Acciones rápidas",
        viewLeads: "Ver mis leads",
        registerClient: "Registrar cliente",
        commissions: "Mis comisiones",
        aiSales: "IA para ventas",
      },
    },
    teamDashboard: {
      title: "Dashboard del equipo",
      subtitle: "Supervisa el rendimiento de tu equipo de ventas",
      errors: {
        load: "Error al cargar datos del equipo",
      },
      metrics: {
        teamMembers: "Miembros del equipo",
        activeMembersSubtitle: "{{count}} activos",
        teamRevenue: "Ingresos del equipo",
        thisMonth: "Este mes",
        topSeller: "Mejor vendedor",
        topSellerSubtitle: "Top performer",
        teamGoal: "Meta del equipo",
      },
      goal: {
        title: "Progreso de meta del equipo",
        completed: "{{percent}}% completado",
        reached: "🎉 ¡Meta del equipo alcanzada!",
        remaining: "Faltan {{amount}} para la meta mensual",
      },
      table: {
        title: "Rendimiento individual",
        headers: {
          seller: "Vendedor",
          leads: "Leads",
          conversions: "Conversiones",
          revenue: "Ingresos",
          goal: "Meta",
          performance: "Performance",
          status: "Estado",
          actions: "Acciones",
        },
      },
      status: {
        active: "Activo",
        inactive: "Inactivo",
      },
      tooltips: {
        viewDetails: "Ver detalles",
        call: "Llamar",
        email: "Email",
      },
      summary: {
        totalLeads: "Total leads del equipo",
        totalConversions: "Total conversiones",
        conversionRate: "Tasa de conversión",
      },
    },
    commission: {
      title: "Mis comisiones",
      subtitle: "Gestiona y visualiza tus ganancias",
      errors: {
        load: "Error al cargar datos de comisiones",
      },
      defaults: {
        client: "Cliente",
        plan: "Plan",
      },
      period: {
        label: "Período",
        current: "Mes actual",
        last: "Mes anterior",
        quarter: "Último trimestre",
        year: "Este año",
        selected: "Período seleccionado",
      },
      metrics: {
        totalEarned: "Total ganado",
        currentMonth: "Mes actual",
        pendingPayout: "Pendiente de pago",
        paid: "Ya pagado",
        cumulative: "Acumulado",
        rateSubtitle: "Tasa: {{rate}}%",
        toProcess: "Por procesar",
        processed: "Procesado",
      },
      goal: {
        title: "Meta de comisiones - {{period}}",
        progress: "Progreso: {{percent}}%",
        reached: "🎉 ¡Meta alcanzada! Excelente trabajo",
        remaining: "Faltan {{amount}} para alcanzar tu meta mensual",
        rateLabel: "Tasa de comisión",
      },
      table: {
        title: "Historial de comisiones",
        headers: {
          client: "Cliente",
          plan: "Plan",
          saleValue: "Valor venta",
          commission: "Comisión",
          status: "Estado",
          date: "Fecha",
        },
      },
      status: {
        paid: "Pagado",
        pending: "Pendiente",
      },
      summary: {
        totalPaid: "Total comisiones pagadas",
        totalPending: "Total comisiones pendientes",
      },
    },
    checkout: {
      steps: {
        data: "Datos",
        customize: "Personalizar",
        review: "Revisar",
      },
      gateways: {
        steps: {
          selectPlan: "Seleccionar plan",
          paymentMethod: "Método de pago",
          confirm: "Confirmar",
        },
        errors: {
          loadPlans: "Error al cargar los planes.",
          missingCustomerInfo: "Por favor completa tu nombre y correo.",
          initMercadoPago: "No se pudo iniciar el pago con MercadoPago.",
          processPayment: "Error al procesar el pago.",
        },
        title: "Mejora tu plan",
        subtitle: "Elige el plan perfecto para tu negocio",
        billing: {
          monthly: "Mensual",
          yearly: "Anual",
          freeMonths: "{{count}} meses gratis",
        },
        plan: {
          mostPopular: "Más popular",
          perMonth: "/mes",
          perYear: "/año",
          savings: "Ahorras {{amount}}",
          limits: {
            messagesPerMonth: "{{value}} mensajes/mes",
            channels: "{{value}} canales",
            users: "{{value}} usuarios",
          },
        },
        billingInfo: {
          title: "Información de facturación",
          fullName: "Nombre completo",
          email: "Correo electrónico",
        },
        summary: {
          title: "Resumen",
          plan: "Plan {{plan}}",
          cycle: "Ciclo: {{cycle}}",
        },
        paymentMethod: {
          title: "Método de pago",
          mercadoPago: "MercadoPago (Perú)",
          paypal: "PayPal (Internacional)",
        },
        buttons: {
          payWithMercadoPago: "Pagar con MercadoPago",
          payWithPayPal: "Pagar con PayPal",
        },
        securityHint: "Pago seguro. Puedes cancelar cuando quieras.",
      },
      header: "¡Falta poco!",
      notFound: "No encontrado.",
      buttons: {
        pay: "Pagar",
        select: "Seleccionar",
        increase: "Aumentar",
        decrease: "Disminuir",
      },
      paymentHint: "Al realizar el pago, actualiza la página.",
      toasts: {
        subscriptionCreatedWaiting:
          "Suscripción creada correctamente. Esperando la confirmación del pago.",
      },
      form: {
        fullName: {
          label: "Nombre completo*",
          required: "El nombre completo es obligatorio",
        },
        lastName: {
          label: "Apellido*",
          required: "El apellido es obligatorio",
        },
        address: {
          label: "Dirección*",
          required: "La dirección es obligatoria",
        },
        city: {
          label: "Ciudad*",
          required: "La ciudad es obligatoria",
        },
        state: {
          label: "Estado/Provincia*",
          required: "El estado/provincia es obligatorio",
        },
        document: {
          label: "CPF/CNPJ*",
          required: "El documento es obligatorio",
          invalid: "Formato de documento inválido",
        },
        country: {
          label: "País*",
          required: "El país es obligatorio",
        },
        useAddressForPaymentDetails: {
          label: "Usar esta dirección para los datos de pago",
        },
        nameOnCard: {
          label: "Nombre en la tarjeta*",
          required: "El nombre en la tarjeta es obligatorio",
        },
        cardNumber: {
          label: "Número de tarjeta*",
          required: "El número de tarjeta es obligatorio",
          invalid: "El número de tarjeta no es válido (p. ej., 4111111111111)",
        },
        expiryDate: {
          label: "Fecha de vencimiento*",
          required: "La fecha de vencimiento es obligatoria",
          invalid: "La fecha de vencimiento no es válida",
        },
        cvv: {
          label: "CVV*",
          required: "El CVV es obligatorio",
          invalid: "El CVV no es válido (p. ej., 357)",
        },
      },
      plan: {
        perMonth: "/mes",
        users: "{{count}} Usuarios",
        connections: "{{count}} Conexiones",
        queues: "{{count}} Filas",
      },
      review: {
        title: "Resumen de la suscripción",
        planDetails: {
          title: "Detalles del plan",
          users: "Usuarios: {{count}}",
          connections: "Conexiones: {{count}}",
          queues: "Filas: {{count}}",
          billing: "Facturación: Mensual",
        },
        paymentInfo: {
          title: "Información de pago",
          document: "CPF/CNPJ",
          total: "Total",
        },
      },
      success: {
        total: "TOTAL",
        copyQrCode: "Copiar código QR",
        instructions:
          "Para finalizar, realiza el pago escaneando o pegando el código Pix de arriba.",
        licenseRenewed: "¡Tu licencia fue renovada hasta {{date}}!",
      },
    },
    modulesManager: {
      table: {
        key: "Clave",
        category: "Categoría",
        addon: "Complemento",
      },
      toasts: {
        loadError: "No fue posible cargar los módulos.",
        saved: "Módulo guardado.",
        saveError: "No fue posible guardar el módulo.",
        deactivated: "Módulo desactivado.",
        deactivateError: "No fue posible desactivar el módulo.",
      },
      confirm: {
        deactivateTitle: "Desactivar módulo",
        deactivateMessage: "¿Deseas desactivar este módulo?",
      },
    },
    flowImportModal: {
      title: "Importar flujo",
      instructions: "Selecciona un archivo .zip exportado por Flowbuilder.",
      noFile: "Ningún archivo seleccionado",
      buttons: {
        chooseFile: "Elegir archivo",
        import: "Importar",
      },
      toasts: {
        selectZip: "Selecciona un archivo .zip",
        success: "Flujo importado con éxito.",
        error: "Error al importar el flujo.",
      },
    },
    chatList: {
      confirm: {
        deleteTitle: "Eliminar conversación",
        deleteMessage: "Esta acción no se puede deshacer. ¿Confirmar?",
      },
    },
    planModulesManager: {
      form: {
        plan: "Plan",
      },
      table: {
        module: "Módulo",
        category: "Categoría",
        included: "Incluido",
      },
      buttons: {
        saveChanges: "Guardar cambios",
      },
      toasts: {
        plansLoadError: "No se pudieron cargar los planes.",
        modulesLoadError: "No se pudieron cargar los módulos del plan.",
        saved: "Módulos del plan actualizados.",
        saveError: "No se pudieron guardar los módulos del plan.",
      },
    },
    companyModulesManager: {
      table: {
        module: "Módulo",
        category: "Categoría",
        plan: "Plan",
        override: "Override",
        effective: "Efectivo",
      },
      override: {
        plan: "Usar plan",
        enable: "Habilitar",
        disable: "Deshabilitar",
      },
      buttons: {
        saveChanges: "Guardar cambios",
      },
      toasts: {
        companiesLoadError: "No se pudieron cargar empresas.",
        modulesLoadError: "No se pudieron cargar módulos de la empresa.",
        saved: "Módulos de empresa actualizados.",
        saveError: "No se pudieron actualizar módulos.",
      },
    },
    contactNotesDialog: {
      toasts: {
        added: "Observación agregada con éxito.",
        deleted: "Observación eliminada con éxito.",
      },
      confirm: {
        deleteTitle: "Eliminar registro",
        deleteMessage: "¿Deseas realmente eliminar este registro?",
      },
    },
    contacts: {
      menu: {
        importExport: "Importar / Exportar",
      },
      importPage: {
        title: "Importar contactos de archivo",
      },
      toasts: {
        batchDeleted: "Contactos seleccionados eliminados.",
        blocked: "Contacto bloqueado.",
        unblocked: "Contacto desbloqueado.",
      },
      confirmationModal: {
        blockTitle: "Bloquear {{name}}",
        unblockTitle: "Desbloquear {{name}}",
        chooseConnectionToImport:
          "Elige de qué conexión importar los contactos.",
        batchDeleteTitle: "Eliminar {{count}} contactos",
        batchDeleteMessage:
          "¿Deseas realmente eliminar los contactos seleccionados? Esta acción no se puede deshacer.",
      },
      buttons: {
        deleteSelected: "Eliminar seleccionados ({{count}})",
      },
      accessibility: {
        selectAll: "Seleccionar todos los contactos",
        selectContact: "Seleccionar contacto {{name}}",
      },
    },
    contactImport: {
      validateWhatsapp: "Validar contactos en WhatsApp",
      uploading: "Importando... espera",
      buttons: {
        importContacts: "Importar contactos",
      },
      fields: {
        name: "Nombre",
        number: "Número",
        email: "Email",
        tags: "Etiquetas",
      },
      errors: {
        missingNumberField: "Selecciona la columna para el campo \"Número\".",
        missingNameField: "Selecciona la columna para el campo \"Nombre\".",
        noContactsSelected: "Selecciona al menos un contacto para importar.",
        fieldAlreadySelected: "El campo {{field}} ya fue seleccionado.",
      },
      toasts: {
        success: "Contactos importados con éxito.",
        successWithErrors:
          "Importación completada con advertencias. Algunos contactos fueron ignorados.",
      },
      summary: {
        created: "{{count}} contactos creados",
        ignored:
          "{{count}} contactos ignorados (número inválido o no marcados para actualizar)",
      },
      file: {
        processing: "Procesando archivo...",
        invalid: "¡Archivo inválido!",
      },
      dropzone: {
        title: "Haz clic o arrastra un archivo",
        note:
          "* Importante: solo se aceptan archivos con extensiones: xls, xlsx, csv, txt",
      },
      alt: {
        upload: "Subir archivo",
      },
    },
    slaPolicies: {
      title: "SLA por canal",
      description:
        "Configura tiempos de primera respuesta, siguiente respuesta y resolución por canal.",
      fields: {
        firstResponseMinutes: "Primera respuesta (min)",
        nextResponseMinutes: "Siguiente respuesta (min)",
        resolutionMinutes: "Resolución (min)",
      },
      buttons: {
        save: "Guardar SLA",
      },
      toasts: {
        loadError: "Error al cargar SLA.",
        saved: "SLA actualizado.",
        saveError: "Error al guardar SLA.",
      },
    },
    ticketMessagesDialog: {
      errors: {
        exportTargetNotFound: "No se encontró el elemento para exportar.",
      },
      buttons: {
        exportPdf: "Exportar a PDF",
      },
    },
    reports: {
      buttons: {
        exportExcel: "Exportar a Excel",
      },
    },
    campaignPhraseModal: {
      title: {
        create: "Crear campaña por frase",
        edit: "Editar campaña por frase",
      },
      fields: {
        name: "Nombre",
        flow: "Flujo",
        phrase: "Frase",
      },
      placeholders: {
        flow: "Selecciona un flujo",
        connection: "Selecciona una conexión",
      },
      buttons: {
        createCampaign: "Crear campaña",
        saveCampaign: "Guardar campaña",
      },
      toasts: {
        created: "Campaña creada con éxito.",
        updated: "Campaña actualizada con éxito.",
      },
    },
    colorBoxModal: {
      title: "Seleccionar color",
    },
    editMessageModal: {
      title: "Editar mensaje",
      placeholders: {
        message: "Escribe el mensaje...",
      },
      aria: {
        messageInput: "Mensaje editado",
      },
    },
    flowDefault: {
      title: "Flujos predeterminados",
      confirm: {
        deleteMessage: "¿Deseas realmente eliminar este flujo?",
      },
      sections: {
        welcome: {
          title: "Flujo de bienvenida",
          description:
            "Selecciona el flujo que se enviará al inicio de una conversación.",
        },
        defaultReply: {
          title: "Flujo de respuesta predeterminada",
          description:
            "Selecciona el flujo que se usará cuando no haya coincidencias de frase.",
        },
      },
      placeholders: {
        selectFlow: "Selecciona un flujo",
      },
      toasts: {
        deleted: "Flujo eliminado con éxito.",
        updated: "Flujos predeterminados actualizados.",
      },
    },
    campaignsConfig: {
      sections: {
        intervals: "Intervalos",
      },
      errors: {
        noPermissionRedirect:
          "Esta empresa no tiene permiso para acceder a esta página. Te estamos redirigiendo.",
      },
    },
    campaigns: {
      settings: {
        seconds: "segundos",
      },
      dialog: {
        tabs: {
          message: "Mensaje {{number}}",
        },
      },
      table: {
        notScheduled: "Sin programación",
        notCompleted: "No finalizada",
      },
      status: {
        inactive: "Inactiva",
        scheduled: "Programada",
        running: "En curso",
        canceled: "Cancelada",
        completed: "Finalizada",
      },
      actions: {
        stop: "Detener campaña",
        restart: "Reiniciar campaña",
      },
    },
    flowBuilderConfig: {
      title: "Diseña tu flujo",
      reminder: "No olvides guardar tu flujo.",
      aria: {
        speedDial: "Agregar nodo",
      },
      toasts: {
        saved: "Flujo guardado con éxito.",
      },
      actions: {
        start: "Inicio",
        content: "Contenido",
        menu: "Menú",
        randomizer: "Randomizador",
        interval: "Intervalo",
        ticket: "Cola",
        typebot: "TypeBot",
        openai: "OpenAI",
        question: "Pregunta",
      },
      fallback: {
        html5: "Tu navegador no soporta HTML5",
      },
      units: {
        seconds: "segundos",
      },
      nodes: {
        start: {
          title: "Inicio del flujo",
          description: "Este bloque marca el inicio de tu flujo.",
        },
        message: {
          title: "Mensaje",
        },
        interval: {
          title: "Intervalo",
          seconds: "{{seconds}} segundos",
        },
        menu: {
          title: "Menú",
        },
        randomizer: {
          title: "Randomizador",
        },
        audio: {
          title: "Audio",
          recordedNow: "Grabado en el momento",
          sent: "Audio enviado",
        },
        image: {
          title: "Imagen",
          previewAlt: "Vista previa de imagen",
        },
        video: {
          title: "Video",
        },
        condition: {
          title: "Condición",
        },
        singleBlock: {
          title: "Contenido",
        },
        ticket: {
          title: "Cola",
        },
        typebot: {
          title: "TypeBot",
          iconAlt: "Icono de TypeBot",
        },
        openai: {
          title: "OpenAI/Gemini",
        },
        question: {
          title: "Pregunta",
        },
      },
    },
    flowBuilderModal: {
      title: {
        create: "Agregar flujo",
        edit: "Editar flujo",
      },
    },
    buttonModal: {
      title: "Selecciona una opción",
      select: {
        placeholder: "Selecciona",
      },
      options: {
        list: "Lista",
        copy: "Copiar",
        callMe: "Llámame",
      },
      fields: {
        title: "Título",
        description: "Descripción",
        message: "Mensaje",
        buttonText: "Texto del botón",
        url: "URL",
        copyText: "Texto para copiar",
        phone: "Teléfono",
        value: "Valor",
        image: "Imagen",
        name: "Nombre",
      },
      buttons: {
        addOption: "Agregar nueva opción",
      },
      list: {
        optionLabel: "Opción {{number}}",
        defaultSectionTitle: "Opciones",
        defaultButtonText: "Haz clic aquí",
      },
      url: {
        defaults: {
          title: "Botón de URL",
          description: "Mensaje con botón",
          buttonText: "Abrir enlace",
          url: "https://ejemplo.com",
        },
      },
      pix: {
        keyType: {
          placeholder: "Tipo de clave",
          phone: "Teléfono",
          email: "Email",
          random: "Clave aleatoria",
        },
        fields: {
          key: "Clave PIX",
        },
      },
      errors: {
        invalidTicketId: "ID de ticket inválido.",
        noOptionSelected: "Selecciona una opción.",
        processMessage: "Error al procesar el mensaje.",
      },
    },
    queueOptions: {
      title: "Opciones",
      placeholders: {
        title: "Título de la opción",
        message: "Escribe el texto de la opción",
      },
      fallback: {
        undefinedTitle: "Título no definido",
      },
    },
    nodePalette: {
      title: "Nodos disponibles",
      nodeCount: "{{count}} nodos profesionales",
      searchPlaceholder: "Buscar nodos...",
      noResults: {
        title: "No se encontraron nodos",
        subtitle: "Intenta con otro término",
      },
      categories: {
        trigger: {
          name: "Disparadores",
          description: "Inicia tu flujo automáticamente",
        },
        ai: {
          name: "IA y aprendizaje automático",
          description: "Inteligencia artificial avanzada",
        },
        crm: {
          name: "CRM y ventas",
          description: "Gestión de clientes y ventas",
        },
        ecommerce: {
          name: "E-commerce y pagos",
          description: "Tiendas online y pagos",
        },
        communication: {
          name: "Comunicación",
          description: "Mensajería y comunicación",
        },
        database: {
          name: "Bases de datos",
          description: "Bases de datos y almacenamiento",
        },
        storage: {
          name: "Nube y archivos",
          description: "Almacenamiento en la nube",
        },
        analytics: {
          name: "Analítica y seguimiento",
          description: "Análisis y métricas",
        },
        marketing: {
          name: "Marketing y publicidad",
          description: "Marketing y publicidad",
        },
        logic: {
          name: "Lógica y control de flujo",
          description: "Control de flujo y lógica",
        },
        transform: {
          name: "Transformación de datos",
          description: "Transformación de datos",
        },
        action: {
          name: "Acciones y automatización",
          description: "Acciones y automatización",
        },
      },
      nodes: {
        trigger: {
          whatsapp_message: "Mensaje de WhatsApp",
          whatsapp_status: "Estado de WhatsApp",
          telegram_message: "Mensaje de Telegram",
          email_received: "Email recibido",
          sms_received: "SMS recibido",
          webhook: "Webhook",
          schedule: "Programación/Cron",
          form_submit: "Envío de formulario",
          file_upload: "Subida de archivo",
          api_call: "Llamada API",
          database_change: "Cambio en base de datos",
          payment_received: "Pago recibido",
          order_placed: "Pedido realizado",
          new_contact: "Nuevo contacto",
          calendar_event: "Evento de calendario",
          button_click: "Clic en botón",
          qr_scan: "Escaneo QR",
          voice_command: "Comando de voz",
        },
        ai: {
          gpt4: "Chat GPT-4",
          gpt4_vision: "Visión GPT-4",
          claude: "Claude 3",
          gemini: "Google Gemini",
          dall_e: "Imagen DALL-E",
          whisper: "Audio Whisper",
          tts: "Texto a voz",
          intent_detection: "Detección de intención",
          sentiment: "Análisis de sentimiento",
          rag: "Consulta RAG",
          summarize: "Resumen de texto",
          translate: "Traducción",
          classify: "Clasificación de texto",
          entity_extraction: "Extracción de entidades",
          embeddings: "Generar embeddings",
          question_answer: "Sistema de preguntas y respuestas",
          content_moderate: "Moderación de contenido",
          image_recognition: "Reconocimiento de imágenes",
          ocr: "OCR: extracción de texto",
          face_detection: "Detección de rostros",
          object_detection: "Detección de objetos",
          speech_recognition: "Reconocimiento de voz",
          video_analysis: "Análisis de video",
          predictive: "Modelo predictivo",
          recommendation: "Motor de recomendación",
        },
        crm: {
          salesforce_lead: "Lead de Salesforce",
          salesforce_contact: "Contacto de Salesforce",
          hubspot_contact: "Contacto de HubSpot",
          hubspot_deal: "Negocio de HubSpot",
          pipedrive_deal: "Negocio de Pipedrive",
          pipedrive_activity: "Actividad de Pipedrive",
          zoho_lead: "Lead de Zoho",
          zoho_account: "Cuenta de Zoho",
          dynamics_contact: "Contacto de Dynamics",
          freshsales: "Freshsales",
          airtable: "Airtable",
          notion: "Base de datos de Notion",
          monday: "Monday.com",
          asana: "Tarea de Asana",
          trello: "Tarjeta de Trello",
          jira: "Incidencia de Jira",
          zendesk: "Ticket de Zendesk",
          intercom: "Mensaje de Intercom",
        },
        ecommerce: {
          shopify_order: "Pedido de Shopify",
          shopify_product: "Producto de Shopify",
          shopify_customer: "Cliente de Shopify",
          woocommerce_order: "Pedido de WooCommerce",
          woocommerce_product: "Producto de WooCommerce",
          mercadolibre: "Mercado Libre",
          amazon: "Amazon FBA",
          ebay: "Listado de eBay",
          stripe_payment: "Pago de Stripe",
          stripe_subscription: "Suscripción de Stripe",
          paypal: "Transacción de PayPal",
          square: "Pago de Square",
          mercadopago: "Mercado Pago",
          conekta: "Pago de Conekta",
          wix_store: "Tienda Wix",
          squarespace: "Squarespace",
          bigcommerce: "BigCommerce",
          magento: "Magento",
          prestashop: "PrestaShop",
          shipment_tracking: "Seguimiento de envío",
        },
        communication: {
          whatsapp_send: "Enviar WhatsApp",
          whatsapp_template: "Plantilla de WhatsApp",
          whatsapp_media: "Multimedia de WhatsApp",
          telegram_send: "Enviar Telegram",
          telegram_bot: "Bot de Telegram",
          slack_message: "Mensaje de Slack",
          slack_channel: "Canal de Slack",
          discord_message: "Mensaje de Discord",
          discord_embed: "Embed de Discord",
          email_smtp: "Email SMTP",
          email_template: "Plantilla de email",
          sms_twilio: "SMS Twilio",
          sms_nexmo: "SMS Nexmo",
          voice_call: "Llamada de voz",
          push_notification: "Notificación push",
          teams_message: "Microsoft Teams",
          zoom_meeting: "Reunión de Zoom",
          google_meet: "Google Meet",
          messenger_send: "Facebook Messenger",
          instagram_dm: "DM de Instagram",
          twitter_dm: "DM de Twitter",
          linkedin_message: "Mensaje de LinkedIn",
        },
        database: {
          postgresql: "PostgreSQL",
          mysql: "MySQL",
          mongodb: "MongoDB",
          redis: "Caché Redis",
          elasticsearch: "Elasticsearch",
          firebase_firestore: "Firebase Firestore",
          firebase_realtime: "Firebase Realtime",
          supabase: "Supabase",
          dynamodb: "AWS DynamoDB",
          cosmosdb: "Azure Cosmos DB",
          cassandra: "Cassandra",
          mariadb: "MariaDB",
          oracle: "Oracle DB",
          sql_server: "SQL Server",
          sqlite: "SQLite",
          couchdb: "CouchDB",
          influxdb: "InfluxDB",
          neo4j: "Grafo Neo4j",
        },
        storage: {
          google_drive: "Google Drive",
          google_sheets: "Google Sheets",
          dropbox: "Dropbox",
          s3: "AWS S3",
          azure_blob: "Azure Blob Storage",
          onedrive: "OneDrive",
          box: "Box",
          ftp: "Servidor FTP",
          sftp: "Servidor SFTP",
          github: "Repositorio GitHub",
          gitlab: "Repositorio GitLab",
          bitbucket: "Bitbucket",
        },
        analytics: {
          google_analytics: "Google Analytics",
          ga4_event: "Evento GA4",
          mixpanel: "Mixpanel",
          amplitude: "Amplitude",
          segment: "Segment (Track)",
          hotjar: "Evento Hotjar",
          posthog: "PostHog",
          heap: "Heap Analytics",
          facebook_pixel: "Facebook Pixel",
          google_tag: "Google Tag Manager",
          custom_event: "Evento personalizado",
          ab_test: "Prueba A/B",
        },
        marketing: {
          facebook_ads: "Anuncios de Facebook",
          google_ads: "Anuncios de Google",
          instagram_ads: "Anuncios de Instagram",
          linkedin_ads: "Anuncios de LinkedIn",
          twitter_ads: "Anuncios de Twitter",
          mailchimp: "Campaña Mailchimp",
          sendgrid: "Email SendGrid",
          activecampaign: "ActiveCampaign",
          convertkit: "ConvertKit",
          hubspot_email: "Email HubSpot",
          klaviyo: "Klaviyo",
          brevo: "Brevo (Sendinblue)",
          tiktok_ads: "Anuncios de TikTok",
          youtube_ads: "Anuncios de YouTube",
          pinterest_ads: "Anuncios de Pinterest",
        },
        logic: {
          condition: "Condición If",
          switch: "Caso Switch",
          router: "Router",
          loop: "Bucle/Iterar",
          for_each: "Para cada",
          while: "Bucle While",
          filter: "Filtrar array",
          sort: "Ordenar array",
          merge: "Combinar datos",
          split: "Dividir datos",
          aggregate: "Agregar",
          limit: "Limitar resultados",
          delay: "Espera/Delay",
          error_handler: "Manejador de errores",
          retry: "Reintentar",
        },
        transform: {
          json_parse: "Parser JSON",
          json_stringify: "JSON Stringify",
          xml_parse: "Parser XML",
          csv_parse: "Parser CSV",
          data_mapper: "Mapeo de datos",
          text_extract: "Extraer texto (Regex)",
          text_replace: "Reemplazar texto",
          hash: "Generador hash",
          encrypt: "Encriptar datos",
          decrypt: "Desencriptar datos",
          base64: "Base64 codificar/decodificar",
          url_encode: "Codificar URL",
        },
        action: {
          send_message: "Enviar mensaje",
          create_ticket: "Crear ticket",
          tag_contact: "Etiquetar contacto",
          update_contact: "Actualizar contacto",
          create_task: "Crear tarea",
          send_email: "Enviar email",
          log_event: "Registrar evento",
          webhook_call: "Llamar webhook",
          http_request: "Solicitud HTTP",
          graphql: "Consulta GraphQL",
          run_script: "Ejecutar JavaScript",
          python_script: "Ejecutar Python",
          schedule_action: "Programar acción",
          trigger_flow: "Disparar otro flujo",
          stop_flow: "Detener flujo",
        },
      },
    },
    allConnections: {
      table: {
        customer: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
      },
    },
    webhooksPage: {
      title: "Webhooks",
      soon: "Próximamente.",
    },
    helps: {
      settings: {
        title: "Título",
      },
    },
    plans: {
      form: {
        queues: "Filas",
        amount: "Valor",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        internalChat: "Chat interno",
        externalApi: "API externa",
        kanban: "Kanban",
        openAi: "OpenAI",
        integrations: "Integraciones",
      },
    },
    invoices: {
      table: {
        status: "Estado",
        idLabel: "ID: {{id}}",
      },
      tooltips: {
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Filas",
        value: "Valor",
        dueDate: "Vencimiento",
      },
      status: {
        paid: "Pagada",
        overdue: "Vencida",
        open: "Abierta",
      },
      actions: {
        pay: "Pagar",
        payNow: "Pagar ahora",
      },
      daysLeft: {
        overdueOne: "Vencida hace {{days}} día",
        overdueMany: "Vencida hace {{days}} días",
        dueToday: "Vence hoy",
        dueInOne: "Vence en {{days}} día",
        dueInMany: "Vence en {{days}} días",
      },
    },
    buttonPreview: {
      toasts: {
        codeCopied: "Código copiado.",
      },
      errors: {
        noContentToCopy: "No hay contenido para copiar.",
        noLinkAvailable: "No hay enlace disponible.",
        callsNotSupported: "Las llamadas no son compatibles en esta vista previa.",
      },
      empty: {
        noButtonsInSection: "No hay botones en esta sección.",
        noSectionsAvailable: "No hay secciones disponibles.",
      },
      alt: {
        preview: "Vista previa",
      },
    },
    schedules: {
      calendar: {
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el día",
        week: "Semana",
        workWeek: "Semana laboral",
        day: "Día",
        month: "Mes",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este rango.",
        showMore: "+{{total}} más",
      },
    },
    layout: {
      errors: {
        accountAccessedElsewhere:
          "Este usuario ya inició sesión en otro dispositivo. Se cerrará tu sesión.",
      },
    },
    messageOptionsMenu: {
      toasts: {
        reactionSent: "Reacción enviada.",
      },
    },
    newTicketModal: {
      placeholders: {
        queue: "Selecciona una cola",
        connection: "Selecciona una conexión",
      },
      errors: {
        queueRequired: "Selecciona una cola para continuar.",
      },
    },
    analytics: {
      title: "Analíticas",
      subtitle: "Métricas y tendencias de tu negocio",
      toasts: {
        loadError: "Error al cargar analíticas.",
      },
      period: {
        label: "Período",
        options: {
          week: "Semana",
          month: "Mes",
          quarter: "Trimestre",
          year: "Año",
        },
      },
      metrics: {
        totalRevenue: "Ingresos totales",
        totalLeads: "Total de leads",
        conversionRate: "Tasa de conversión",
        avgDealSize: "Tamaño promedio del negocio",
        vsPreviousPeriod: "{{value}}% vs período anterior",
      },
      monthlyTrends: {
        title: "Tendencias mensuales",
        revenueTrend: "Tendencia de ingresos",
        table: {
          month: "Mes",
          leads: "Leads",
          conversions: "Conversiones",
          conversionRate: "Tasa",
          revenue: "Ingresos",
        },
      },
      topProducts: {
        title: "Productos principales",
        salesLabel: "{{count}} ventas",
      },
      leadSources: {
        title: "Fuentes de leads",
        countLabel: "{{count}} leads",
      },
    },
    campaignsPhrase: {
      toasts: {
        deleted: "Frase eliminada con éxito.",
      },
    },
    messagesAPI: {
      toasts: {
        sent: "Mensaje enviado con éxito.",
      },
      labels: {
        endpoint: "Endpoint",
        method: "Método",
        headers: "Headers",
        body: "Body",
        formData: "FormData",
        testSend: "Enviar prueba",
      },
      docs: {
        headers: {
          json: "Authorization: Bearer (token registrado) y Content-Type (application/json)",
          formData:
            "Authorization: Bearer (token registrado) y Content-Type (multipart/form-data)",
        },
        fields: {
          userIdHint: "ID de usuario/agente o \"\"",
          queueIdHint: "ID de la cola o \"\"",
          mediasHint: "archivo",
          sendSignatureHint: "Firmar mensaje - true/false",
          closeTicketHint: "Cerrar ticket - true/false",
        },
      },
    },
    messageModal: {
      title: {
        add: "Nuevo mensaje programado",
        edit: "Editar mensaje programado",
      },
      success: {
        save: "Mensaje programado guardado.",
      },
      placeholders: {
        connection: "Conexión",
        contacts: "Contactos",
        users: "Usuarios",
      },
      form: {
        createTicket: "Crear ticket",
      },
    },
    listPreview: {
      modal: {
        title: "Lista de botones",
      },
      fields: {
        selectedTitlePlaceholder: "Título seleccionado",
      },
      a11y: {
        selectedTitle: "título seleccionado",
      },
      alerts: {
        selectTitle: "Por favor, selecciona un título.",
        ticketIdNotFound: "Error: ticketId no encontrado.",
        sendError: "Error al enviar el mensaje. Intenta nuevamente.",
      },
    },
    scheduleModal: {
      statusTitle: {
        sendError: "Error de envío",
        messageWithStatus: "Mensaje {{status}}",
      },
    },
  },

  en: {
    common: {
      save: "Save",
      cancel: "Cancel",
      back: "Back",
      next: "Next",
      previous: "Previous",
      create: "Create",
      update: "Update",
      add: "Add",
      edit: "Edit",
      import: "Import",
      export: "Export",
      confirm: "Confirm",
      close: "Close",
      delete: "Delete",
      duplicate: "Duplicate",
      refresh: "Refresh",
      search: "Search",
      configure: "Configure",
      upgradePlan: "Upgrade plan",
      company: "Company",
      package: "Package",
      assignCredits: "Assign credits",
      copied: "Copied",
      yes: "Yes",
      no: "No",
      active: "Active",
      inactive: "Inactive",
      actions: "Actions",
      status: "Status",
      source: "Source",
      date: "Date",
      id: "ID",
      name: "Name",
      email: "Email",
      phone: "Phone",
      notes: "Notes",
      description: "Description",
      price: "Price",
      tokens: "Tokens",
      clear: "Clear",
      deactivate: "Deactivate",
      activate: "Activate",
      anErrorOccurred: "An error occurred.",
      loading: "Loading...",
      ok: "OK",
      total: "Total",
      other: "Other",
      send: "Send",
      chat: "Chat",
      placeholders: {
        emailAddress: "Email address",
      },
      alt: {
        thumbnail: "Thumbnail",
      },
      validation: {
        required: "Required.",
        tooShort: "Too short.",
        tooLong: "Too long.",
        passwordRequired: "Password is required.",
        invalidEmail: "Invalid email.",
        apiKeyRequired: "API Key is required.",
        voiceModeRequired: "Voice mode is required.",
        ratingRequired: "Rating is required.",
        passwordsMustMatch: "Passwords must match.",
        invalidOption: "Invalid option.",
        minValue: "Minimum {{min}}.",
        maxValue: "Maximum {{max}}.",
      },
      errors: {
        loadRecords: "Unable to load the records list.",
        noPermissionRedirect:
          "This company does not have permission to access this page. Redirecting you.",
        operationFailed: "Operation failed.",
        operationFailedDuplicateOrInvalid:
          "Operation failed. Please check the data and try again.",
      },
      toasts: {
        success: "Operation completed successfully.",
        clickSaveToApplyChanges: 'Click "Save" to apply the changes.',
      },
      confirmationModal: {
        deleteTitle: "Delete record",
        deleteMessage: "Do you really want to delete this record?",
      },
    },
    backendErrors: {
      plan_limit_exceeded:
        "You have reached the connection limit of your membership. Upgrade your plan to add more.",
    },
    connections: {
      table: {
        channel: "Channel",
      },
    },
    compaies: {
      title: "Companies",
      table: {
        ID: "ID",
        status: "Active",
        name: "Name",
        email: "Email",
        password: "Password",
        phone: "Phone",
        plan: "Plan",
        active: "Active",
        numberAttendants: "Agents",
        numberConections: "Connections",
        value: "Value",
        namePlan: "Plan Name",
        numberQueues: "Queues",
        useCampaigns: "Campaigns",
        useExternalApi: "Rest API",
        useFacebook: "Facebook",
        useInstagram: "Instagram",
        useWhatsapp: "WhatsApp",
        useInternalChat: "Internal Chat",
        useSchedules: "Scheduling",
        createdAt: "Created At",
        dueDate: "Due Date",
        lastLogin: "Last Login",
        folderSize: "Folder size",
        totalFiles: "Total files",
        lastFolderUpdate: "Last folder update",
        actions: "Actions",
        money: "$",
        yes: "Yes",
        no: "No",
        document: "CNPJ/CPF",
        recurrence: "Recurrence",
        monthly: "Monthly",
        bimonthly: "Bimonthly",
        quarterly: "Quarterly",
        semester: "Semiannual",
        yearly: "Annual",
        clear: "Clear",
        delete: "Delete",
        user: "User",
        save: "Save",
      },
      buttons: {
        add: "Add company",
      },
      toasts: {
        deleted: "Company deleted successfully.",
      },
      confirmationModal: {
        deleteTitle: "Delete",
        deleteMessage:
          "All company data will be lost. Open tickets from this user will be moved to the queue.",
      },
    },
    qrCode: {
      waiting: "Waiting for QR code",
    },
    chatbots: {
      toasts: {
        saved: "Chatbot saved successfully.",
        deleted: "Chatbot deleted successfully.",
      },
      confirmationModal: {
        deleteMessage: "Are you sure? All internal options will also be deleted.",
      },
      validation: {
        optionNameMin: "Option name must be at least 4 characters.",
        optionNameRequired: "Option name is required.",
        optionsRequired: "You must add at least one option.",
      },
    },
    contactImportWpModal: {
      status: {
        completed: "Import completed successfully.",
        inProgress:
          "Import in progress {{current}} of {{total}}. Please do not leave this screen until the import completes.",
      },
    },
    tagsKanban: {
      form: {
        stage: "Kanban stage",
      },
    },
    filters: {
      placeholders: {
        contacts: "Contacts",
        connections: "Connections",
        departments: "Departments",
        statusFilter: "Filter by status",
        tagsFilter: "Filter by tags",
        tags: "Tags",
      },
    },
    tagsContainer: {
      errors: {
        tooShort: "Tag is too short.",
      },
    },
    tickets: {
      search: {
        filterConectionsOptions: {
          groups: "Groups",
        },
      },
      simulateIncoming: {
        channelFallback: "channel",
        body: "Test message ({{channel}})",
        menuLabel: "Simulate incoming message",
        toasts: {
          success: "Incoming message simulated.",
        },
      },
    },
    messageUploadMedias: {
      placeholders: {
        caption: "Caption (optional)",
      },
      fallback: {
        unavailable: "Preview not available",
      },
      alt: {
        image: "Image {{index}}",
      },
    },
    ticket: {
      chat: {
        searchPlaceholder: "Search in this chat...",
      },
    },
    messagesList: {
      deletedMessage: "🚫 _Message deleted_",
      deletedText: "🚫 Message deleted",
      deletedByContactText: "🚫 This message was deleted by the contact",
      forwarded: "Forwarded",
      reacted: "You reacted... {{reaction}}",
      editedAt: "Edited {{time}}",
      empty: {
        startConversation: "Say hello to your new contact!",
      },
      dragDrop: {
        dropHere: "Drop the file here",
      },
      facebookPolicy24h:
        "You have 24h to reply after receiving a message, according to Facebook policies.",
    },
    recurrence: {
      title: "Recurrence",
      description:
        "You can send the message recurrently and choose the interval. If it's a one-time message, don't change anything in this section.",
      interval: {
        label: "Interval",
        valueLabel: "Interval value",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      sendCount: {
        label: "Send how many times",
      },
      businessDaysPolicy: {
        label: "Non-business days",
        options: {
          normal: "Send normally on non-business days",
          before: "Send one business day before",
          after: "Send one business day after",
        },
      },
      showUser: "Show user",
    },
    whatsappModal: {
      flowbuilder: {
        welcomeFlow: {
          title: "Welcome flow",
          description:
            "This flow is triggered only for new contacts: people who are not in your contacts list and who sent a message.",
        },
        defaultResponseFlow: {
          title: "Default response flow",
          description:
            "The default response is sent for any character that is different from a keyword. Note: it will be triggered if the conversation is already closed.",
        },
      },
    },
    ticketsList: {
      preview: {
        title: "Previewing conversation",
      },
      loadingMessages: "Loading messages...",
      tooltips: {
        previewConversation: "Preview conversation",
      },
      adClick: "Ad click",
    },
    userModal: {
      form: {
        profiles: {
          admin: "Admin",
          user: "User",
        },
      },
    },
    contactNotesEditModal: {
      title: "Edit note",
      fields: {
        note: "Note",
      },
    },
    updateNotification: {
      title: "New version available!",
      subtitle: "A system update is available.",
      versionLabel: "Version: {{version}}",
      instruction: 'Click "Update now" to load the new version.',
      buttons: {
        later: "Later",
        updateNow: "Update now",
      },
    },
    settings: {
      tabs: {
        sla: "SLA",
        schedules: "Schedules",
        companies: "Companies",
        modules: "Modules",
        planModules: "Plan-Modules",
        companyModules: "Company Modules",
        aiTokens: "AI Tokens",
        whitelabel: "Whitelabel",
      },
      settings: {
        customMessages: {
          transferMessageDefault:
            `Your ticket has been transferred to the \${queue.name} department. Please wait...`,
        },
        options: {
          text: "Text",
        },
      },
      whitelabel: {
        fields: {
          primaryColorLight: "Primary color (light mode)",
          primaryColorDark: "Primary color (dark mode)",
          systemName: "System name",
          logoLight: "Light logo",
          logoDark: "Dark logo",
          favicon: "Favicon",
        },
        errors: {
          uploadImage: "Could not upload image.",
        },
      },
    },
    aiTokens: {
      title: "AI Tokens",
      packages: {
        form: {
          name: "Name",
          tokens: "Tokens",
          price: "Price",
          active: "Active",
        },
        table: {
          name: "Name",
          tokens: "Tokens",
          price: "Price",
          active: "Active",
        },
        buttons: {
          clear: "Clear",
          save: "Save",
          deactivate: "Deactivate",
          assignCredits: "Assign credits",
        },
        credit: {
          company: "Company",
          package: "AI Package",
        },
        confirm: {
          deactivateTitle: "Deactivate package",
          deactivateMessage: "Do you want to deactivate this AI package?",
        },
        toasts: {
          companiesLoadError: "Could not load companies.",
          packagesLoadError: "Could not load packages.",
          packageSaved: "Package saved.",
          packageSaveError: "Could not save the package.",
          packageDeactivated: "Package deactivated.",
          packageDeactivateError: "Could not deactivate the package.",
          selectCompanyAndPackage: "Select a company and a package.",
          creditsAssigned: "AI credits assigned.",
          creditsAssignError: "Could not assign credits.",
        },
      },
    },
    leads: {
      title: "Lead Management",
      subtitle: "Manage your sales opportunities",
      buttons: {
        refresh: "Refresh",
        new: "New Lead",
        cancel: "Cancel",
        create: "Create",
        update: "Update",
      },
      stats: {
        total: "Total Leads",
        new: "New",
        qualified: "Qualified",
        contacted: "Contacted",
      },
      filters: {
        searchPlaceholder: "Search leads...",
        status: "Status",
        source: "Source",
        all: "All",
        allFeminine: "All",
      },
      table: {
        name: "Name",
        contact: "Contact",
        status: "Status",
        source: "Source",
        score: "Score",
        date: "Date",
        actions: "Actions",
        empty: "No leads to display",
      },
      pagination: {
        rowsPerPage: "Rows per page",
        displayedRows: "{{from}}-{{to}} of {{count}}",
        moreThan: "more than {{to}}",
      },
      dialog: {
        addTitle: "New Lead",
        editTitle: "Edit Lead",
      },
      form: {
        name: "Name",
        nameRequired: "Name is required",
        email: "Email",
        phone: "Phone",
        phonePlaceholder: "+51987654321",
        status: "Status",
        source: "Source",
        score: "Score (0-100)",
        notes: "Notes",
      },
      confirm: {
        delete: "Are you sure you want to delete this lead?",
      },
      status: {
        new: "New",
        contacted: "Contacted",
        qualified: "Qualified",
        converted: "Converted",
        lost: "Lost",
      },
      sources: {
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        website: "Website",
        referral: "Referral",
        cold_call: "Call",
        email: "Email",
        other: "Other",
      },
      contactActions: {
        whatsapp: "WhatsApp",
        call: "Call",
        email: "Email",
      },
      toasts: {
        loadError: "Error loading leads.",
        saveError: "Error saving lead.",
        deleteError: "Error deleting lead.",
        updated: "Lead updated successfully.",
        created: "Lead created successfully.",
        deleted: "Lead deleted successfully.",
      },
    },
    abTesting: {
      title: "A/B Testing AI",
      subtitle: "Optimize AI responses with controlled experiments",
      actions: {
        refresh: "Refresh",
      },
      errors: {
        loadData: "Error loading A/B testing data",
      },
      stats: {
        totalExperiments: "Total Experiments",
        activeLabel: "{{count}} active",
        totalImpressions: "Total Impressions",
        conversions: "Conversions",
        conversionRate: "Conversion Rate",
      },
      table: {
        title: "Experiments",
        idLabel: "ID: {{id}}",
        headers: {
          experiment: "Experiment",
          description: "Description",
          variants: "Variants",
          impressions: "Impressions",
          status: "Status",
          actions: "Actions",
        },
        status: {
          active: "Active",
          stopped: "Stopped",
        },
        tooltips: {
          viewDetails: "View details",
          stopExperiment: "Stop experiment",
        },
      },
      dialog: {
        progressTitle: "Experiment Progress",
        samples: "{{count}} samples",
        goal: "Goal: {{count}}",
        significant: "The experiment has reached statistical significance",
        winnerTitle: "Current Winner: {{name}}",
        score: "Score: {{score}}",
        variantsTitle: "Variants",
        variantsHeaders: {
          variant: "Variant",
          impressions: "Impressions",
          conversions: "Conversions",
          conversionRate: "Conv. Rate",
          satisfaction: "Satisfaction",
          escalations: "Escalations",
        },
        control: "Control",
        actions: {
          close: "Close",
          stop: "Stop Experiment",
        },
      },
    },
    registerClient: {
      title: "Register New Client",
      subtitle: "Fill in the information to onboard a new client",
      steps: {
        company: "Company Info",
        contact: "Contact Person",
        plan: "Plan and Services",
      },
      industries: {
        retail: "Retail",
        restaurant: "Restaurant",
        healthcare: "Healthcare",
        education: "Education",
        technology: "Technology",
        services: "Services",
        ecommerce: "E-commerce",
        realEstate: "Real estate",
        other: "Other",
      },
      company: {
        title: "Company Information",
        fields: {
          name: "Company Name",
          industry: "Industry",
          email: "Company Email",
          phone: "Company Phone",
          address: "Address",
          website: "Website",
        },
      },
      contact: {
        title: "Contact Person",
        fields: {
          name: "Full Name",
          position: "Role/Position",
          email: "Contact Email",
          phone: "Contact Phone",
        },
      },
      plan: {
        title: "Select Plan",
        includes: {
          users: "Users",
          connections: "Connections",
          queues: "Queues",
        },
        perMonth: "/month",
        billingCycle: "Billing Cycle",
        billingMonthly: "Monthly",
        billingAnnual: "Annual (2 months free)",
      },
      addons: {
        title: "Additional Services",
        pricePerMonth: `+\${{amount}}/month`,
      },
      notes: {
        title: "Additional Notes",
        placeholder: "Add any notes or comments about this client...",
      },
      total: {
        label: "Total to Bill",
        perYear: "/year",
        perMonth: "/month",
      },
      buttons: {
        back: "Back",
        next: "Next",
        submit: "Register Client",
      },
      toasts: {
        stepCompanyRequired: "Please complete all required fields.",
        stepContactRequired: "Please complete the contact information.",
        success: "Client registered successfully!",
        error: "Error registering client.",
      },
    },
    subscription: {
      free: "Free",
      license: {
        noExpiration: "No expiration",
        expiresToday: "Your license expires today",
        expiredOn: "License expired on {{date}}",
        expiresIn: "Your license expires in {{days}} {{dayWord}} ({{date}})",
        day: "day",
        days: "days",
      },
      fields: {
        dueDate: "Due date",
        billingEmail: "Billing email",
        currentPlan: "Current plan",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        price: "Price",
      },
      upgrade: {
        title: "Upgrade plan",
        button: "Update plan",
        updating: "Updating...",
      },
      contact: {
        button: "Subscribe now",
      },
      toasts: {
        planUpdated: "Plan updated successfully.",
      },
    },
    configApis: {
      title: "Connect APIs",
      channels: {
        whatsappTitle: "WhatsApp Cloud API",
        facebookTitle: "Facebook Messenger",
        instagramTitle: "Instagram Messaging",
      },
      summary: {
        title: "Summary",
        activeConnections: "Active connections (Meta APIs):",
        planLimit: "Your membership limit:",
        limitReached: "Limit reached: to add more connections, upgrade your plan.",
      },
      channelCard: {
        activeConnections: "Active connections:",
        configure: "Configure",
        upgradePlan: "Upgrade plan",
      },
      actions: {
        refresh: "Refresh",
      },
      subtitles: {
        whatsapp: "Phone Number ID + Access Token + Webhook",
        facebook: "Page + Access Token + Webhook",
        instagram: "Account + Access Token + Webhook",
      },
      empty: {
        title: "Connect APIs",
        subtitle: "Your plan doesn't have Meta modules enabled.",
        button: "View plans",
      },
    },
    whatsappApi: {
      title: "WhatsApp API",
      actions: {
        copyWebhook: "Copy webhook",
        newConnection: "New connection",
        copy: "Copy",
        save: "Save",
        saving: "Saving...",
        rotating: "Rotating...",
        rotateVerifyToken: "Rotate Verify Token",
        rotateSecrets: "Rotate WebhookKey + Verify Token",
      },
      toasts: {
        copied: "Copied",
        connectionUpdated: "Connection updated.",
        connectionCreated: "Connection created.",
        connectionDeleted: "Connection deleted.",
        connectionSavedButMetaSubscribeFailed:
          "Connection saved, but the automatic Meta subscription could not be completed. {{reason}}",
        metaSubscribeOk: "Meta subscription completed.",
        metaSubscribeFailed: "Could not complete the Meta subscription. {{reason}}",
        verifyTokenRotated: "Verify Token updated. Update it in Meta and verify again.",
        secretsRotated: "WebhookKey and Verify Token updated. Update them in Meta and verify again.",
      },
      modal: {
        editTitle: "Edit WhatsApp API connection",
        newTitle: "New WhatsApp API connection",
      },
      form: {
        name: "Name",
        phoneNumberId: "Phone Number ID",
        phoneNumberIdHelper: "e.g. 123456789012345",
        wabaIdOptional: "WABA ID",
        accessToken: "Access Token",
        accessTokenEditHint: "Access Token (leave blank to keep current)",
        useAsDefault: "Use as default",
        cancel: "Cancel",
      },
      validation: {
        nameMin: "Name must be at least 2 characters",
        nameRequired: "Name is required",
        phoneNumberIdRequired: "Phone Number ID is required",
        wabaIdRequired: "WABA ID is required",
        accessTokenRequired: "Access Token is required",
      },
      errors: {
        missingWabaId: "Missing WABA ID. Add it and save again to auto-subscribe in Meta.",
        missingAccessToken: "Missing Access Token. Add it and save again.",
        appNotSubscribed: "The app does not appear subscribed to the WABA. Check token permissions or subscribe manually in Meta.",
      },
      confirm: {
        deleteTitle: "Delete connection",
        deleteMessage: "Delete the connection {{name}}?",
      },
      rotateVerifyToken: {
        title: "Rotate Verify Token",
        message:
          "You are about to generate a new Verify Token. The previous token will no longer be used. Then you must update it in Meta Developer and re-verify the webhook. Continue?",
      },
      rotateSecrets: {
        title: "Rotate WebhookKey + Verify Token",
        message:
          "You are about to generate a new WebhookKey and a new Verify Token. The webhook URL will change and the previous token will no longer be used. Then you must update both in Meta Developer and re-verify the webhook. Continue?",
      },
      table: {
        name: "Name",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        meta: "Meta",
        default: "Default",
        webhook: "Webhook",
        actions: "Actions",
      },
      values: {
        yes: "Yes",
        no: "No",
        verified: "Verified",
        pending: "Pending",
        metaSubscribed: "Subscribed",
        metaError: "Error",
        metaUnknown: "Pending",
      },
      empty: "No connections. Create one to get started.",
      helper: {
        title: "Meta data (unique per client)",
        step1: "In Meta Developer, configure the webhook using:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        step2: "Subscribe to the messages event. When you save/activate, Klorum tries to subscribe your app to the WABA automatically.",
        step3: "When Meta verifies, you'll see the status Verified.",
        step4: "Incoming messages will arrive in WhatsApp (Tickets) and you can reply from the chat.",
        user: "User:",
      },
      tooltips: {
        retryMetaSubscribe: "Retry Meta subscription",
        edit: "Edit",
        delete: "Delete",
      },
    },
    dashboard: {
      errors: {
        loadData: "Unable to load dashboard data.",
      },
      filters: {
        title: "Filters",
      },
      export: {
        agentsSheet: "AgentsReport",
        agentsFile: "agents-report.xlsx",
        error: "Error exporting to Excel.",
      },
      charts: {
        errors: {
          loadTicketsInfo: "Unable to load ticket information.",
        },
        perHour: {
          title: "Tickets per hour",
        },
        ticketsLabel: "Tickets",
        empty: {
          noData: "No data to display.",
          noDataForPeriod: "No data for the selected period.",
        },
      },
      membership: {
        title: "My membership",
        details: "View details",
        availablePlansTitle: "Available plans",
        availablePlansSubtitle:
          "Your current plan automatically applies to system limits and modules.",
        loadingPlans: "Loading plans...",
        noPublicPlans: "No public plans available at the moment.",
        planLabel: "Plan",
        activeBadge: "ACTIVE",
        channelsLabel: "Channels",
        buttons: {
          current: "Current plan",
          upgrade: "Upgrade",
          view: "View",
        },
        license: {
          noExpiration: "No expiration",
          expiresToday: "Expires today",
          expiredOn: "Expired on {{date}}",
          expiresOn: "Expires on {{date}}",
        },
      },
      channels: {
        titleOverline: "Channels",
        title: "Channel status",
        subtitle: "Active connections and last sync per channel.",
        configureApis: "Configure APIs",
        loading: "Loading channel status...",
        empty: "No channel information available.",
        status: {
          connected: "Connected",
          disconnected: "Disconnected",
          error: "Error",
        },
        errors: {
          load: "Unable to load channel status.",
        },
      },
      analytics: {
        title: "Analytics (this month)",
        period: "Period: {{from}} to {{to}}",
        chips: {
          unavailable: "Unavailable",
          realData: "Real data",
        },
        disabledMessage:
          "Your current plan does not include the Analytics module. Upgrade your plan to view these metrics.",
        loading: "Loading analytics...",
        metrics: {
          monthlyRevenue: "Revenue (month)",
          totalRevenue: "Revenue (total)",
          conversion: "Conversion",
          firstResponse: "First response (min)",
          activeUsers: "Active users",
          newLeads: "New leads",
          closings: "Closed deals",
        },
        activity: {
          title: "Recent activity",
          loading: "Loading activity...",
          empty: "No recent activity available.",
          fallbackTitle: "Activity",
        },
        errors: {
          metrics: "Unable to load company metrics.",
          activity: "Unable to load recent activity.",
        },
      },
    },
    flowBuilder: {
      defaultFlowName: "New Flow",
      copySuffix: "(Copy)",
      list: {
        title: "Conversation flows",
        addFlow: "Add flow",
        searchPlaceholder: "Search flow...",
        empty: "You don't have any flows yet.",
        noMatches: "No results for your search.",
        status: {
          active: "Active",
          inactive: "Disabled",
        },
        menu: {
          editName: "Edit name",
          editFlow: "Edit flow",
          duplicate: "Duplicate",
          delete: "Delete",
        },
        confirm: {
          deleteTitle: "Delete the flow {{name}}?",
          deleteBody:
            "Are you sure you want to delete this flow? All related integrations will be lost.",
          duplicateTitle: "Duplicate the flow {{name}}?",
          duplicateBody: "Are you sure you want to duplicate this flow?",
        },
        toasts: {
          deleted: "Flow deleted successfully",
          duplicated: "Flow duplicated successfully",
        },
      },
      modals: {
        question: {
          titleCreate: "Add question to flow",
          titleEdit: "Edit question",
          fields: {
            message: "Message",
            answerKey: "Save answer as",
          },
        },
        text: {
          titleCreate: "Add message to flow",
          titleEdit: "Edit message",
          fields: {
            message: "Message",
          },
        },
        image: {
          titleCreate: "Add image to flow",
          titleEdit: "Edit image",
          buttons: {
            upload: "Upload image",
          },
          errors: {
            fileTooLarge: "File is too large. Max 2MB.",
          },
          toasts: {
            created: "Image added successfully.",
            updated: "Image updated successfully.",
          },
        },
        audio: {
          titleCreate: "Add audio to flow",
          titleEdit: "Edit audio",
          buttons: {
            upload: "Upload audio",
          },
          fields: {
            record: "Send as recorded audio",
          },
          fallback: "Your browser does not support HTML5",
          errors: {
            fileTooLarge: "File is too large. Max 5MB.",
          },
          toasts: {
            created: "Audio added successfully.",
            updated: "Audio updated successfully.",
          },
        },
        video: {
          titleCreate: "Add video to flow",
          titleEdit: "Edit video",
          buttons: {
            upload: "Upload video",
          },
          warnings: {
            onlyMp4: "WARNING: MP4 videos only.",
          },
          fallback: "Your browser does not support HTML5",
          errors: {
            fileTooLarge: "File is too large. Max 20MB.",
          },
          toasts: {
            created: "Video added successfully.",
            updated: "Video updated successfully.",
          },
        },
        openai: {
          titleCreate: "Add OpenAI/Gemini to flow",
          titleEdit: "Edit OpenAI/Gemini",
          voice: {
            text: "Text",
          },
        },
        interval: {
          titleCreate: "Add interval to flow",
          titleEdit: "Edit interval",
          fields: {
            seconds: "Time in seconds",
          },
          errors: {
            required: "Add an interval value.",
            maxSeconds: "Maximum time: 120 seconds.",
          },
        },
        condition: {
          titleCreate: "Add condition to flow",
          titleEdit: "Edit condition",
          fields: {
            key: "Condition field (type only 1 key)",
            rule: "Validation rule",
            value: "Condition value to analyze",
          },
        },
        ticket: {
          titleCreate: "Add queue to flow",
          titleEdit: "Edit queue",
          placeholders: {
            selectQueue: "Select a queue",
          },
          errors: {
            requiredQueue: "Please select a queue.",
          },
        },
        menu: {
          titleCreate: "Add menu to flow",
          titleEdit: "Edit menu",
          fields: {
            message: "Menu explanation message",
          },
          buttons: {
            addOption: "Add option",
          },
          optionPrompt: "Type {{number}}",
          placeholders: {
            option: "Type option",
          },
        },
        randomizer: {
          titleCreate: "Add randomizer to flow",
          titleEdit: "Edit randomizer",
          aria: {
            slider: "Percentage",
          },
          errors: {
            required: "Add a percentage.",
            maxPercent: "Maximum percentage: 100.",
          },
        },
        typebot: {
          titleCreate: "Add Typebot to flow",
          titleEdit: "Edit Typebot",
        },
        singleBlock: {
          titleCreate: "Add content to flow",
          titleEdit: "Edit content",
          elements: {
            text: "Text",
            interval: "Interval",
            image: "Image",
            audio: "Audio",
            video: "Video",
            document: "Document",
          },
          buttons: {
            uploadImage: "Upload image",
            uploadAudio: "Upload audio",
            uploadVideo: "Upload video",
            uploadDocument: "Upload document",
          },
          fields: {
            message: "Message",
            seconds: "Time in seconds",
            recordAudio: "Send as recorded audio",
            variables: "Variables",
          },
          file: {
            noFileSelected: "No file selected",
          },
          loading: {
            uploading: "Uploading files and creating content...",
          },
          toasts: {
            saved: "Content saved successfully.",
          },
          errors: {
            messageEmpty: "Message field is empty.",
            intervalInvalid: "Interval cannot be 0 or greater than 120.",
            fileTooLarge: "File is too large. Max {{maxMb}}MB.",
            pendingUploads: "Delete empty cards or upload pending files.",
          },
        },
      },
    },
    flowBuilderCanvas: {
      back: "Back",
      title: "FlowBuilder Canvas",
      testFlow: "Test Flow",
      save: "Save",
      alerts: {
        saved: "Flow saved successfully",
        saveError: "Error saving flow",
        testSoon: "Test function coming soon",
        confirmDeleteNode: "Are you sure you want to delete this node?",
      },
      nodeConfig: {
        sections: {
          basic: "Basic configuration",
          advanced: "Advanced options",
        },
        fields: {
          nodeName: "Node name",
          model: "Model",
          systemPrompt: "System Prompt",
          temperatureLabel: "Temperature: {{value}}",
          maxTokens: "Max Tokens",
          intents: "Possible intents (comma-separated)",
          confidenceLabel: "Confidence threshold: {{value}}",
          webhookUrl: "Webhook URL",
          httpMethod: "HTTP Method",
          requireAuth: "Require authentication",
          secretKey: "Secret key",
          scheduleType: "Schedule type",
          cronExpression: "Cron expression",
          messageTemplate: "Message template",
          includeMedia: "Include media",
          mediaUrl: "Media URL",
          emailSubject: "Subject",
          emailBody: "Email body (HTML)",
          fromEmail: "From email",
          conditionType: "Condition type",
          fieldToCheck: "Field to check",
          operator: "Operator",
          valueToCompare: "Value to compare",
          jsExpression: "JavaScript expression",
          continueOnError: "Continue on error",
          retryOnFailure: "Retry on failure",
        },
        placeholders: {
          nodeName: "Enter node name...",
          systemPrompt: "You are a helpful assistant...",
          intents: "buy, question, complaint...",
          secretKey: "Enter secret key...",
          cronExpression: "0 9 * * * (Every day at 9 AM)",
          messageTemplate: "Hi {{name}}, thanks for contacting us...",
          emailSubject: "Email subject...",
          emailBody: "<h1>Hello {{name}}</h1><p>...</p>",
          fieldToCheck: "e.g. user.age, message.text",
          valueToCompare: "Enter value...",
        },
        defaults: {
          intents: "buy, question, complaint, cancellation",
        },
        options: {
          scheduleType: {
            cron: "Cron expression",
            interval: "Interval",
            specific: "Specific date/time",
          },
          intervalUnit: {
            minutes: "Minutes",
            hours: "Hours",
            days: "Days",
          },
          conditionType: {
            simple: "Simple (A == B)",
            multiple: "Multiple (AND/OR)",
            expression: "JavaScript expression",
          },
          operator: {
            equals: "Equals (==)",
            notEquals: "Not equals (!=)",
            greater: "Greater than (>)",
            less: "Less than (<)",
            contains: "Contains",
            startsWith: "Starts with",
            endsWith: "Ends with",
          },
        },
        helpers: {
          temperature:
            "Higher values = more creative. Lower values = more deterministic.",
          cronExpression:
            'Example: "0 9 * * *" runs every day at 9:00 AM',
          variables: "Use {{variable}} for dynamic variables",
        },
        empty: {
          noSpecificConfig: "No specific configuration for this node type.",
          connectHelp: "Drag connections to link to other nodes.",
        },
        confirmDelete: "Delete this node?",
      },
    },
    kanban: {
      ticketLabel: "Ticket #{{id}}",
      filters: {
        startDate: "Start date",
        endDate: "End date",
      },
      toasts: {
        tagRemoved: "Tag removed from the ticket!",
        tagAdded: "Tag added to the ticket!",
      },
      actions: {
        search: "Search",
        viewTicket: "View Ticket",
        addColumns: "+ Add columns",
      },
    },
    moments: {
      title: "Service Dashboard",
    },
    todoList: {
      newTask: "New task",
      add: "Add",
      save: "Save",
    },
    facebookInstagram: {
      titleAll: "Facebook and Instagram",
      subtitle: "Manage your Meta integrations",
      actions: {
        newConnection: "New connection",
        connectFacebook: "Connect Facebook",
        connectInstagram: "Connect Instagram",
      },
      meta: {
        title: "Meta details (unique per client)",
        step1: "1. In Meta Developer, configure the Webhooks product using:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        copy: "Copy",
        step2: "2. Subscribe to the objects/fields:",
        objectWord: "object",
        fieldsWord: "fields",
        step3:
          "3. Once Meta verifies, you'll see the status saved in your app. Then, inbound messages will arrive in Tickets and you can reply from the chat.",
        user: "User:",
      },
      filters: {
        title: "Filters",
        searchLabel: "Search (name or ID)",
        category: "Category",
        from: "From",
        to: "To",
        inactiveShort: "Inact.",
      },
      table: {
        title: "Connections",
        empty: "No connections to display.",
        headers: {
          platform: "Platform",
          name: "Name",
          id: "ID",
          category: "Category",
          status: "Status",
          webhook: "Webhook",
          created: "Created",
          active: "Active",
          actions: "Actions",
        },
      },
      labels: {
        pageId: "Page ID",
        instagramAccountId: "Instagram Account ID",
      },
      status: {
        connected: "Connected",
        disconnected: "Disconnected",
        error: "Error",
        verified: "Verified",
        pending: "Pending",
      },
      tooltips: {
        edit: "Edit",
        disconnect: "Disconnect",
      },
      dialog: {
        newTitle: "New {{platform}} connection",
        editTitle: "Edit {{platform}} connection",
        info: "This screen creates a manual API connection. Paste the Access Token and the corresponding ID.",
        fields: {
          name: "Name",
          categoryOptional: "Category (optional)",
          accessToken: "Access Token",
          accessTokenEditHint: "Access Token (leave blank to keep current)",
        },
        saving: "Saving...",
      },
      validations: {
        selectValidChannel: "Select a valid channel",
        nameRequired: "Name is required",
        idRequired: "{{idLabel}} is required",
        accessTokenRequired: "Access Token is required",
      },
      confirm: {
        disconnect: "Are you sure you want to disconnect this account?",
      },
      toasts: {
        copied: "Copied",
        accountActivated: "Account activated successfully",
        accountDeactivated: "Account deactivated successfully",
        statusToggleError: "Error changing account status",
        disconnectSuccess: "Account disconnected successfully!",
        disconnectError: "Error disconnecting account",
        connectionUpdated: "Connection updated",
        connectionCreated: "Connection created",
        saveError: "Error saving connection",
      },
    },
    salesDashboard: {
      title: "Sales Dashboard",
      subtitle: "Welcome, {{name}} - Here's your performance",
      errors: {
        load: "Error loading sales data.",
      },
      metrics: {
        totalLeads: "Total leads",
        convertedClients: "Converted clients",
        totalRevenue: "Total revenue",
        ranking: "Seller ranking",
        thisMonth: "This month",
        cumulative: "Cumulative",
        conversionSubtitle: "{{rate}}% conversion",
        rankingSubtitle: "Top 3 of the team",
      },
      goal: {
        title: "Monthly goal",
        progress: "Progress: {{percent}}%",
        reached: "Goal achieved! 🎉",
        remaining: "{{amount}} left to reach the goal",
      },
      topProduct: {
        title: "Top-selling product",
        salesThisMonth: "{{count}} sales this month",
        conversionRate: "Conversion rate",
        avgValue: "Average value",
      },
      quickActions: {
        title: "Quick actions",
        viewLeads: "View my leads",
        registerClient: "Register client",
        commissions: "My commissions",
        aiSales: "AI for sales",
      },
    },
    teamDashboard: {
      title: "Team Dashboard",
      subtitle: "Monitor your sales team's performance",
      errors: {
        load: "Error loading team data.",
      },
      metrics: {
        teamMembers: "Team members",
        activeMembersSubtitle: "{{count}} active",
        teamRevenue: "Team revenue",
        thisMonth: "This month",
        topSeller: "Top seller",
        topSellerSubtitle: "Top performer",
        teamGoal: "Team goal",
      },
      goal: {
        title: "Team goal progress",
        completed: "{{percent}}% completed",
        reached: "🎉 Team goal achieved!",
        remaining: "{{amount}} left for the monthly goal",
      },
      table: {
        title: "Individual performance",
        headers: {
          seller: "Seller",
          leads: "Leads",
          conversions: "Conversions",
          revenue: "Revenue",
          goal: "Goal",
          performance: "Performance",
          status: "Status",
          actions: "Actions",
        },
      },
      status: {
        active: "Active",
        inactive: "Inactive",
      },
      tooltips: {
        viewDetails: "View details",
        call: "Call",
        email: "Email",
      },
      summary: {
        totalLeads: "Total team leads",
        totalConversions: "Total conversions",
        conversionRate: "Conversion rate",
      },
    },
    commission: {
      title: "My commissions",
      subtitle: "Manage and track your earnings",
      errors: {
        load: "Error loading commission data.",
      },
      defaults: {
        client: "Client",
        plan: "Plan",
      },
      period: {
        label: "Period",
        current: "Current month",
        last: "Last month",
        quarter: "Last quarter",
        year: "This year",
        selected: "Selected period",
      },
      metrics: {
        totalEarned: "Total earned",
        currentMonth: "Current month",
        pendingPayout: "Pending payout",
        paid: "Paid",
        cumulative: "Cumulative",
        rateSubtitle: "Rate: {{rate}}%",
        toProcess: "To be processed",
        processed: "Processed",
      },
      goal: {
        title: "Commission goal - {{period}}",
        progress: "Progress: {{percent}}%",
        reached: "🎉 Goal achieved! Great job",
        remaining: "{{amount}} left to reach your monthly goal",
        rateLabel: "Commission rate",
      },
      table: {
        title: "Commission history",
        headers: {
          client: "Client",
          plan: "Plan",
          saleValue: "Sale value",
          commission: "Commission",
          status: "Status",
          date: "Date",
        },
      },
      status: {
        paid: "Paid",
        pending: "Pending",
      },
      summary: {
        totalPaid: "Total paid commissions",
        totalPending: "Total pending commissions",
      },
    },
    checkout: {
      steps: {
        data: "Data",
        customize: "Customize",
        review: "Review",
      },
      gateways: {
        steps: {
          selectPlan: "Select plan",
          paymentMethod: "Payment method",
          confirm: "Confirm",
        },
        errors: {
          loadPlans: "Unable to load plans.",
          missingCustomerInfo: "Please enter your name and email.",
          initMercadoPago: "Unable to start payment with MercadoPago.",
          processPayment: "Error processing payment.",
        },
        title: "Upgrade your plan",
        subtitle: "Choose the perfect plan for your business",
        billing: {
          monthly: "Monthly",
          yearly: "Yearly",
          freeMonths: "{{count}} months free",
        },
        plan: {
          mostPopular: "Most popular",
          perMonth: "/mo",
          perYear: "/yr",
          savings: "You save {{amount}}",
          limits: {
            messagesPerMonth: "{{value}} messages/month",
            channels: "{{value}} channels",
            users: "{{value}} users",
          },
        },
        billingInfo: {
          title: "Billing information",
          fullName: "Full name",
          email: "Email",
        },
        summary: {
          title: "Summary",
          plan: "Plan {{plan}}",
          cycle: "Cycle: {{cycle}}",
        },
        paymentMethod: {
          title: "Payment method",
          mercadoPago: "MercadoPago (Peru)",
          paypal: "PayPal (International)",
        },
        buttons: {
          payWithMercadoPago: "Pay with MercadoPago",
          payWithPayPal: "Pay with PayPal",
        },
        securityHint: "Secure payment. You can cancel anytime.",
      },
      header: "Almost there!",
      notFound: "Not found.",
      buttons: {
        pay: "Pay",
        select: "Select",
        increase: "Increase",
        decrease: "Decrease",
      },
      paymentHint: "After making the payment, refresh the page.",
      toasts: {
        subscriptionCreatedWaiting:
          "Subscription created successfully. Waiting for payment confirmation.",
      },
      form: {
        fullName: {
          label: "Full name*",
          required: "Full name is required",
        },
        lastName: {
          label: "Last name*",
          required: "Last name is required",
        },
        address: {
          label: "Address*",
          required: "Address is required",
        },
        city: {
          label: "City*",
          required: "City is required",
        },
        state: {
          label: "State/Province*",
          required: "State/Province is required",
        },
        document: {
          label: "CPF/CNPJ*",
          required: "Document is required",
          invalid: "Invalid document format",
        },
        country: {
          label: "Country*",
          required: "Country is required",
        },
        useAddressForPaymentDetails: {
          label: "Use this address for payment details",
        },
        nameOnCard: {
          label: "Name on card*",
          required: "Name on card is required",
        },
        cardNumber: {
          label: "Card number*",
          required: "Card number is required",
          invalid: "Card number is not valid (e.g. 4111111111111)",
        },
        expiryDate: {
          label: "Expiry date*",
          required: "Expiry date is required",
          invalid: "Expiry date is not valid",
        },
        cvv: {
          label: "CVV*",
          required: "CVV is required",
          invalid: "CVV is invalid (e.g. 357)",
        },
      },
      plan: {
        perMonth: "/month",
        users: "{{count}} Users",
        connections: "{{count}} Connections",
        queues: "{{count}} Queues",
      },
      review: {
        title: "Subscription summary",
        planDetails: {
          title: "Plan details",
          users: "Users: {{count}}",
          connections: "Connections: {{count}}",
          queues: "Queues: {{count}}",
          billing: "Billing: Monthly",
        },
        paymentInfo: {
          title: "Payment information",
          document: "CPF/CNPJ",
          total: "Total",
        },
      },
      success: {
        total: "TOTAL",
        copyQrCode: "Copy QR code",
        instructions:
          "To finish, pay by scanning or pasting the Pix code above.",
        licenseRenewed: "Your license has been renewed until {{date}}!",
      },
    },
    modulesManager: {
      table: {
        key: "Key",
        category: "Category",
        addon: "Addon",
      },
      toasts: {
        loadError: "Could not load modules.",
        saved: "Module saved.",
        saveError: "Could not save module.",
        deactivated: "Module deactivated.",
        deactivateError: "Could not deactivate module.",
      },
      confirm: {
        deactivateTitle: "Deactivate module",
        deactivateMessage: "Do you want to deactivate this module?",
      },
    },
    flowImportModal: {
      title: "Import flow",
      instructions: "Select a .zip file exported by Flowbuilder.",
      noFile: "No file selected",
      buttons: {
        chooseFile: "Choose file",
        import: "Import",
      },
      toasts: {
        selectZip: "Select a .zip file",
        success: "Flow imported successfully.",
        error: "Error importing flow.",
      },
    },
    chatList: {
      confirm: {
        deleteTitle: "Delete conversation",
        deleteMessage: "This action cannot be undone. Confirm?",
      },
    },
    planModulesManager: {
      form: {
        plan: "Plan",
      },
      table: {
        module: "Module",
        category: "Category",
        included: "Included",
      },
      buttons: {
        saveChanges: "Save changes",
      },
      toasts: {
        plansLoadError: "Could not load plans.",
        modulesLoadError: "Could not load plan modules.",
        saved: "Plan modules updated.",
        saveError: "Could not save plan modules.",
      },
    },
    companyModulesManager: {
      table: {
        module: "Module",
        category: "Category",
        plan: "Plan",
        override: "Override",
        effective: "Effective",
      },
      override: {
        plan: "Use plan",
        enable: "Enable",
        disable: "Disable",
      },
      buttons: {
        saveChanges: "Save changes",
      },
      toasts: {
        companiesLoadError: "Could not load companies.",
        modulesLoadError: "Could not load company modules.",
        saved: "Company modules updated.",
        saveError: "Could not update modules.",
      },
    },
    contactNotesDialog: {
      toasts: {
        added: "Note added successfully.",
        deleted: "Note deleted successfully.",
      },
      confirm: {
        deleteTitle: "Delete record",
        deleteMessage: "Do you really want to delete this record?",
      },
    },
    contacts: {
      menu: {
        importExport: "Import / Export",
      },
      importPage: {
        title: "Import contacts from file",
      },
      toasts: {
        batchDeleted: "Selected contacts deleted.",
        blocked: "Contact blocked.",
        unblocked: "Contact unblocked.",
      },
      confirmationModal: {
        blockTitle: "Block {{name}}",
        unblockTitle: "Unblock {{name}}",
        chooseConnectionToImport:
          "Choose which connection to import contacts from.",
        batchDeleteTitle: "Delete {{count}} contacts",
        batchDeleteMessage:
          "Do you really want to delete the selected contacts? This action cannot be undone.",
      },
      buttons: {
        deleteSelected: "Delete selected ({{count}})",
      },
      accessibility: {
        selectAll: "Select all contacts",
        selectContact: "Select contact {{name}}",
      },
    },
    contactImport: {
      validateWhatsapp: "Validate contacts on WhatsApp",
      uploading: "Importing... please wait",
      buttons: {
        importContacts: "Import contacts",
      },
      fields: {
        name: "Name",
        number: "Number",
        email: "Email",
        tags: "Tags",
      },
      errors: {
        missingNumberField: 'Select the column for the "Number" field.',
        missingNameField: 'Select the column for the "Name" field.',
        noContactsSelected: "Select at least one contact to import.",
        fieldAlreadySelected: "The field {{field}} is already selected.",
      },
      toasts: {
        success: "Contacts imported successfully.",
        successWithErrors:
          "Import completed with warnings. Some contacts were ignored.",
      },
      summary: {
        created: "{{count}} contacts created",
        ignored:
          "{{count}} contacts ignored (invalid number or not marked to update)",
      },
      file: {
        processing: "Processing file...",
        invalid: "Invalid file!",
      },
      dropzone: {
        title: "Click or drag a file",
        note:
          "* Important: only files with the following extensions are accepted: xls, xlsx, csv, txt",
      },
      alt: {
        upload: "Upload file",
      },
    },
    slaPolicies: {
      title: "SLA by channel",
      description:
        "Configure first response, next response, and resolution times by channel.",
      fields: {
        firstResponseMinutes: "First response (min)",
        nextResponseMinutes: "Next response (min)",
        resolutionMinutes: "Resolution (min)",
      },
      buttons: {
        save: "Save SLA",
      },
      toasts: {
        loadError: "Error loading SLA.",
        saved: "SLA updated.",
        saveError: "Error saving SLA.",
      },
    },
    ticketMessagesDialog: {
      errors: {
        exportTargetNotFound: "Element not found to export.",
      },
      buttons: {
        exportPdf: "Export to PDF",
      },
    },
    reports: {
      buttons: {
        exportExcel: "Export to Excel",
      },
    },
    campaignPhraseModal: {
      title: {
        create: "Create phrase campaign",
        edit: "Edit phrase campaign",
      },
      fields: {
        name: "Name",
        flow: "Flow",
        phrase: "Phrase",
      },
      placeholders: {
        flow: "Select a flow",
        connection: "Select a connection",
      },
      buttons: {
        createCampaign: "Create campaign",
        saveCampaign: "Save campaign",
      },
      toasts: {
        created: "Campaign created successfully.",
        updated: "Campaign updated successfully.",
      },
    },
    colorBoxModal: {
      title: "Select color",
    },
    editMessageModal: {
      title: "Edit message",
      placeholders: {
        message: "Type the message...",
      },
      aria: {
        messageInput: "Edited message",
      },
    },
    flowDefault: {
      title: "Default flows",
      confirm: {
        deleteMessage: "Do you really want to delete this flow?",
      },
      sections: {
        welcome: {
          title: "Welcome flow",
          description: "Select the flow to send at the start of a conversation.",
        },
        defaultReply: {
          title: "Default reply flow",
          description:
            "Select the flow to use when there is no phrase match.",
        },
      },
      placeholders: {
        selectFlow: "Select a flow",
      },
      toasts: {
        deleted: "Flow deleted successfully.",
        updated: "Default flows updated.",
      },
    },
    campaignsConfig: {
      sections: {
        intervals: "Intervals",
      },
      errors: {
        noPermissionRedirect:
          "This company does not have permission to access this page. Redirecting you.",
      },
    },
    campaigns: {
      settings: {
        seconds: "seconds",
      },
      dialog: {
        tabs: {
          message: "Message {{number}}",
        },
      },
      table: {
        notScheduled: "Not scheduled",
        notCompleted: "Not completed",
      },
      status: {
        inactive: "Inactive",
        scheduled: "Scheduled",
        running: "Running",
        canceled: "Canceled",
        completed: "Completed",
      },
      actions: {
        stop: "Stop campaign",
        restart: "Restart campaign",
      },
    },
    flowBuilderConfig: {
      title: "Design your flow",
      reminder: "Don't forget to save your flow!",
      aria: {
        speedDial: "Add node",
      },
      toasts: {
        saved: "Flow saved successfully.",
      },
      actions: {
        start: "Start",
        content: "Content",
        menu: "Menu",
        randomizer: "Randomizer",
        interval: "Interval",
        ticket: "Queue",
        typebot: "TypeBot",
        openai: "OpenAI",
        question: "Question",
      },
      fallback: {
        html5: "Your browser does not support HTML5",
      },
      units: {
        seconds: "seconds",
      },
      nodes: {
        start: {
          title: "Start of flow",
          description: "This block marks the start of your flow.",
        },
        message: {
          title: "Message",
        },
        interval: {
          title: "Interval",
          seconds: "{{seconds}} seconds",
        },
        menu: {
          title: "Menu",
        },
        randomizer: {
          title: "Randomizer",
        },
        audio: {
          title: "Audio",
          recordedNow: "Recorded now",
          sent: "Audio sent",
        },
        image: {
          title: "Image",
          previewAlt: "Image preview",
        },
        video: {
          title: "Video",
        },
        condition: {
          title: "Condition",
        },
        singleBlock: {
          title: "Content",
        },
        ticket: {
          title: "Queue",
        },
        typebot: {
          title: "TypeBot",
          iconAlt: "TypeBot icon",
        },
        openai: {
          title: "OpenAI/Gemini",
        },
        question: {
          title: "Question",
        },
      },
    },
    flowBuilderModal: {
      title: {
        create: "Add flow",
        edit: "Edit flow",
      },
    },
    buttonModal: {
      title: "Select an option",
      select: {
        placeholder: "Select",
      },
      options: {
        list: "List",
        copy: "Copy",
        callMe: "Call me",
      },
      fields: {
        title: "Title",
        description: "Description",
        message: "Message",
        buttonText: "Button text",
        url: "URL",
        copyText: "Text to copy",
        phone: "Phone",
        value: "Value",
        image: "Image",
        name: "Name",
      },
      buttons: {
        addOption: "Add new option",
      },
      list: {
        optionLabel: "Option {{number}}",
        defaultSectionTitle: "Options",
        defaultButtonText: "Click here",
      },
      url: {
        defaults: {
          title: "URL button",
          description: "Message with button",
          buttonText: "Open link",
          url: "https://example.com",
        },
      },
      pix: {
        keyType: {
          placeholder: "Key type",
          phone: "Phone",
          email: "Email",
          random: "Random key",
        },
        fields: {
          key: "Pix key",
        },
      },
      errors: {
        invalidTicketId: "Invalid ticket ID.",
        noOptionSelected: "Select an option.",
        processMessage: "Error processing the message.",
      },
    },
    queueOptions: {
      title: "Options",
      placeholders: {
        title: "Option title",
        message: "Type the option text",
      },
      fallback: {
        undefinedTitle: "Title not defined",
      },
    },
    nodePalette: {
      title: "Available Nodes",
      nodeCount: "{{count}} professional nodes",
      searchPlaceholder: "Search nodes...",
      noResults: {
        title: "No nodes found",
        subtitle: "Try a different term",
      },
      categories: {
        trigger: {
          name: "Triggers",
          description: "Start your flow automatically",
        },
        ai: {
          name: "AI & Machine Learning",
          description: "Advanced artificial intelligence",
        },
        crm: {
          name: "CRM & Sales",
          description: "Customer and sales management",
        },
        ecommerce: {
          name: "E-commerce & Payments",
          description: "Online stores and payments",
        },
        communication: {
          name: "Communication",
          description: "Messaging and communication",
        },
        database: {
          name: "Databases & Storage",
          description: "Databases and storage",
        },
        storage: {
          name: "Cloud & File Storage",
          description: "Cloud storage",
        },
        analytics: {
          name: "Analytics & Tracking",
          description: "Analytics and metrics",
        },
        marketing: {
          name: "Marketing & Advertising",
          description: "Marketing and advertising",
        },
        logic: {
          name: "Logic & Flow Control",
          description: "Flow control and logic",
        },
        transform: {
          name: "Data Transformation",
          description: "Data transformation",
        },
        action: {
          name: "Actions & Automation",
          description: "Actions and automation",
        },
      },
    },
    allConnections: {
      table: {
        customer: "Customer",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
      },
    },
    webhooksPage: {
      title: "Webhooks",
      soon: "Coming soon.",
    },
    helps: {
      settings: {
        title: "Title",
      },
    },
    plans: {
      form: {
        queues: "Queues",
        amount: "Amount",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        internalChat: "Internal chat",
        externalApi: "External API",
        kanban: "Kanban",
        openAi: "OpenAI",
        integrations: "Integrations",
      },
    },
    invoices: {
      table: {
        status: "Status",
        idLabel: "ID: {{id}}",
      },
      tooltips: {
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        dueDate: "Due date",
      },
      status: {
        paid: "Paid",
        overdue: "Overdue",
        open: "Open",
      },
      actions: {
        pay: "Pay",
        payNow: "Pay now",
      },
      daysLeft: {
        overdueOne: "Overdue by {{days}} day",
        overdueMany: "Overdue by {{days}} days",
        dueToday: "Due today",
        dueInOne: "Due in {{days}} day",
        dueInMany: "Due in {{days}} days",
      },
    },
    buttonPreview: {
      toasts: {
        codeCopied: "Code copied.",
      },
      errors: {
        noContentToCopy: "No content to copy.",
        noLinkAvailable: "No link available.",
        callsNotSupported: "Calls are not supported in this preview.",
      },
      empty: {
        noButtonsInSection: "No buttons in this section.",
        noSectionsAvailable: "No sections available.",
      },
      alt: {
        preview: "Preview",
      },
    },
    schedules: {
      calendar: {
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All day",
        week: "Week",
        workWeek: "Work week",
        day: "Day",
        month: "Month",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in range.",
        showMore: "+{{total}} more",
      },
    },
    layout: {
      errors: {
        accountAccessedElsewhere:
          "This user is already logged in on another device. You will be signed out.",
      },
    },
    messageOptionsMenu: {
      toasts: {
        reactionSent: "Reaction sent.",
      },
    },
    newTicketModal: {
      placeholders: {
        queue: "Select a queue",
        connection: "Select a connection",
      },
      errors: {
        queueRequired: "Select a queue to continue.",
      },
    },
    analytics: {
      title: "Analytics",
      subtitle: "Business metrics and trends",
      toasts: {
        loadError: "Error loading analytics.",
      },
      period: {
        label: "Period",
        options: {
          week: "Week",
          month: "Month",
          quarter: "Quarter",
          year: "Year",
        },
      },
      metrics: {
        totalRevenue: "Total revenue",
        totalLeads: "Total leads",
        conversionRate: "Conversion rate",
        avgDealSize: "Average deal size",
        vsPreviousPeriod: "{{value}}% vs previous period",
      },
      monthlyTrends: {
        title: "Monthly trends",
        revenueTrend: "Revenue trend",
        table: {
          month: "Month",
          leads: "Leads",
          conversions: "Conversions",
          conversionRate: "Conversion rate",
          revenue: "Revenue",
        },
      },
      topProducts: {
        title: "Top products",
        salesLabel: "{{count}} sales",
      },
      leadSources: {
        title: "Lead sources",
        countLabel: "{{count}} leads",
      },
    },
    campaignsPhrase: {
      toasts: {
        deleted: "Phrase deleted successfully.",
      },
    },
    messagesAPI: {
      toasts: {
        sent: "Message sent successfully.",
      },
      labels: {
        endpoint: "Endpoint",
        method: "Method",
        headers: "Headers",
        body: "Body",
        formData: "FormData",
        testSend: "Test send",
      },
      docs: {
        headers: {
          json: "Authorization: Bearer (registered token) and Content-Type (application/json)",
          formData:
            "Authorization: Bearer (registered token) and Content-Type (multipart/form-data)",
        },
        fields: {
          userIdHint: "User/agent ID or \"\"",
          queueIdHint: "Queue ID or \"\"",
          mediasHint: "file",
          sendSignatureHint: "Sign message - true/false",
          closeTicketHint: "Close ticket - true/false",
        },
      },
    },
    messageModal: {
      title: {
        add: "New scheduled message",
        edit: "Edit scheduled message",
      },
      success: {
        save: "Scheduled message saved.",
      },
      placeholders: {
        connection: "Connection",
        contacts: "Contacts",
        users: "Users",
      },
      form: {
        createTicket: "Create ticket",
      },
    },
    listPreview: {
      modal: {
        title: "Button list",
      },
      fields: {
        selectedTitlePlaceholder: "Selected title",
      },
      a11y: {
        selectedTitle: "selected title",
      },
      alerts: {
        selectTitle: "Please select a title.",
        ticketIdNotFound: "Error: ticketId not found.",
        sendError: "Error sending the message. Please try again.",
      },
    },
    scheduleModal: {
      statusTitle: {
        sendError: "Send error",
        messageWithStatus: "Message {{status}}",
      },
    },
  },
  pt: {
    common: {
      save: "Salvar",
      cancel: "Cancelar",
      back: "Voltar",
      next: "Próximo",
      previous: "Anterior",
      create: "Criar",
      update: "Atualizar",
      add: "Adicionar",
      edit: "Editar",
      import: "Importar",
      export: "Exportar",
      confirm: "Confirmar",
      close: "Fechar",
      delete: "Excluir",
      duplicate: "Duplicar",
      refresh: "Atualizar",
      search: "Buscar",
      configure: "Configurar",
      upgradePlan: "Melhorar plano",
      company: "Empresa",
      package: "Pacote",
      assignCredits: "Atribuir créditos",
      copied: "Copiado",
      yes: "Sim",
      no: "Não",
      active: "Ativo",
      inactive: "Inativo",
      actions: "Ações",
      status: "Status",
      source: "Origem",
      date: "Data",
      id: "ID",
      name: "Nome",
      email: "E-mail",
      phone: "Telefone",
      notes: "Notas",
      description: "Descrição",
      price: "Preço",
      tokens: "Tokens",
      clear: "Limpar",
      deactivate: "Desativar",
      activate: "Ativar",
      anErrorOccurred: "Ocorreu um erro.",
      loading: "Carregando...",
      ok: "OK",
      total: "Total",
      other: "Outro",
      send: "Enviar",
      chat: "Conversar",
      placeholders: {
        emailAddress: "Endereço de e-mail",
      },
      alt: {
        thumbnail: "Miniatura",
      },
      validation: {
        required: "Obrigatório.",
        tooShort: "Muito curto.",
        tooLong: "Muito longo.",
        passwordRequired: "Senha é obrigatória.",
        invalidEmail: "Email inválido.",
        apiKeyRequired: "A API Key é obrigatória.",
        voiceModeRequired: "O modo de voz é obrigatório.",
        ratingRequired: "Avaliação obrigatória.",
        passwordsMustMatch: "As senhas devem coincidir.",
        invalidOption: "Opção inválida.",
        minValue: "Mínimo {{min}}.",
        maxValue: "Máximo {{max}}.",
      },
      errors: {
        loadRecords: "Não foi possível carregar a lista de registros.",
        noPermissionRedirect:
          "Esta empresa não possui permissão para acessar esta página. Estamos redirecionando você.",
        operationFailed: "Não foi possível concluir a operação.",
        operationFailedDuplicateOrInvalid:
          "Não foi possível concluir a operação. Verifique os dados e tente novamente.",
      },
      toasts: {
        success: "Operação realizada com sucesso.",
        clickSaveToApplyChanges: 'Clique em "Salvar" para aplicar as alterações.',
      },
      confirmationModal: {
        deleteTitle: "Excluir registro",
        deleteMessage: "Deseja realmente excluir este registro?",
      },
    },
    backendErrors: {
      plan_limit_exceeded:
        "Você atingiu o limite de conexões da sua assinatura. Atualize seu plano para adicionar mais.",
    },
    connections: {
      table: {
        channel: "Canal",
      },
    },
    compaies: {
      table: {
        folderSize: "Tamanho da pasta",
        totalFiles: "Total de arquivos",
        lastFolderUpdate: "Última atualização da pasta",
      },
    },
    qrCode: {
      waiting: "Aguardando o QR Code",
    },
    chatbots: {
      toasts: {
        saved: "Chatbot salvo com sucesso.",
        deleted: "Chatbot excluído com sucesso.",
      },
      confirmationModal: {
        deleteMessage:
          "Tem certeza? Todas as opções internas também serão excluídas.",
      },
      validation: {
        optionNameMin: "O nome da opção deve ter pelo menos 4 caracteres.",
        optionNameRequired: "O nome da opção é obrigatório.",
        optionsRequired: "Você deve adicionar pelo menos uma opção.",
      },
    },
    contactImportWpModal: {
      status: {
        completed: "Importação concluída com sucesso.",
        inProgress:
          "Importação em andamento {{current}} de {{total}}. Não saia desta tela até concluir a importação.",
      },
    },
    tagsKanban: {
      form: {
        stage: "Etapa Kanban",
      },
    },
    filters: {
      placeholders: {
        contacts: "Contatos",
        connections: "Conexões",
        departments: "Departamentos",
        statusFilter: "Filtro por status",
        tagsFilter: "Filtro por tags",
        tags: "Tags",
      },
    },
    tagsContainer: {
      errors: {
        tooShort: "Tag muito curta!",
      },
    },
    tickets: {
      search: {
        filterConectionsOptions: {
          groups: "Grupos",
        },
      },
      simulateIncoming: {
        channelFallback: "canal",
        body: "Mensagem de teste ({{channel}})",
        menuLabel: "Simular mensagem recebida",
        toasts: {
          success: "Mensagem recebida simulada.",
        },
      },
    },
    messageUploadMedias: {
      placeholders: {
        caption: "Legenda (opcional)",
      },
      fallback: {
        unavailable: "Visualização não disponível",
      },
      alt: {
        image: "Imagem {{index}}",
      },
    },
    ticket: {
      chat: {
        searchPlaceholder: "Buscar neste chat...",
      },
    },
    messagesList: {
      deletedMessage: "🚫 _Mensagem apagada_",
      deletedText: "🚫 Esta mensagem foi apagada",
      deletedByContactText: "🚫 Esta mensagem foi apagada pelo contato",
      forwarded: "Encaminhada",
      reacted: "Você reagiu... {{reaction}}",
      editedAt: "Editada {{time}}",
      empty: {
        startConversation: "Diga olá para seu novo contato!",
      },
      dragDrop: {
        dropHere: "Solte o arquivo aqui",
      },
      facebookPolicy24h:
        "Você tem 24h para responder após receber uma mensagem, de acordo com as políticas do Facebook.",
    },
    recurrence: {
      title: "Recorrência",
      description:
        "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
      interval: {
        label: "Intervalo",
        valueLabel: "Valor do intervalo",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      sendCount: {
        label: "Enviar quantas vezes",
      },
      businessDaysPolicy: {
        label: "Dias não úteis",
        options: {
          normal: "Enviar normalmente em dias não úteis",
          before: "Enviar um dia útil antes",
          after: "Enviar um dia útil depois",
        },
      },
      showUser: "Mostrar usuário",
    },
    whatsappModal: {
      flowbuilder: {
        welcomeFlow: {
          title: "Fluxo de boas-vindas",
          description:
            "Este fluxo é disparado apenas para novos contatos: pessoas que você não possui na sua lista de contatos e que enviaram uma mensagem.",
        },
        defaultResponseFlow: {
          title: "Fluxo de resposta padrão",
          description:
            "A resposta padrão é enviada com qualquer caractere diferente de uma palavra-chave. Atenção: será disparada se o atendimento já estiver fechado.",
        },
      },
    },
    ticketsList: {
      preview: {
        title: "Espiando a conversa",
      },
      loadingMessages: "Carregando mensagens...",
      tooltips: {
        previewConversation: "Espiar conversa",
      },
      adClick: "Clique de anúncio",
    },
    userModal: {
      form: {
        profiles: {
          admin: "Administrador",
          user: "Usuário",
        },
      },
    },
    contactNotesEditModal: {
      title: "Editar nota",
      fields: {
        note: "Nota",
      },
    },
    updateNotification: {
      title: "Nova versão disponível!",
      subtitle: "Há uma atualização do sistema disponível.",
      versionLabel: "Versão: {{version}}",
      instruction: 'Clique em "Atualizar agora" para carregar a nova versão.',
      buttons: {
        later: "Mais tarde",
        updateNow: "Atualizar agora",
      },
    },
    settings: {
      tabs: {
        sla: "SLA",
        schedules: "Horários",
        companies: "Empresas",
        modules: "Módulos",
        planModules: "Plano-Módulos",
        companyModules: "Módulos da Empresa",
        aiTokens: "Tokens IA",
        whitelabel: "Whitelabel",
      },
      settings: {
        customMessages: {
          transferMessageDefault:
            `Seu atendimento foi transferido para o setor \${queue.name}. Aguarde atendimento, por favor...`,
        },
        options: {
          text: "Texto",
        },
      },
      whitelabel: {
        fields: {
          primaryColorLight: "Cor primária (modo claro)",
          primaryColorDark: "Cor primária (modo escuro)",
          systemName: "Nome do sistema",
          logoLight: "Logo claro",
          logoDark: "Logo escuro",
          favicon: "Favicon",
        },
        errors: {
          uploadImage: "Não foi possível enviar a imagem.",
        },
      },
    },
    aiTokens: {
      title: "Tokens IA",
      packages: {
        form: {
          name: "Nome",
          tokens: "Tokens",
          price: "Preço",
          active: "Ativo",
        },
        table: {
          name: "Nome",
          tokens: "Tokens",
          price: "Preço",
          active: "Ativo",
        },
        buttons: {
          clear: "Limpar",
          save: "Salvar",
          deactivate: "Desativar",
          assignCredits: "Atribuir créditos",
        },
        credit: {
          company: "Empresa",
          package: "Pacote IA",
        },
        confirm: {
          deactivateTitle: "Desativar pacote",
          deactivateMessage: "Deseja desativar este pacote de IA?",
        },
        toasts: {
          companiesLoadError: "Não foi possível carregar as empresas.",
          packagesLoadError: "Não foi possível carregar os pacotes.",
          packageSaved: "Pacote salvo.",
          packageSaveError: "Não foi possível salvar o pacote.",
          packageDeactivated: "Pacote desativado.",
          packageDeactivateError: "Não foi possível desativar o pacote.",
          selectCompanyAndPackage: "Selecione empresa e pacote.",
          creditsAssigned: "Créditos de IA atribuídos.",
          creditsAssignError: "Não foi possível atribuir créditos.",
        },
      },
    },
    leads: {
      title: "Gestão de Leads",
      subtitle: "Gerencie suas oportunidades de venda",
      buttons: {
        refresh: "Atualizar",
        new: "Novo Lead",
        cancel: "Cancelar",
        create: "Criar",
        update: "Atualizar",
      },
      stats: {
        total: "Total de Leads",
        new: "Novos",
        qualified: "Qualificados",
        contacted: "Contatados",
      },
      filters: {
        searchPlaceholder: "Buscar leads...",
        status: "Status",
        source: "Origem",
        all: "Todos",
        allFeminine: "Todas",
      },
      table: {
        name: "Nome",
        contact: "Contato",
        status: "Status",
        source: "Origem",
        score: "Score",
        date: "Data",
        actions: "Ações",
        empty: "Nenhum lead para mostrar",
      },
      pagination: {
        rowsPerPage: "Linhas por página",
        displayedRows: "{{from}}-{{to}} de {{count}}",
        moreThan: "mais de {{to}}",
      },
      dialog: {
        addTitle: "Novo Lead",
        editTitle: "Editar Lead",
      },
      form: {
        name: "Nome",
        nameRequired: "Nome é obrigatório",
        email: "E-mail",
        phone: "Telefone",
        phonePlaceholder: "+51987654321",
        status: "Status",
        source: "Origem",
        score: "Score (0-100)",
        notes: "Notas",
      },
      confirm: {
        delete: "Tem certeza que deseja excluir este lead?",
      },
      status: {
        new: "Novo",
        contacted: "Contatado",
        qualified: "Qualificado",
        converted: "Convertido",
        lost: "Perdido",
      },
      sources: {
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        website: "Site",
        referral: "Indicação",
        cold_call: "Ligação",
        email: "E-mail",
        other: "Outro",
      },
      contactActions: {
        whatsapp: "WhatsApp",
        call: "Ligar",
        email: "E-mail",
      },
      toasts: {
        loadError: "Erro ao carregar leads.",
        saveError: "Erro ao salvar lead.",
        deleteError: "Erro ao excluir lead.",
        updated: "Lead atualizado com sucesso.",
        created: "Lead criado com sucesso.",
        deleted: "Lead excluído com sucesso.",
      },
    },
    abTesting: {
      title: "Testes A/B IA",
      subtitle: "Otimize as respostas de IA com experimentos controlados",
      actions: {
        refresh: "Atualizar",
      },
      errors: {
        loadData: "Erro ao carregar os dados de A/B Testing",
      },
      stats: {
        totalExperiments: "Total de Experimentos",
        activeLabel: "{{count}} ativos",
        totalImpressions: "Impressões Totais",
        conversions: "Conversões",
        conversionRate: "Taxa de Conversão",
      },
      table: {
        title: "Experimentos",
        idLabel: "ID: {{id}}",
        headers: {
          experiment: "Experimento",
          description: "Descrição",
          variants: "Variantes",
          impressions: "Impressões",
          status: "Status",
          actions: "Ações",
        },
        status: {
          active: "Ativo",
          stopped: "Interrompido",
        },
        tooltips: {
          viewDetails: "Ver detalhes",
          stopExperiment: "Parar experimento",
        },
      },
      dialog: {
        progressTitle: "Progresso do Experimento",
        samples: "{{count}} amostras",
        goal: "Meta: {{count}}",
        significant: "O experimento atingiu significância estatística",
        winnerTitle: "Vencedor atual: {{name}}",
        score: "Score: {{score}}",
        variantsTitle: "Variantes",
        variantsHeaders: {
          variant: "Variante",
          impressions: "Impressões",
          conversions: "Conversões",
          conversionRate: "Taxa Conv.",
          satisfaction: "Satisfação",
          escalations: "Escalonamentos",
        },
        control: "Controle",
        actions: {
          close: "Fechar",
          stop: "Parar experimento",
        },
      },
    },
    registerClient: {
      title: "Registrar Novo Cliente",
      subtitle: "Preencha as informações para cadastrar um novo cliente",
      steps: {
        company: "Dados da Empresa",
        contact: "Pessoa de Contato",
        plan: "Plano e Serviços",
      },
      industries: {
        retail: "Varejo",
        restaurant: "Restaurante",
        healthcare: "Saúde",
        education: "Educação",
        technology: "Tecnologia",
        services: "Serviços",
        ecommerce: "E-commerce",
        realEstate: "Imobiliário",
        other: "Outro",
      },
      company: {
        title: "Informações da Empresa",
        fields: {
          name: "Nome da Empresa",
          industry: "Setor",
          email: "E-mail da Empresa",
          phone: "Telefone da Empresa",
          address: "Endereço",
          website: "Site",
        },
      },
      contact: {
        title: "Pessoa de Contato",
        fields: {
          name: "Nome completo",
          position: "Cargo/Posição",
          email: "E-mail do Contato",
          phone: "Telefone do Contato",
        },
      },
      plan: {
        title: "Selecionar Plano",
        includes: {
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
        },
        perMonth: "/mês",
        billingCycle: "Ciclo de Cobrança",
        billingMonthly: "Mensal",
        billingAnnual: "Anual (2 meses grátis)",
      },
      addons: {
        title: "Serviços Adicionais",
        pricePerMonth: `+\${{amount}}/mês`,
      },
      notes: {
        title: "Notas Adicionais",
        placeholder: "Adicione qualquer nota ou comentário sobre este cliente...",
      },
      total: {
        label: "Total a Faturar",
        perYear: "/ano",
        perMonth: "/mês",
      },
      buttons: {
        back: "Voltar",
        next: "Próximo",
        submit: "Registrar Cliente",
      },
      toasts: {
        stepCompanyRequired: "Por favor, preencha todos os campos obrigatórios.",
        stepContactRequired: "Por favor, preencha os dados do contato.",
        success: "Cliente registrado com sucesso!",
        error: "Erro ao registrar cliente.",
      },
    },
    subscription: {
      free: "Grátis",
      license: {
        noExpiration: "Sem vencimento",
        expiresToday: "Sua licença vence hoje",
        expiredOn: "Licença vencida em {{date}}",
        expiresIn: "Sua licença vence em {{days}} {{dayWord}} ({{date}})",
        day: "dia",
        days: "dias",
      },
      fields: {
        dueDate: "Vencimento",
        billingEmail: "E-mail de cobrança",
        currentPlan: "Plano atual",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        price: "Preço",
      },
      upgrade: {
        title: "Melhorar plano",
        button: "Atualizar plano",
        updating: "Atualizando...",
      },
      contact: {
        button: "Assinar agora",
      },
      toasts: {
        planUpdated: "Plano atualizado com sucesso.",
      },
    },
    configApis: {
      title: "Conectar APIs",
      channels: {
        whatsappTitle: "WhatsApp Cloud API",
        facebookTitle: "Facebook Messenger",
        instagramTitle: "Instagram Messaging",
      },
      summary: {
        title: "Resumo",
        activeConnections: "Conexões ativas (APIs Meta):",
        planLimit: "Limite da sua assinatura:",
        limitReached: "Limite atingido: para adicionar mais conexões, melhore seu plano.",
      },
      channelCard: {
        activeConnections: "Conexões ativas:",
        configure: "Configurar",
        upgradePlan: "Melhorar plano",
      },
      actions: {
        refresh: "Atualizar",
      },
      subtitles: {
        whatsapp: "Phone Number ID + Access Token + Webhook",
        facebook: "Página + Access Token + Webhook",
        instagram: "Conta + Access Token + Webhook",
      },
      empty: {
        title: "Conectar APIs",
        subtitle: "Seu plano não tem os módulos da Meta habilitados.",
        button: "Ver planos",
      },
    },
    whatsappApi: {
      title: "WhatsApp API",
      actions: {
        copyWebhook: "Copiar webhook",
        newConnection: "Nova conexão",
        copy: "Copiar",
        save: "Salvar",
        saving: "Salvando...",
        rotating: "Rotacionando...",
        rotateVerifyToken: "Rotacionar Verify Token",
        rotateSecrets: "Rotacionar WebhookKey + Verify Token",
      },
      toasts: {
        copied: "Copiado",
        connectionUpdated: "Conexão atualizada.",
        connectionCreated: "Conexão criada.",
        connectionDeleted: "Conexão excluída.",
        connectionSavedButMetaSubscribeFailed:
          "Conexão salva, mas não foi possível concluir a inscrição automática no Meta. {{reason}}",
        metaSubscribeOk: "Inscrição no Meta concluída.",
        metaSubscribeFailed: "Não foi possível concluir a inscrição no Meta. {{reason}}",
        verifyTokenRotated: "Verify Token atualizado. Atualize no Meta e verifique novamente.",
        secretsRotated: "WebhookKey e Verify Token atualizados. Atualize no Meta e verifique novamente.",
      },
      modal: {
        editTitle: "Editar conexão WhatsApp API",
        newTitle: "Nova conexão WhatsApp API",
      },
      form: {
        name: "Nome",
        phoneNumberId: "Phone Number ID",
        phoneNumberIdHelper: "Ex: 123456789012345",
        wabaIdOptional: "WABA ID",
        accessToken: "Access Token",
        accessTokenEditHint: "Access Token (deixe em branco para manter)",
        useAsDefault: "Usar como padrão",
        cancel: "Cancelar",
      },
      validation: {
        nameMin: "O nome deve ter pelo menos 2 caracteres",
        nameRequired: "Nome é obrigatório",
        phoneNumberIdRequired: "Phone Number ID é obrigatório",
        wabaIdRequired: "WABA ID é obrigatório",
        accessTokenRequired: "Access Token é obrigatório",
      },
      errors: {
        missingWabaId: "Faltou o WABA ID. Adicione e salve novamente para assinar automaticamente no Meta.",
        missingAccessToken: "Faltou o Access Token. Adicione e salve novamente.",
        appNotSubscribed:
          "O app não aparece inscrito no WABA. Verifique permissões do token ou faça manualmente no Meta.",
      },
      confirm: {
        deleteTitle: "Excluir conexão",
        deleteMessage: "Excluir a conexão {{name}}?",
      },
      rotateVerifyToken: {
        title: "Rotacionar Verify Token",
        message:
          "Você vai gerar um novo Verify Token. O token anterior deixará de ser usado. Depois, você deve atualizá-lo no Meta Developer e re-verificar o webhook. Continuar?",
      },
      rotateSecrets: {
        title: "Rotacionar WebhookKey + Verify Token",
        message:
          "Você vai gerar um novo WebhookKey e um novo Verify Token. A URL do webhook mudará e o token anterior deixará de ser usado. Depois, você deve atualizar ambos no Meta Developer e re-verificar o webhook. Continuar?",
      },
      table: {
        name: "Nome",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        meta: "Meta",
        default: "Padrão",
        webhook: "Webhook",
        actions: "Ações",
      },
      values: {
        yes: "Sim",
        no: "Não",
        verified: "Verificado",
        pending: "Pendente",
        metaSubscribed: "Inscrito",
        metaError: "Erro",
        metaUnknown: "Pendente",
      },
      empty: "Nenhuma conexão. Crie uma para começar.",
      helper: {
        title: "Dados para Meta (únicos por cliente)",
        step1: "No Meta Developer, configure o webhook usando:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        step2: "Inscreva-se no evento messages. Ao salvar/ativar, o Klorum tenta inscrever seu app no WABA automaticamente.",
        step3: "Quando a Meta verificar, você verá o status Verificado.",
        step4: "As mensagens recebidas chegarão no WhatsApp (Tickets) e você poderá responder pelo chat.",
        user: "Usuário:",
      },
      tooltips: {
        retryMetaSubscribe: "Tentar novamente inscrição no Meta",
        edit: "Editar",
        delete: "Excluir",
      },
    },
    dashboard: {
      errors: {
        loadData: "Não foi possível carregar os dados do dashboard.",
      },
      filters: {
        title: "Filtros",
      },
      export: {
        agentsSheet: "RelatorioDeAgentes",
        agentsFile: "relatorio-de-agentes.xlsx",
        error: "Erro ao exportar para Excel.",
      },
      charts: {
        errors: {
          loadTicketsInfo: "Erro ao carregar informações dos tickets.",
        },
        perHour: {
          title: "Atendimentos por hora",
        },
        ticketsLabel: "Tickets",
        empty: {
          noData: "Nenhum dado para exibir.",
          noDataForPeriod: "Nenhum dado para o período selecionado.",
        },
      },
      membership: {
        title: "Minha assinatura",
        details: "Ver detalhes",
        availablePlansTitle: "Planos disponíveis",
        availablePlansSubtitle:
          "Seu plano atual se aplica automaticamente aos limites e módulos do sistema.",
        loadingPlans: "Carregando planos...",
        noPublicPlans: "Não há planos públicos disponíveis no momento.",
        planLabel: "Plano",
        activeBadge: "ATIVO",
        channelsLabel: "Canais",
        buttons: {
          current: "Plano atual",
          upgrade: "Melhorar",
          view: "Ver",
        },
        license: {
          noExpiration: "Sem vencimento",
          expiresToday: "Vence hoje",
          expiredOn: "Venceu em {{date}}",
          expiresOn: "Vence em {{date}}",
        },
      },
      channels: {
        titleOverline: "Canais",
        title: "Status dos canais",
        subtitle: "Conexões ativas e última sincronização por canal.",
        configureApis: "Configurar APIs",
        loading: "Carregando status dos canais...",
        empty: "Não há informações de canais disponíveis.",
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          error: "Erro",
        },
        errors: {
          load: "Não foi possível carregar o status dos canais.",
        },
      },
      analytics: {
        title: "Análises (mês atual)",
        period: "Período: {{from}} a {{to}}",
        chips: {
          unavailable: "Indisponível",
          realData: "Dados reais",
        },
        disabledMessage:
          "Seu plano atual não inclui o módulo de Análises. Melhore seu plano para ver essas métricas.",
        loading: "Carregando análises...",
        metrics: {
          monthlyRevenue: "Receita (mês)",
          totalRevenue: "Receita (total)",
          conversion: "Conversão",
          firstResponse: "1ª resposta (min)",
          activeUsers: "Usuários ativos",
          newLeads: "Novos leads",
          closings: "Fechamentos",
        },
        activity: {
          title: "Atividade recente",
          loading: "Carregando atividade...",
          empty: "Não há atividade recente disponível.",
          fallbackTitle: "Atividade",
        },
        errors: {
          metrics: "Não foi possível carregar as métricas da empresa.",
          activity: "Não foi possível carregar a atividade recente.",
        },
      },
    },
    flowBuilder: {
      defaultFlowName: "Novo Fluxo",
      copySuffix: "(Cópia)",
      list: {
        title: "Fluxos de conversa",
        addFlow: "Adicionar fluxo",
        searchPlaceholder: "Buscar fluxo...",
        empty: "Você ainda não tem fluxos.",
        noMatches: "Nenhum resultado para sua busca.",
        status: {
          active: "Ativo",
          inactive: "Desativado",
        },
        menu: {
          editName: "Editar nome",
          editFlow: "Editar fluxo",
          duplicate: "Duplicar",
          delete: "Excluir",
        },
        confirm: {
          deleteTitle: "Excluir o fluxo {{name}}?",
          deleteBody:
            "Tem certeza que deseja excluir este fluxo? Todas as integrações relacionadas serão perdidas.",
          duplicateTitle: "Duplicar o fluxo {{name}}?",
          duplicateBody: "Tem certeza que deseja duplicar este fluxo?",
        },
        toasts: {
          deleted: "Fluxo excluído com sucesso",
          duplicated: "Fluxo duplicado com sucesso",
        },
      },
      modals: {
        question: {
          titleCreate: "Adicionar pergunta ao fluxo",
          titleEdit: "Editar pergunta",
          fields: {
            message: "Mensagem",
            answerKey: "Salvar resposta como",
          },
        },
        text: {
          titleCreate: "Adicionar mensagem ao fluxo",
          titleEdit: "Editar mensagem",
          fields: {
            message: "Mensagem",
          },
        },
        image: {
          titleCreate: "Adicionar imagem ao fluxo",
          titleEdit: "Editar imagem",
          buttons: {
            upload: "Enviar imagem",
          },
          errors: {
            fileTooLarge: "Arquivo muito grande. Máximo 2MB.",
          },
          toasts: {
            created: "Imagem adicionada com sucesso!",
            updated: "Imagem alterada com sucesso!",
          },
        },
        audio: {
          titleCreate: "Adicionar áudio ao fluxo",
          titleEdit: "Editar áudio",
          buttons: {
            upload: "Enviar áudio",
          },
          fields: {
            record: "Enviar como áudio gravado na hora",
          },
          fallback: "Seu navegador não suporta HTML5",
          errors: {
            fileTooLarge: "Arquivo muito grande. Máximo 5MB.",
          },
          toasts: {
            created: "Áudio adicionado com sucesso!",
            updated: "Áudio alterado com sucesso!",
          },
        },
        video: {
          titleCreate: "Adicionar vídeo ao fluxo",
          titleEdit: "Editar vídeo",
          buttons: {
            upload: "Enviar vídeo",
          },
          warnings: {
            onlyMp4: "ATENÇÃO! Apenas vídeos em MP4!",
          },
          fallback: "Seu navegador não suporta HTML5",
          errors: {
            fileTooLarge: "Arquivo muito grande. Máximo 20MB.",
          },
          toasts: {
            created: "Vídeo adicionado com sucesso!",
            updated: "Vídeo alterado com sucesso!",
          },
        },
        openai: {
          titleCreate: "Adicionar OpenAI/Gemini ao fluxo",
          titleEdit: "Editar OpenAI/Gemini",
          voice: {
            text: "Texto",
          },
        },
        interval: {
          titleCreate: "Adicionar intervalo ao fluxo",
          titleEdit: "Editar intervalo",
          fields: {
            seconds: "Tempo em segundos",
          },
          errors: {
            required: "Adicione o valor do intervalo.",
            maxSeconds: "Tempo máximo: 120 segundos.",
          },
        },
        condition: {
          titleCreate: "Adicionar condição ao fluxo",
          titleEdit: "Editar condição",
          fields: {
            key: "Campo da condição (digite apenas 1 chave)",
            rule: "Regra de validação",
            value: "Valor da condição a ser analisada",
          },
        },
        ticket: {
          titleCreate: "Adicionar fila ao fluxo",
          titleEdit: "Editar fila",
          placeholders: {
            selectQueue: "Selecione uma fila",
          },
          errors: {
            requiredQueue: "Selecione uma fila.",
          },
        },
        menu: {
          titleCreate: "Adicionar menu ao fluxo",
          titleEdit: "Editar menu",
          fields: {
            message: "Mensagem de explicação do menu",
          },
          buttons: {
            addOption: "Adicionar opção",
          },
          optionPrompt: "Digite {{number}}",
          placeholders: {
            option: "Digite opção",
          },
        },
        randomizer: {
          titleCreate: "Adicionar randomizador ao fluxo",
          titleEdit: "Editar randomizador",
          aria: {
            slider: "Porcentagem",
          },
          errors: {
            required: "Adicione um percentual.",
            maxPercent: "Percentual máximo: 100.",
          },
        },
        typebot: {
          titleCreate: "Adicionar Typebot ao fluxo",
          titleEdit: "Editar Typebot",
        },
        singleBlock: {
          titleCreate: "Adicionar conteúdo ao fluxo",
          titleEdit: "Editar conteúdo",
          elements: {
            text: "Texto",
            interval: "Intervalo",
            image: "Imagem",
            audio: "Áudio",
            video: "Vídeo",
            document: "Documento",
          },
          buttons: {
            uploadImage: "Enviar imagem",
            uploadAudio: "Enviar áudio",
            uploadVideo: "Enviar vídeo",
            uploadDocument: "Enviar documento",
          },
          fields: {
            message: "Mensagem",
            seconds: "Tempo em segundos",
            recordAudio: "Enviar como áudio gravado na hora",
            variables: "Variáveis",
          },
          file: {
            noFileSelected: "Nenhum arquivo selecionado",
          },
          loading: {
            uploading: "Subindo os arquivos e criando o conteúdo...",
          },
          toasts: {
            saved: "Conteúdo salvo com sucesso!",
          },
          errors: {
            messageEmpty: "Campo de mensagem vazio!",
            intervalInvalid: "Intervalo não pode ser 0 ou maior que 120!",
            fileTooLarge: "Arquivo muito grande. Máximo {{maxMb}}MB.",
            pendingUploads:
              "Delete os cards vazios ou envie os arquivos pendentes.",
          },
        },
      },
    },
    flowBuilderCanvas: {
      back: "Voltar",
      title: "FlowBuilder Canvas",
      testFlow: "Testar Fluxo",
      save: "Salvar",
      alerts: {
        saved: "Fluxo salvo com sucesso",
        saveError: "Erro ao salvar fluxo",
        testSoon: "Função de teste em breve",
        confirmDeleteNode: "Tem certeza que deseja excluir este nó?",
      },
      nodeConfig: {
        sections: {
          basic: "Configuração básica",
          advanced: "Opções avançadas",
        },
        fields: {
          nodeName: "Nome do nó",
          model: "Modelo",
          systemPrompt: "Prompt do sistema",
          temperatureLabel: "Temperatura: {{value}}",
          maxTokens: "Máx. tokens",
          intents: "Intenções possíveis (separadas por vírgula)",
          confidenceLabel: "Limite de confiança: {{value}}",
          webhookUrl: "URL do webhook",
          httpMethod: "Método HTTP",
          requireAuth: "Requer autenticação",
          secretKey: "Chave secreta",
          scheduleType: "Tipo de agendamento",
          cronExpression: "Expressão cron",
          messageTemplate: "Modelo de mensagem",
          includeMedia: "Incluir mídia",
          mediaUrl: "URL da mídia",
          emailSubject: "Assunto",
          emailBody: "Corpo do e-mail (HTML)",
          fromEmail: "E-mail remetente",
          conditionType: "Tipo de condição",
          fieldToCheck: "Campo para verificar",
          operator: "Operador",
          valueToCompare: "Valor para comparar",
          jsExpression: "Expressão JavaScript",
          continueOnError: "Continuar em caso de erro",
          retryOnFailure: "Repetir em caso de falha",
        },
        placeholders: {
          nodeName: "Digite o nome do nó...",
          systemPrompt: "Você é um assistente útil...",
          intents: "compra, dúvida, reclamação...",
          secretKey: "Digite a chave secreta...",
          cronExpression: "0 9 * * * (Todos os dias às 9:00)",
          messageTemplate: "Olá {{name}}, obrigado por entrar em contato...",
          emailSubject: "Assunto do e-mail...",
          emailBody: "<h1>Olá {{name}}</h1><p>...</p>",
          fieldToCheck: "Ex: user.age, message.text",
          valueToCompare: "Digite um valor...",
        },
        defaults: {
          intents: "compra, dúvida, reclamação, cancelamento",
        },
        options: {
          scheduleType: {
            cron: "Expressão cron",
            interval: "Intervalo",
            specific: "Data/hora específica",
          },
          intervalUnit: {
            minutes: "Minutos",
            hours: "Horas",
            days: "Dias",
          },
          conditionType: {
            simple: "Simples (A == B)",
            multiple: "Múltiplas (AND/OR)",
            expression: "Expressão JavaScript",
          },
          operator: {
            equals: "Igual (==)",
            notEquals: "Diferente (!=)",
            greater: "Maior que (>)",
            less: "Menor que (<)",
            contains: "Contém",
            startsWith: "Começa com",
            endsWith: "Termina com",
          },
        },
        helpers: {
          temperature:
            "Valores altos = mais criativo. Valores baixos = mais determinístico.",
          cronExpression:
            'Exemplo: "0 9 * * *" executa todos os dias às 9:00',
          variables: "Use {{variable}} para variáveis dinâmicas",
        },
        empty: {
          noSpecificConfig:
            "Não há configuração específica para este tipo de nó.",
          connectHelp: "Arraste conexões para vincular com outros nós.",
        },
        confirmDelete: "Excluir este nó?",
      },
    },
    kanban: {
      ticketLabel: "Ticket nº {{id}}",
      filters: {
        startDate: "Data de início",
        endDate: "Data de fim",
      },
      toasts: {
        tagRemoved: "Etiqueta removida do ticket!",
        tagAdded: "Etiqueta adicionada ao ticket!",
      },
      actions: {
        search: "Buscar",
        viewTicket: "Ver Ticket",
        addColumns: "+ Adicionar colunas",
      },
    },
    moments: {
      title: "Painel de Atendimentos",
    },
    todoList: {
      newTask: "Nova tarefa",
      add: "Adicionar",
      save: "Salvar",
    },
    facebookInstagram: {
      titleAll: "Facebook e Instagram",
      subtitle: "Gerencie suas integrações com a Meta",
      actions: {
        newConnection: "Nova conexão",
        connectFacebook: "Conectar Facebook",
        connectInstagram: "Conectar Instagram",
      },
      meta: {
        title: "Dados para a Meta (únicos por cliente)",
        step1: "1. No Meta Developer, configure o produto Webhooks usando:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        copy: "Copiar",
        step2: "2. Inscreva-se nos objetos/campos:",
        objectWord: "objeto",
        fieldsWord: "campos",
        step3:
          "3. Quando a Meta verificar, você verá o status salvo no app. Depois, as mensagens de entrada chegarão em Tickets e você poderá responder pelo chat.",
        user: "Usuário:",
      },
      filters: {
        title: "Filtros",
        searchLabel: "Buscar (nome ou ID)",
        category: "Categoria",
        from: "De",
        to: "Até",
        inactiveShort: "Inat.",
      },
      table: {
        title: "Conexões",
        empty: "Nenhuma conexão para mostrar.",
        headers: {
          platform: "Plataforma",
          name: "Nome",
          id: "ID",
          category: "Categoria",
          status: "Status",
          webhook: "Webhook",
          created: "Criado",
          active: "Ativo",
          actions: "Ações",
        },
      },
      labels: {
        pageId: "ID da Página",
        instagramAccountId: "ID da conta do Instagram",
      },
      status: {
        connected: "Conectada",
        disconnected: "Desconectada",
        error: "Erro",
        verified: "Verificado",
        pending: "Pendente",
      },
      tooltips: {
        edit: "Editar",
        disconnect: "Desconectar",
      },
      dialog: {
        newTitle: "Nova conexão {{platform}}",
        editTitle: "Editar conexão {{platform}}",
        info: "Esta tela cria uma conexão de API manual. Cole o Access Token e o ID correspondente.",
        fields: {
          name: "Nome",
          categoryOptional: "Categoria (opcional)",
          accessToken: "Access Token",
          accessTokenEditHint: "Access Token (deixe vazio para não alterar)",
        },
        saving: "Salvando...",
      },
      validations: {
        selectValidChannel: "Selecione um canal válido",
        nameRequired: "O nome é obrigatório",
        idRequired: "{{idLabel}} é obrigatório",
        accessTokenRequired: "Access Token é obrigatório",
      },
      confirm: {
        disconnect: "Tem certeza de que deseja desconectar esta conta?",
      },
      toasts: {
        copied: "Copiado",
        accountActivated: "Conta ativada com sucesso",
        accountDeactivated: "Conta desativada com sucesso",
        statusToggleError: "Erro ao alterar o status da conta",
        disconnectSuccess: "Conta desconectada com sucesso!",
        disconnectError: "Erro ao desconectar conta",
        connectionUpdated: "Conexão atualizada",
        connectionCreated: "Conexão criada",
        saveError: "Erro ao salvar conexão",
      },
    },
    salesDashboard: {
      title: "Dashboard de Vendas",
      subtitle: "Bem-vindo, {{name}} - Aqui está o seu desempenho",
      errors: {
        load: "Erro ao carregar dados de vendas.",
      },
      metrics: {
        totalLeads: "Total de leads",
        convertedClients: "Clientes convertidos",
        totalRevenue: "Receita total",
        ranking: "Ranking de vendedores",
        thisMonth: "Este mês",
        cumulative: "Acumulado",
        conversionSubtitle: "{{rate}}% de conversão",
        rankingSubtitle: "Top 3 da equipe",
      },
      goal: {
        title: "Meta mensal",
        progress: "Progresso: {{percent}}%",
        reached: "Meta atingida! 🎉",
        remaining: "Faltam {{amount}} para atingir a meta",
      },
      topProduct: {
        title: "Produto mais vendido",
        salesThisMonth: "{{count}} vendas este mês",
        conversionRate: "Taxa de conversão",
        avgValue: "Valor médio",
      },
      quickActions: {
        title: "Ações rápidas",
        viewLeads: "Ver meus leads",
        registerClient: "Cadastrar cliente",
        commissions: "Minhas comissões",
        aiSales: "IA para vendas",
      },
    },
    teamDashboard: {
      title: "Dashboard da equipe",
      subtitle: "Acompanhe o desempenho da sua equipe de vendas",
      errors: {
        load: "Erro ao carregar dados da equipe.",
      },
      metrics: {
        teamMembers: "Membros da equipe",
        activeMembersSubtitle: "{{count}} ativos",
        teamRevenue: "Receita da equipe",
        thisMonth: "Este mês",
        topSeller: "Melhor vendedor",
        topSellerSubtitle: "Melhor desempenho",
        teamGoal: "Meta da equipe",
      },
      goal: {
        title: "Progresso da meta da equipe",
        completed: "{{percent}}% concluído",
        reached: "🎉 Meta da equipe atingida!",
        remaining: "Faltam {{amount}} para a meta mensal",
      },
      table: {
        title: "Desempenho individual",
        headers: {
          seller: "Vendedor",
          leads: "Leads",
          conversions: "Conversões",
          revenue: "Receita",
          goal: "Meta",
          performance: "Desempenho",
          status: "Status",
          actions: "Ações",
        },
      },
      status: {
        active: "Ativo",
        inactive: "Inativo",
      },
      tooltips: {
        viewDetails: "Ver detalhes",
        call: "Ligar",
        email: "E-mail",
      },
      summary: {
        totalLeads: "Total de leads da equipe",
        totalConversions: "Total de conversões",
        conversionRate: "Taxa de conversão",
      },
    },
    commission: {
      title: "Minhas comissões",
      subtitle: "Gerencie e acompanhe seus ganhos",
      errors: {
        load: "Erro ao carregar dados de comissões.",
      },
      defaults: {
        client: "Cliente",
        plan: "Plano",
      },
      period: {
        label: "Período",
        current: "Mês atual",
        last: "Mês anterior",
        quarter: "Último trimestre",
        year: "Este ano",
        selected: "Período selecionado",
      },
      metrics: {
        totalEarned: "Total ganho",
        currentMonth: "Mês atual",
        pendingPayout: "Pendente de pagamento",
        paid: "Pago",
        cumulative: "Acumulado",
        rateSubtitle: "Taxa: {{rate}}%",
        toProcess: "A processar",
        processed: "Processado",
      },
      goal: {
        title: "Meta de comissões - {{period}}",
        progress: "Progresso: {{percent}}%",
        reached: "🎉 Meta atingida! Excelente trabalho",
        remaining: "Faltam {{amount}} para atingir sua meta mensal",
        rateLabel: "Taxa de comissão",
      },
      table: {
        title: "Histórico de comissões",
        headers: {
          client: "Cliente",
          plan: "Plano",
          saleValue: "Valor da venda",
          commission: "Comissão",
          status: "Status",
          date: "Data",
        },
      },
      status: {
        paid: "Pago",
        pending: "Pendente",
      },
      summary: {
        totalPaid: "Total de comissões pagas",
        totalPending: "Total de comissões pendentes",
      },
    },
    checkout: {
      steps: {
        data: "Dados",
        customize: "Personalizar",
        review: "Revisar",
      },
      gateways: {
        steps: {
          selectPlan: "Selecionar plano",
          paymentMethod: "Método de pagamento",
          confirm: "Confirmar",
        },
        errors: {
          loadPlans: "Erro ao carregar os planos.",
          missingCustomerInfo: "Por favor, preencha seu nome e e-mail.",
          initMercadoPago: "Não foi possível iniciar o pagamento com MercadoPago.",
          processPayment: "Erro ao processar o pagamento.",
        },
        title: "Melhore seu plano",
        subtitle: "Escolha o plano perfeito para o seu negócio",
        billing: {
          monthly: "Mensal",
          yearly: "Anual",
          freeMonths: "{{count}} meses grátis",
        },
        plan: {
          mostPopular: "Mais popular",
          perMonth: "/mês",
          perYear: "/ano",
          savings: "Você economiza {{amount}}",
          limits: {
            messagesPerMonth: "{{value}} mensagens/mês",
            channels: "{{value}} canais",
            users: "{{value}} usuários",
          },
        },
        billingInfo: {
          title: "Informações de cobrança",
          fullName: "Nome completo",
          email: "E-mail",
        },
        summary: {
          title: "Resumo",
          plan: "Plano {{plan}}",
          cycle: "Ciclo: {{cycle}}",
        },
        paymentMethod: {
          title: "Método de pagamento",
          mercadoPago: "MercadoPago (Peru)",
          paypal: "PayPal (Internacional)",
        },
        buttons: {
          payWithMercadoPago: "Pagar com MercadoPago",
          payWithPayPal: "Pagar com PayPal",
        },
        securityHint: "Pagamento seguro. Você pode cancelar quando quiser.",
      },
      header: "Falta pouco!",
      notFound: "Não encontrado.",
      buttons: {
        pay: "Pagar",
        select: "Selecionar",
        increase: "Aumentar",
        decrease: "Diminuir",
      },
      paymentHint: "Após realizar o pagamento, atualize a página.",
      toasts: {
        subscriptionCreatedWaiting:
          "Assinatura criada com sucesso. Aguardando a confirmação do pagamento.",
      },
      form: {
        fullName: {
          label: "Nome completo*",
          required: "O nome completo é obrigatório",
        },
        lastName: {
          label: "Sobrenome*",
          required: "O sobrenome é obrigatório",
        },
        address: {
          label: "Endereço*",
          required: "O endereço é obrigatório",
        },
        city: {
          label: "Cidade*",
          required: "A cidade é obrigatória",
        },
        state: {
          label: "Estado*",
          required: "O estado é obrigatório",
        },
        document: {
          label: "CPF/CNPJ*",
          required: "O documento é obrigatório",
          invalid: "Formato de documento inválido",
        },
        country: {
          label: "País*",
          required: "O país é obrigatório",
        },
        useAddressForPaymentDetails: {
          label: "Usar este endereço para os dados de pagamento",
        },
        nameOnCard: {
          label: "Nome no cartão*",
          required: "O nome no cartão é obrigatório",
        },
        cardNumber: {
          label: "Número do cartão*",
          required: "O número do cartão é obrigatório",
          invalid: "Número do cartão inválido (ex.: 4111111111111)",
        },
        expiryDate: {
          label: "Validade*",
          required: "A validade é obrigatória",
          invalid: "Validade inválida",
        },
        cvv: {
          label: "CVV*",
          required: "O CVV é obrigatório",
          invalid: "CVV inválido (ex.: 357)",
        },
      },
      plan: {
        perMonth: "/mês",
        users: "{{count}} Usuários",
        connections: "{{count}} Conexões",
        queues: "{{count}} Filas",
      },
      review: {
        title: "Resumo da assinatura",
        planDetails: {
          title: "Detalhes do plano",
          users: "Usuários: {{count}}",
          connections: "Conexões: {{count}}",
          queues: "Filas: {{count}}",
          billing: "Cobrança: Mensal",
        },
        paymentInfo: {
          title: "Informação de pagamento",
          document: "CPF/CNPJ",
          total: "Total",
        },
      },
      success: {
        total: "TOTAL",
        copyQrCode: "Copiar código QR",
        instructions:
          "Para finalizar, realize o pagamento escaneando ou colando o código Pix acima.",
        licenseRenewed: "Sua licença foi renovada até {{date}}!",
      },
    },
    modulesManager: {
      table: {
        key: "Chave",
        category: "Categoria",
        addon: "Adicional",
      },
      toasts: {
        loadError: "Não foi possível carregar os módulos.",
        saved: "Módulo salvo.",
        saveError: "Não foi possível salvar o módulo.",
        deactivated: "Módulo desativado.",
        deactivateError: "Não foi possível desativar o módulo.",
      },
      confirm: {
        deactivateTitle: "Desativar módulo",
        deactivateMessage: "Deseja desativar este módulo?",
      },
    },
    flowImportModal: {
      title: "Importar fluxo",
      instructions: "Selecione um arquivo .zip exportado pelo Flowbuilder.",
      noFile: "Nenhum arquivo escolhido",
      buttons: {
        chooseFile: "Escolher arquivo",
        import: "Importar",
      },
      toasts: {
        selectZip: "Selecione um arquivo .zip",
        success: "Fluxo importado com sucesso!",
        error: "Erro ao importar fluxo.",
      },
    },
    chatList: {
      confirm: {
        deleteTitle: "Excluir conversa",
        deleteMessage: "Esta ação não pode ser revertida. Confirmar?",
      },
    },
    planModulesManager: {
      form: {
        plan: "Plano",
      },
      table: {
        module: "Módulo",
        category: "Categoria",
        included: "Incluído",
      },
      buttons: {
        saveChanges: "Salvar alterações",
      },
      toasts: {
        plansLoadError: "Não foi possível carregar os planos.",
        modulesLoadError: "Não foi possível carregar os módulos do plano.",
        saved: "Módulos do plano atualizados.",
        saveError: "Não foi possível salvar os módulos do plano.",
      },
    },
    companyModulesManager: {
      table: {
        module: "Módulo",
        category: "Categoria",
        plan: "Plano",
        override: "Override",
        effective: "Efetivo",
      },
      override: {
        plan: "Usar plano",
        enable: "Habilitar",
        disable: "Desabilitar",
      },
      buttons: {
        saveChanges: "Salvar alterações",
      },
      toasts: {
        companiesLoadError: "Não foi possível carregar empresas.",
        modulesLoadError: "Não foi possível carregar os módulos da empresa.",
        saved: "Módulos da empresa atualizados.",
        saveError: "Não foi possível atualizar os módulos.",
      },
    },
    contactNotesDialog: {
      toasts: {
        added: "Observação adicionada com sucesso!",
        deleted: "Observação excluída com sucesso!",
      },
      confirm: {
        deleteTitle: "Excluir registro",
        deleteMessage: "Deseja realmente excluir este registro?",
      },
    },
    contacts: {
      menu: {
        importExport: "Importar / Exportar",
      },
      importPage: {
        title: "Importar contatos de arquivo",
      },
      toasts: {
        batchDeleted: "Contatos selecionados excluídos com sucesso.",
        blocked: "Contato bloqueado.",
        unblocked: "Contato desbloqueado.",
      },
      confirmationModal: {
        blockTitle: "Bloquear {{name}}",
        unblockTitle: "Desbloquear {{name}}",
        chooseConnectionToImport:
          "Escolha de qual conexão importar os contatos.",
        batchDeleteTitle: "Excluir {{count}} contatos",
        batchDeleteMessage:
          "Deseja realmente excluir os contatos selecionados? Esta ação não pode ser desfeita.",
      },
      buttons: {
        deleteSelected: "Excluir selecionados ({{count}})",
      },
      accessibility: {
        selectAll: "Selecionar todos os contatos",
        selectContact: "Selecionar contato {{name}}",
      },
    },
    contactImport: {
      validateWhatsapp: "Validar contatos no WhatsApp",
      uploading: "Importando... aguarde",
      buttons: {
        importContacts: "Importar contatos",
      },
      fields: {
        name: "Nome",
        number: "Número",
        email: "E-mail",
        tags: "Tags",
      },
      errors: {
        missingNumberField: "Selecione a coluna para o campo \"Número\".",
        missingNameField: "Selecione a coluna para o campo \"Nome\".",
        noContactsSelected: "Selecione pelo menos um contato para importar.",
        fieldAlreadySelected: "O campo {{field}} já foi selecionado.",
      },
      toasts: {
        success: "Contatos importados com sucesso.",
        successWithErrors:
          "Importação concluída com avisos. Alguns contatos foram ignorados.",
      },
      summary: {
        created: "{{count}} contatos criados",
        ignored:
          "{{count}} contatos ignorados (número inválido ou não marcados para atualizar)",
      },
      file: {
        processing: "Processando arquivo...",
        invalid: "Arquivo inválido!",
      },
      dropzone: {
        title: "Clique ou arraste um arquivo",
        note:
          "* Importante: apenas arquivos com extensões: xls, xlsx, csv, txt",
      },
      alt: {
        upload: "Enviar arquivo",
      },
    },
    slaPolicies: {
      title: "SLA por canal",
      description:
        "Configure tempos de primeira resposta, próxima resposta e resolução por canal.",
      fields: {
        firstResponseMinutes: "Primeira resposta (min)",
        nextResponseMinutes: "Próxima resposta (min)",
        resolutionMinutes: "Resolução (min)",
      },
      buttons: {
        save: "Salvar SLA",
      },
      toasts: {
        loadError: "Erro ao carregar SLA.",
        saved: "SLA atualizado.",
        saveError: "Erro ao salvar SLA.",
      },
    },
    ticketMessagesDialog: {
      errors: {
        exportTargetNotFound: "Elemento não encontrado para exportar.",
      },
      buttons: {
        exportPdf: "Exportar para PDF",
      },
    },
    reports: {
      buttons: {
        exportExcel: "Exportar para Excel",
      },
    },
    campaignPhraseModal: {
      title: {
        create: "Criar campanha de frase",
        edit: "Editar campanha de frase",
      },
      fields: {
        name: "Nome",
        flow: "Fluxo",
        phrase: "Frase",
      },
      placeholders: {
        flow: "Selecione um fluxo",
        connection: "Selecione uma conexão",
      },
      buttons: {
        createCampaign: "Criar campanha",
        saveCampaign: "Salvar campanha",
      },
      toasts: {
        created: "Campanha criada com sucesso.",
        updated: "Campanha atualizada com sucesso.",
      },
    },
    colorBoxModal: {
      title: "Selecionar cor",
    },
    editMessageModal: {
      title: "Editar mensagem",
      placeholders: {
        message: "Digite a mensagem...",
      },
      aria: {
        messageInput: "Mensagem editada",
      },
    },
    flowDefault: {
      title: "Fluxos padrão",
      confirm: {
        deleteMessage: "Deseja realmente excluir este fluxo?",
      },
      sections: {
        welcome: {
          title: "Fluxo de boas-vindas",
          description:
            "Selecione o fluxo enviado no início de uma conversa.",
        },
        defaultReply: {
          title: "Fluxo de resposta padrão",
          description:
            "Selecione o fluxo usado quando não houver correspondência de frase.",
        },
      },
      placeholders: {
        selectFlow: "Selecione um fluxo",
      },
      toasts: {
        deleted: "Fluxo excluído com sucesso.",
        updated: "Fluxos padrão atualizados.",
      },
    },
    campaignsConfig: {
      sections: {
        intervals: "Intervalos",
      },
      errors: {
        noPermissionRedirect:
          "Esta empresa não possui permissão para acessar esta página. Estamos redirecionando você.",
      },
    },
    campaigns: {
      settings: {
        seconds: "segundos",
      },
      dialog: {
        tabs: {
          message: "Mensagem {{number}}",
        },
      },
      table: {
        notScheduled: "Sem agendamento",
        notCompleted: "Não concluída",
      },
      status: {
        inactive: "Inativa",
        scheduled: "Programada",
        running: "Em andamento",
        canceled: "Cancelada",
        completed: "Finalizada",
      },
      actions: {
        stop: "Parar campanha",
        restart: "Reiniciar campanha",
      },
    },
    flowBuilderConfig: {
      title: "Desenhe seu fluxo",
      reminder: "Não se esqueça de salvar seu fluxo!",
      aria: {
        speedDial: "Adicionar nó",
      },
      toasts: {
        saved: "Fluxo salvo com sucesso.",
      },
      actions: {
        start: "Início",
        content: "Conteúdo",
        menu: "Menu",
        randomizer: "Randomizador",
        interval: "Intervalo",
        ticket: "Fila",
        typebot: "TypeBot",
        openai: "OpenAI",
        question: "Pergunta",
      },
      fallback: {
        html5: "Seu navegador não suporta HTML5",
      },
      units: {
        seconds: "segundos",
      },
      nodes: {
        start: {
          title: "Início do fluxo",
          description: "Este bloco marca o início do seu fluxo.",
        },
        message: {
          title: "Mensagem",
        },
        interval: {
          title: "Intervalo",
          seconds: "{{seconds}} segundos",
        },
        menu: {
          title: "Menu",
        },
        randomizer: {
          title: "Randomizador",
        },
        audio: {
          title: "Áudio",
          recordedNow: "Gravado na hora",
          sent: "Áudio enviado",
        },
        image: {
          title: "Imagem",
          previewAlt: "Pré-visualização de imagem",
        },
        video: {
          title: "Vídeo",
        },
        condition: {
          title: "Condição",
        },
        singleBlock: {
          title: "Conteúdo",
        },
        ticket: {
          title: "Fila",
        },
        typebot: {
          title: "TypeBot",
          iconAlt: "Ícone do TypeBot",
        },
        openai: {
          title: "OpenAI/Gemini",
        },
        question: {
          title: "Pergunta",
        },
      },
    },
    flowBuilderModal: {
      title: {
        create: "Adicionar fluxo",
        edit: "Editar fluxo",
      },
    },
    buttonModal: {
      title: "Selecione uma opção",
      select: {
        placeholder: "Selecione",
      },
      options: {
        list: "Lista",
        copy: "Copiar",
        callMe: "Me ligue",
      },
      fields: {
        title: "Título",
        description: "Descrição",
        message: "Mensagem",
        buttonText: "Texto do botão",
        url: "URL",
        copyText: "Texto para copiar",
        phone: "Telefone",
        value: "Valor",
        image: "Imagem",
        name: "Nome",
      },
      buttons: {
        addOption: "Adicionar nova opção",
      },
      list: {
        optionLabel: "Opção {{number}}",
        defaultSectionTitle: "Opções",
        defaultButtonText: "Clique aqui",
      },
      url: {
        defaults: {
          title: "Botão de URL",
          description: "Mensagem com botão",
          buttonText: "Abrir link",
          url: "https://exemplo.com",
        },
      },
      pix: {
        keyType: {
          placeholder: "Tipo de chave",
          phone: "Telefone",
          email: "E-mail",
          random: "Chave aleatória",
        },
        fields: {
          key: "Chave PIX",
        },
      },
      errors: {
        invalidTicketId: "ID do ticket inválido.",
        noOptionSelected: "Selecione uma opção.",
        processMessage: "Erro ao processar a mensagem.",
      },
    },
    queueOptions: {
      title: "Opções",
      placeholders: {
        title: "Título da opção",
        message: "Digite o texto da opção",
      },
      fallback: {
        undefinedTitle: "Título não definido",
      },
    },
    nodePalette: {
      title: "Nós disponíveis",
      nodeCount: "{{count}} nós profissionais",
      searchPlaceholder: "Buscar nós...",
      noResults: {
        title: "Nenhum nó encontrado",
        subtitle: "Tente outro termo",
      },
      categories: {
        trigger: {
          name: "Gatilhos",
          description: "Inicie seu fluxo automaticamente",
        },
        ai: {
          name: "IA e aprendizado de máquina",
          description: "Inteligência artificial avançada",
        },
        crm: {
          name: "CRM e vendas",
          description: "Gestão de clientes e vendas",
        },
        ecommerce: {
          name: "E-commerce e pagamentos",
          description: "Lojas online e pagamentos",
        },
        communication: {
          name: "Comunicação",
          description: "Mensagens e comunicação",
        },
        database: {
          name: "Bancos de dados",
          description: "Bancos de dados e armazenamento",
        },
        storage: {
          name: "Nuvem e arquivos",
          description: "Armazenamento em nuvem",
        },
        analytics: {
          name: "Analytics e rastreamento",
          description: "Análise e métricas",
        },
        marketing: {
          name: "Marketing e publicidade",
          description: "Marketing e publicidade",
        },
        logic: {
          name: "Lógica e controle de fluxo",
          description: "Controle de fluxo e lógica",
        },
        transform: {
          name: "Transformação de dados",
          description: "Transformação de dados",
        },
        action: {
          name: "Ações e automação",
          description: "Ações e automação",
        },
      },
      nodes: {
        trigger: {
          whatsapp_message: "Mensagem do WhatsApp",
          whatsapp_status: "Status do WhatsApp",
          telegram_message: "Mensagem do Telegram",
          email_received: "E-mail recebido",
          sms_received: "SMS recebido",
          webhook: "Webhook",
          schedule: "Agendamento/Cron",
          form_submit: "Envio de formulário",
          file_upload: "Upload de arquivo",
          api_call: "Chamada de API",
          database_change: "Mudança no banco de dados",
          payment_received: "Pagamento recebido",
          order_placed: "Pedido realizado",
          new_contact: "Novo contato",
          calendar_event: "Evento de calendário",
          button_click: "Clique no botão",
          qr_scan: "Leitura de QR",
          voice_command: "Comando de voz",
        },
        ai: {
          gpt4: "Chat GPT-4",
          gpt4_vision: "Visão GPT-4",
          claude: "Claude 3",
          gemini: "Google Gemini",
          dall_e: "Imagem DALL-E",
          whisper: "Áudio Whisper",
          tts: "Texto para fala",
          intent_detection: "Detecção de intenção",
          sentiment: "Análise de sentimento",
          rag: "Consulta RAG",
          summarize: "Resumo de texto",
          translate: "Tradução",
          classify: "Classificação de texto",
          entity_extraction: "Extração de entidades",
          embeddings: "Gerar embeddings",
          question_answer: "Sistema de perguntas e respostas",
          content_moderate: "Moderação de conteúdo",
          image_recognition: "Reconhecimento de imagem",
          ocr: "OCR: extração de texto",
          face_detection: "Detecção de rosto",
          object_detection: "Detecção de objetos",
          speech_recognition: "Reconhecimento de fala",
          video_analysis: "Análise de vídeo",
          predictive: "Modelo preditivo",
          recommendation: "Motor de recomendação",
        },
        crm: {
          salesforce_lead: "Lead do Salesforce",
          salesforce_contact: "Contato do Salesforce",
          hubspot_contact: "Contato do HubSpot",
          hubspot_deal: "Negócio do HubSpot",
          pipedrive_deal: "Negócio do Pipedrive",
          pipedrive_activity: "Atividade do Pipedrive",
          zoho_lead: "Lead do Zoho",
          zoho_account: "Conta do Zoho",
          dynamics_contact: "Contato do Dynamics",
          freshsales: "Freshsales",
          airtable: "Airtable",
          notion: "Banco de dados do Notion",
          monday: "Monday.com",
          asana: "Tarefa do Asana",
          trello: "Card do Trello",
          jira: "Issue do Jira",
          zendesk: "Ticket do Zendesk",
          intercom: "Mensagem do Intercom",
        },
        ecommerce: {
          shopify_order: "Pedido do Shopify",
          shopify_product: "Produto do Shopify",
          shopify_customer: "Cliente do Shopify",
          woocommerce_order: "Pedido do WooCommerce",
          woocommerce_product: "Produto do WooCommerce",
          mercadolibre: "Mercado Livre",
          amazon: "Amazon FBA",
          ebay: "Anúncio do eBay",
          stripe_payment: "Pagamento Stripe",
          stripe_subscription: "Assinatura Stripe",
          paypal: "Transação PayPal",
          square: "Pagamento Square",
          mercadopago: "Mercado Pago",
          conekta: "Pagamento Conekta",
          wix_store: "Loja Wix",
          squarespace: "Squarespace",
          bigcommerce: "BigCommerce",
          magento: "Magento",
          prestashop: "PrestaShop",
          shipment_tracking: "Rastreamento de envio",
        },
        communication: {
          whatsapp_send: "Enviar WhatsApp",
          whatsapp_template: "Template do WhatsApp",
          whatsapp_media: "Mídia do WhatsApp",
          telegram_send: "Enviar Telegram",
          telegram_bot: "Bot do Telegram",
          slack_message: "Mensagem do Slack",
          slack_channel: "Canal do Slack",
          discord_message: "Mensagem do Discord",
          discord_embed: "Embed do Discord",
          email_smtp: "E-mail SMTP",
          email_template: "Template de e-mail",
          sms_twilio: "SMS Twilio",
          sms_nexmo: "SMS Nexmo",
          voice_call: "Chamada de voz",
          push_notification: "Notificação push",
          teams_message: "Microsoft Teams",
          zoom_meeting: "Reunião do Zoom",
          google_meet: "Google Meet",
          messenger_send: "Facebook Messenger",
          instagram_dm: "DM do Instagram",
          twitter_dm: "DM do Twitter",
          linkedin_message: "Mensagem do LinkedIn",
        },
        database: {
          postgresql: "PostgreSQL",
          mysql: "MySQL",
          mongodb: "MongoDB",
          redis: "Cache Redis",
          elasticsearch: "Elasticsearch",
          firebase_firestore: "Firebase Firestore",
          firebase_realtime: "Firebase Realtime",
          supabase: "Supabase",
          dynamodb: "AWS DynamoDB",
          cosmosdb: "Azure Cosmos DB",
          cassandra: "Cassandra",
          mariadb: "MariaDB",
          oracle: "Oracle DB",
          sql_server: "SQL Server",
          sqlite: "SQLite",
          couchdb: "CouchDB",
          influxdb: "InfluxDB",
          neo4j: "Grafo Neo4j",
        },
        storage: {
          google_drive: "Google Drive",
          google_sheets: "Google Sheets",
          dropbox: "Dropbox",
          s3: "AWS S3",
          azure_blob: "Azure Blob Storage",
          onedrive: "OneDrive",
          box: "Box",
          ftp: "Servidor FTP",
          sftp: "Servidor SFTP",
          github: "Repositório GitHub",
          gitlab: "Repositório GitLab",
          bitbucket: "Bitbucket",
        },
        analytics: {
          google_analytics: "Google Analytics",
          ga4_event: "Evento GA4",
          mixpanel: "Mixpanel",
          amplitude: "Amplitude",
          segment: "Segment (Track)",
          hotjar: "Evento Hotjar",
          posthog: "PostHog",
          heap: "Heap Analytics",
          facebook_pixel: "Facebook Pixel",
          google_tag: "Google Tag Manager",
          custom_event: "Evento personalizado",
          ab_test: "Teste A/B",
        },
        marketing: {
          facebook_ads: "Anúncios do Facebook",
          google_ads: "Anúncios do Google",
          instagram_ads: "Anúncios do Instagram",
          linkedin_ads: "Anúncios do LinkedIn",
          twitter_ads: "Anúncios do Twitter",
          mailchimp: "Campanha Mailchimp",
          sendgrid: "E-mail SendGrid",
          activecampaign: "ActiveCampaign",
          convertkit: "ConvertKit",
          hubspot_email: "E-mail HubSpot",
          klaviyo: "Klaviyo",
          brevo: "Brevo (Sendinblue)",
          tiktok_ads: "Anúncios do TikTok",
          youtube_ads: "Anúncios do YouTube",
          pinterest_ads: "Anúncios do Pinterest",
        },
        logic: {
          condition: "Condição If",
          switch: "Caso Switch",
          router: "Router",
          loop: "Loop/Iterar",
          for_each: "Para cada",
          while: "Loop While",
          filter: "Filtrar array",
          sort: "Ordenar array",
          merge: "Mesclar dados",
          split: "Dividir dados",
          aggregate: "Agregação",
          limit: "Limitar resultados",
          delay: "Atraso/Espera",
          error_handler: "Tratador de erros",
          retry: "Lógica de retry",
        },
        transform: {
          json_parse: "Parser JSON",
          json_stringify: "JSON Stringify",
          xml_parse: "Parser XML",
          csv_parse: "Parser CSV",
          data_mapper: "Mapeador de dados",
          text_extract: "Extrair texto (Regex)",
          text_replace: "Substituir texto",
          hash: "Gerador de hash",
          encrypt: "Criptografar dados",
          decrypt: "Descriptografar dados",
          base64: "Base64 codificar/decodificar",
          url_encode: "Codificar URL",
        },
        action: {
          send_message: "Enviar mensagem",
          create_ticket: "Criar ticket",
          tag_contact: "Marcar contato",
          update_contact: "Atualizar contato",
          create_task: "Criar tarefa",
          send_email: "Enviar e-mail",
          log_event: "Registrar evento",
          webhook_call: "Chamar webhook",
          http_request: "Requisição HTTP",
          graphql: "Consulta GraphQL",
          run_script: "Executar JavaScript",
          python_script: "Executar Python",
          schedule_action: "Agendar ação",
          trigger_flow: "Acionar outro fluxo",
          stop_flow: "Parar fluxo",
        },
      },
    },
    allConnections: {
      table: {
        customer: "Cliente",
        connectedConnections: "Conexões conectadas",
        disconnectedConnections: "Conexões desconectadas",
        totalConnections: "Total de conexões",
      },
    },
    webhooksPage: {
      title: "Webhooks",
      soon: "Em breve.",
    },
    helps: {
      settings: {
        title: "Título",
      },
    },
    plans: {
      form: {
        queues: "Filas",
        amount: "Valor",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        internalChat: "Chat interno",
        externalApi: "API externa",
        kanban: "Kanban",
        openAi: "OpenAI",
        integrations: "Integrações",
      },
    },
    invoices: {
      table: {
        status: "Status",
        idLabel: "ID: {{id}}",
      },
      tooltips: {
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        dueDate: "Vencimento",
      },
      status: {
        paid: "Pago",
        overdue: "Vencida",
        open: "Em aberto",
      },
      actions: {
        pay: "Pagar",
        payNow: "Pagar agora",
      },
      daysLeft: {
        overdueOne: "Vencida há {{days}} dia",
        overdueMany: "Vencida há {{days}} dias",
        dueToday: "Vence hoje",
        dueInOne: "Vence em {{days}} dia",
        dueInMany: "Vence em {{days}} dias",
      },
    },
    buttonPreview: {
      toasts: {
        codeCopied: "Código copiado.",
      },
      errors: {
        noContentToCopy: "Nenhum conteúdo para copiar.",
        noLinkAvailable: "Nenhum link disponível.",
        callsNotSupported: "Chamadas não são suportadas nesta prévia.",
      },
      empty: {
        noButtonsInSection: "Nenhum botão nesta seção.",
        noSectionsAvailable: "Nenhuma seção disponível.",
      },
      alt: {
        preview: "Prévia",
      },
    },
    schedules: {
      calendar: {
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia inteiro",
        week: "Semana",
        workWeek: "Semana útil",
        day: "Dia",
        month: "Mês",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Nenhum evento neste período.",
        showMore: "+{{total}} mais",
      },
    },
    layout: {
      errors: {
        accountAccessedElsewhere:
          "Este usuário já está logado em outro dispositivo. Você será desconectado.",
      },
    },
    messageOptionsMenu: {
      toasts: {
        reactionSent: "Reação enviada.",
      },
    },
    newTicketModal: {
      placeholders: {
        queue: "Selecione uma fila",
        connection: "Selecione uma conexão",
      },
      errors: {
        queueRequired: "Selecione uma fila para continuar.",
      },
    },
    analytics: {
      title: "Analytics",
      subtitle: "Métricas e tendências do seu negócio",
      toasts: {
        loadError: "Erro ao carregar analytics.",
      },
      period: {
        label: "Período",
        options: {
          week: "Semana",
          month: "Mês",
          quarter: "Trimestre",
          year: "Ano",
        },
      },
      metrics: {
        totalRevenue: "Receita total",
        totalLeads: "Total de leads",
        conversionRate: "Taxa de conversão",
        avgDealSize: "Ticket médio",
        vsPreviousPeriod: "{{value}}% vs período anterior",
      },
      monthlyTrends: {
        title: "Tendências mensais",
        revenueTrend: "Tendência de receita",
        table: {
          month: "Mês",
          leads: "Leads",
          conversions: "Conversões",
          conversionRate: "Taxa",
          revenue: "Receita",
        },
      },
      topProducts: {
        title: "Principais produtos",
        salesLabel: "{{count}} vendas",
      },
      leadSources: {
        title: "Fontes de leads",
        countLabel: "{{count}} leads",
      },
    },
    campaignsPhrase: {
      toasts: {
        deleted: "Frase excluída com sucesso.",
      },
    },
    messagesAPI: {
      toasts: {
        sent: "Mensagem enviada com sucesso.",
      },
      labels: {
        endpoint: "Endpoint",
        method: "Método",
        headers: "Headers",
        body: "Body",
        formData: "FormData",
        testSend: "Envio teste",
      },
      docs: {
        headers: {
          json: "Authorization Bearer (token cadastrado) e Content-Type (application/json)",
          formData:
            "Authorization Bearer (token cadastrado) e Content-Type (multipart/form-data)",
        },
        fields: {
          userIdHint: "ID do usuário/agente ou \"\"",
          queueIdHint: "ID da fila ou \"\"",
          mediasHint: "arquivo",
          sendSignatureHint: "Assinar mensagem - true/false",
          closeTicketHint: "Encerrar ticket - true/false",
        },
      },
    },
    messageModal: {
      title: {
        add: "Nova mensagem agendada",
        edit: "Editar mensagem agendada",
      },
      success: {
        save: "Mensagem agendada salva.",
      },
      placeholders: {
        connection: "Conexão",
        contacts: "Contatos",
        users: "Usuários",
      },
      form: {
        createTicket: "Criar ticket",
      },
    },
    listPreview: {
      modal: {
        title: "Lista de botões",
      },
      fields: {
        selectedTitlePlaceholder: "Título selecionado",
      },
      a11y: {
        selectedTitle: "título selecionado",
      },
      alerts: {
        selectTitle: "Por favor, selecione um título.",
        ticketIdNotFound: "Erro: ticketId não encontrado.",
        sendError: "Erro ao enviar a mensagem. Tente novamente.",
      },
    },
    scheduleModal: {
      statusTitle: {
        sendError: "Erro de envio",
        messageWithStatus: "Mensagem {{status}}",
      },
    },
  },
  fr: {
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      create: "Créer",
      update: "Mettre à jour",
      add: "Ajouter",
      edit: "Modifier",
      import: "Importer",
      export: "Exporter",
      confirm: "Confirmer",
      close: "Fermer",
      delete: "Supprimer",
      duplicate: "Dupliquer",
      refresh: "Actualiser",
      search: "Rechercher",
      configure: "Configurer",
      upgradePlan: "Améliorer le plan",
      company: "Entreprise",
      package: "Forfait",
      assignCredits: "Attribuer des crédits",
      copied: "Copié",
      yes: "Oui",
      no: "Non",
      active: "Actif",
      inactive: "Inactif",
      actions: "Actions",
      status: "Statut",
      source: "Source",
      date: "Date",
      id: "ID",
      name: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      notes: "Notes",
      description: "Description",
      price: "Prix",
      tokens: "Tokens",
      clear: "Effacer",
      deactivate: "Désactiver",
      activate: "Activer",
      anErrorOccurred: "Une erreur s'est produite.",
      loading: "Chargement...",
      ok: "OK",
      total: "Total",
      other: "Autre",
      send: "Envoyer",
      chat: "Discuter",
      placeholders: {
        emailAddress: "Adresse e-mail",
      },
      alt: {
        thumbnail: "Miniature",
      },
      validation: {
        required: "Obligatoire.",
        tooShort: "Trop court.",
        tooLong: "Trop long.",
        passwordRequired: "Le mot de passe est obligatoire.",
        invalidEmail: "Email invalide.",
        apiKeyRequired: "La clé API est obligatoire.",
        voiceModeRequired: "Le mode voix est obligatoire.",
        ratingRequired: "L'évaluation est obligatoire.",
        passwordsMustMatch: "Les mots de passe doivent correspondre.",
        invalidOption: "Option invalide.",
        minValue: "Minimum {{min}}.",
        maxValue: "Maximum {{max}}.",
      },
      errors: {
        loadRecords: "Impossible de charger la liste des enregistrements.",
        noPermissionRedirect:
          "Cette entreprise n'a pas l'autorisation d'accéder à cette page. Redirection en cours.",
        operationFailed: "Échec de l'opération.",
        operationFailedDuplicateOrInvalid:
          "Échec de l'opération. Vérifiez les données et réessayez.",
      },
      toasts: {
        success: "Opération effectuée avec succès.",
        clickSaveToApplyChanges:
          'Cliquez sur "Enregistrer" pour appliquer les changements.',
      },
      confirmationModal: {
        deleteTitle: "Supprimer l'enregistrement",
        deleteMessage: "Voulez-vous vraiment supprimer cet enregistrement ?",
      },
    },
    backendErrors: {
      plan_limit_exceeded:
        "Vous avez atteint la limite de connexions de votre abonnement. Mettez à niveau votre plan pour en ajouter davantage.",
    },
    connections: {
      table: {
        channel: "Canal",
      },
    },
    compaies: {
      table: {
        folderSize: "Taille du dossier",
        totalFiles: "Total des fichiers",
        lastFolderUpdate: "Dernière mise à jour du dossier",
      },
    },
    qrCode: {
      waiting: "En attente du QR code",
    },
    chatbots: {
      toasts: {
        saved: "Chatbot enregistré avec succès.",
        deleted: "Chatbot supprimé avec succès.",
      },
      confirmationModal: {
        deleteMessage:
          "Êtes-vous sûr ? Toutes les options internes seront également supprimées.",
      },
      validation: {
        optionNameMin:
          "Le nom de l'option doit contenir au moins 4 caractères.",
        optionNameRequired: "Le nom de l'option est obligatoire.",
        optionsRequired: "Vous devez ajouter au moins une option.",
      },
    },
    contactImportWpModal: {
      status: {
        completed: "Importation terminée avec succès.",
        inProgress:
          "Importation en cours {{current}} sur {{total}}. Veuillez ne pas quitter cet écran jusqu'à la fin de l'importation.",
      },
    },
    tagsKanban: {
      form: {
        stage: "Étape Kanban",
      },
    },
    filters: {
      placeholders: {
        contacts: "Contacts",
        connections: "Connexions",
        departments: "Départements",
        statusFilter: "Filtrer par statut",
        tagsFilter: "Filtrer par tags",
        tags: "Tags",
      },
    },
    tagsContainer: {
      errors: {
        tooShort: "Tag trop court.",
      },
    },
    tickets: {
      search: {
        filterConectionsOptions: {
          groups: "Groupes",
        },
      },
      simulateIncoming: {
        channelFallback: "canal",
        body: "Message de test ({{channel}})",
        menuLabel: "Simuler un message entrant",
        toasts: {
          success: "Message entrant simulé.",
        },
      },
    },
    messageUploadMedias: {
      placeholders: {
        caption: "Légende (optionnelle)",
      },
      fallback: {
        unavailable: "Aperçu non disponible",
      },
      alt: {
        image: "Image {{index}}",
      },
    },
    ticket: {
      chat: {
        searchPlaceholder: "Rechercher dans ce chat...",
      },
    },
    messagesList: {
      deletedMessage: "🚫 _Message supprimé_",
      deletedText: "🚫 Message supprimé",
      deletedByContactText: "🚫 Ce message a été supprimé par le contact",
      forwarded: "Transféré",
      reacted: "Vous avez réagi... {{reaction}}",
      editedAt: "Modifié {{time}}",
      empty: {
        startConversation: "Dites bonjour à votre nouveau contact !",
      },
      dragDrop: {
        dropHere: "Déposez le fichier ici",
      },
      facebookPolicy24h:
        "Vous avez 24 h pour répondre après avoir reçu un message, conformément aux politiques de Facebook.",
    },
    recurrence: {
      title: "Récurrence",
      description:
        "Vous pouvez envoyer le message de manière récurrente et choisir l'intervalle. S'il s'agit d'un envoi unique, ne modifiez rien dans cette section.",
      interval: {
        label: "Intervalle",
        valueLabel: "Valeur de l'intervalle",
        options: {
          days: "Jours",
          weeks: "Semaines",
          months: "Mois",
          minutes: "Minutes",
        },
      },
      sendCount: {
        label: "Envoyer combien de fois",
      },
      businessDaysPolicy: {
        label: "Jours non ouvrés",
        options: {
          normal: "Envoyer normalement les jours non ouvrés",
          before: "Envoyer un jour ouvré avant",
          after: "Envoyer un jour ouvré après",
        },
      },
      showUser: "Afficher l'utilisateur",
    },
    whatsappModal: {
      flowbuilder: {
        welcomeFlow: {
          title: "Flux de bienvenue",
          description:
            "Ce flux est déclenché uniquement pour les nouveaux contacts : les personnes qui ne sont pas dans votre liste de contacts et qui ont envoyé un message.",
        },
        defaultResponseFlow: {
          title: "Flux de réponse par défaut",
          description:
            "La réponse par défaut est envoyée pour tout caractère différent d'un mot-clé. Attention : elle sera déclenchée si la conversation est déjà fermée.",
        },
      },
    },
    ticketsList: {
      preview: {
        title: "Aperçu de la conversation",
      },
      loadingMessages: "Chargement des messages...",
      tooltips: {
        previewConversation: "Aperçu de la conversation",
      },
      adClick: "Clic sur l'annonce",
    },
    userModal: {
      form: {
        profiles: {
          admin: "Administrateur",
          user: "Utilisateur",
        },
      },
    },
    contactNotesEditModal: {
      title: "Modifier la note",
      fields: {
        note: "Note",
      },
    },
    updateNotification: {
      title: "Nouvelle version disponible !",
      subtitle: "Une mise à jour du système est disponible.",
      versionLabel: "Version : {{version}}",
      instruction: 'Cliquez sur "Mettre à jour maintenant" pour charger la nouvelle version.',
      buttons: {
        later: "Plus tard",
        updateNow: "Mettre à jour maintenant",
      },
    },
    settings: {
      tabs: {
        sla: "SLA",
        schedules: "Horaires",
        companies: "Entreprises",
        modules: "Modules",
        planModules: "Plan-Modules",
        companyModules: "Modules de l'entreprise",
        aiTokens: "Tokens IA",
        whitelabel: "Marque blanche",
      },
      settings: {
        customMessages: {
          transferMessageDefault:
            `Votre ticket a été transféré au service \${queue.name}. Veuillez patienter...`,
        },
        options: {
          text: "Texte",
        },
      },
      whitelabel: {
        fields: {
          primaryColorLight: "Couleur principale (mode clair)",
          primaryColorDark: "Couleur principale (mode sombre)",
          systemName: "Nom du système",
          logoLight: "Logo clair",
          logoDark: "Logo sombre",
          favicon: "Favicon",
        },
        errors: {
          uploadImage: "Impossible de téléverser l'image.",
        },
      },
    },
    aiTokens: {
      title: "Tokens IA",
      packages: {
        form: {
          name: "Nom",
          tokens: "Tokens",
          price: "Prix",
          active: "Actif",
        },
        table: {
          name: "Nom",
          tokens: "Tokens",
          price: "Prix",
          active: "Actif",
        },
        buttons: {
          clear: "Effacer",
          save: "Enregistrer",
          deactivate: "Désactiver",
          assignCredits: "Attribuer des crédits",
        },
        credit: {
          company: "Entreprise",
          package: "Forfait IA",
        },
        confirm: {
          deactivateTitle: "Désactiver le forfait",
          deactivateMessage: "Voulez-vous désactiver ce forfait IA ?",
        },
        toasts: {
          companiesLoadError: "Impossible de charger les entreprises.",
          packagesLoadError: "Impossible de charger les forfaits.",
          packageSaved: "Forfait enregistré.",
          packageSaveError: "Impossible d'enregistrer le forfait.",
          packageDeactivated: "Forfait désactivé.",
          packageDeactivateError: "Impossible de désactiver le forfait.",
          selectCompanyAndPackage: "Sélectionnez une entreprise et un forfait.",
          creditsAssigned: "Crédits IA attribués.",
          creditsAssignError: "Impossible d'attribuer des crédits.",
        },
      },
    },
    leads: {
      title: "Gestion des leads",
      subtitle: "Gérez vos opportunités de vente",
      buttons: {
        refresh: "Actualiser",
        new: "Nouveau lead",
        cancel: "Annuler",
        create: "Créer",
        update: "Mettre à jour",
      },
      stats: {
        total: "Total des leads",
        new: "Nouveaux",
        qualified: "Qualifiés",
        contacted: "Contactés",
      },
      filters: {
        searchPlaceholder: "Rechercher des leads...",
        status: "Statut",
        source: "Source",
        all: "Tous",
        allFeminine: "Toutes",
      },
      table: {
        name: "Nom",
        contact: "Contact",
        status: "Statut",
        source: "Source",
        score: "Score",
        date: "Date",
        actions: "Actions",
        empty: "Aucun lead à afficher",
      },
      pagination: {
        rowsPerPage: "Lignes par page",
        displayedRows: "{{from}}-{{to}} sur {{count}}",
        moreThan: "plus de {{to}}",
      },
      dialog: {
        addTitle: "Nouveau lead",
        editTitle: "Modifier le lead",
      },
      form: {
        name: "Nom",
        nameRequired: "Le nom est obligatoire",
        email: "E-mail",
        phone: "Téléphone",
        phonePlaceholder: "+51987654321",
        status: "Statut",
        source: "Source",
        score: "Score (0-100)",
        notes: "Notes",
      },
      confirm: {
        delete: "Êtes-vous sûr de vouloir supprimer ce lead ?",
      },
      status: {
        new: "Nouveau",
        contacted: "Contacté",
        qualified: "Qualifié",
        converted: "Converti",
        lost: "Perdu",
      },
      sources: {
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        website: "Site web",
        referral: "Parrainage",
        cold_call: "Appel",
        email: "E-mail",
        other: "Autre",
      },
      contactActions: {
        whatsapp: "WhatsApp",
        call: "Appeler",
        email: "E-mail",
      },
      toasts: {
        loadError: "Erreur lors du chargement des leads.",
        saveError: "Erreur lors de l'enregistrement du lead.",
        deleteError: "Erreur lors de la suppression du lead.",
        updated: "Lead mis à jour avec succès.",
        created: "Lead créé avec succès.",
        deleted: "Lead supprimé avec succès.",
      },
    },
    abTesting: {
      title: "Tests A/B IA",
      subtitle: "Optimisez les réponses IA avec des expériences contrôlées",
      actions: {
        refresh: "Actualiser",
      },
      errors: {
        loadData: "Erreur lors du chargement des données A/B Testing",
      },
      stats: {
        totalExperiments: "Total des expériences",
        activeLabel: "{{count}} actives",
        totalImpressions: "Impressions totales",
        conversions: "Conversions",
        conversionRate: "Taux de conversion",
      },
      table: {
        title: "Expériences",
        idLabel: "ID : {{id}}",
        headers: {
          experiment: "Expérience",
          description: "Description",
          variants: "Variantes",
          impressions: "Impressions",
          status: "Statut",
          actions: "Actions",
        },
        status: {
          active: "Active",
          stopped: "Arrêtée",
        },
        tooltips: {
          viewDetails: "Voir les détails",
          stopExperiment: "Arrêter l'expérience",
        },
      },
      dialog: {
        progressTitle: "Progression de l'expérience",
        samples: "{{count}} échantillons",
        goal: "Objectif : {{count}}",
        significant: "L'expérience a atteint une significativité statistique",
        winnerTitle: "Gagnant actuel : {{name}}",
        score: "Score : {{score}}",
        variantsTitle: "Variantes",
        variantsHeaders: {
          variant: "Variante",
          impressions: "Impressions",
          conversions: "Conversions",
          conversionRate: "Taux conv.",
          satisfaction: "Satisfaction",
          escalations: "Escalades",
        },
        control: "Contrôle",
        actions: {
          close: "Fermer",
          stop: "Arrêter l'expérience",
        },
      },
    },
    registerClient: {
      title: "Enregistrer un nouveau client",
      subtitle: "Renseignez les informations pour enregistrer un nouveau client",
      steps: {
        company: "Informations sur l'entreprise",
        contact: "Personne de contact",
        plan: "Plan et services",
      },
      industries: {
        retail: "Commerce de détail",
        restaurant: "Restaurant",
        healthcare: "Santé",
        education: "Éducation",
        technology: "Technologie",
        services: "Services",
        ecommerce: "E-commerce",
        realEstate: "Immobilier",
        other: "Autre",
      },
      company: {
        title: "Informations sur l'entreprise",
        fields: {
          name: "Nom de l'entreprise",
          industry: "Secteur",
          email: "E-mail de l'entreprise",
          phone: "Téléphone de l'entreprise",
          address: "Adresse",
          website: "Site web",
        },
      },
      contact: {
        title: "Personne de contact",
        fields: {
          name: "Nom complet",
          position: "Poste/Fonction",
          email: "E-mail du contact",
          phone: "Téléphone du contact",
        },
      },
      plan: {
        title: "Choisir un plan",
        includes: {
          users: "Utilisateurs",
          connections: "Connexions",
          queues: "Files",
        },
        perMonth: "/mois",
        billingCycle: "Cycle de facturation",
        billingMonthly: "Mensuel",
        billingAnnual: "Annuel (2 mois offerts)",
      },
      addons: {
        title: "Services supplémentaires",
        pricePerMonth: `+\${{amount}}/mois`,
      },
      notes: {
        title: "Notes supplémentaires",
        placeholder: "Ajoutez toute note ou commentaire sur ce client...",
      },
      total: {
        label: "Total à facturer",
        perYear: "/an",
        perMonth: "/mois",
      },
      buttons: {
        back: "Retour",
        next: "Suivant",
        submit: "Enregistrer le client",
      },
      toasts: {
        stepCompanyRequired: "Veuillez compléter tous les champs obligatoires.",
        stepContactRequired: "Veuillez compléter les informations du contact.",
        success: "Client enregistré avec succès !",
        error: "Erreur lors de l'enregistrement du client.",
      },
    },
    subscription: {
      free: "Gratuit",
      license: {
        noExpiration: "Sans expiration",
        expiresToday: "Votre licence expire aujourd'hui",
        expiredOn: "Licence expirée le {{date}}",
        expiresIn: "Votre licence expire dans {{days}} {{dayWord}} ({{date}})",
        day: "jour",
        days: "jours",
      },
      fields: {
        dueDate: "Échéance",
        billingEmail: "E-mail de facturation",
        currentPlan: "Plan actuel",
        users: "Utilisateurs",
        connections: "Connexions",
        queues: "Files",
        price: "Prix",
      },
      upgrade: {
        title: "Améliorer le plan",
        button: "Mettre à jour le plan",
        updating: "Mise à jour...",
      },
      contact: {
        button: "S'abonner maintenant",
      },
      toasts: {
        planUpdated: "Plan mis à jour avec succès.",
      },
    },
    configApis: {
      title: "Connecter APIs",
      channels: {
        whatsappTitle: "WhatsApp Cloud API",
        facebookTitle: "Facebook Messenger",
        instagramTitle: "Instagram Messaging",
      },
      summary: {
        title: "Résumé",
        activeConnections: "Connexions actives (APIs Meta) :",
        planLimit: "Limite de votre abonnement :",
        limitReached: "Limite atteinte : pour ajouter plus de connexions, améliorez votre plan.",
      },
      channelCard: {
        activeConnections: "Connexions actives :",
        configure: "Configurer",
        upgradePlan: "Améliorer le plan",
      },
      actions: {
        refresh: "Actualiser",
      },
      subtitles: {
        whatsapp: "Phone Number ID + Access Token + Webhook",
        facebook: "Page + Access Token + Webhook",
        instagram: "Compte + Access Token + Webhook",
      },
      empty: {
        title: "Connecter APIs",
        subtitle: "Votre plan n'a pas les modules Meta activés.",
        button: "Voir les plans",
      },
    },
    whatsappApi: {
      title: "WhatsApp API",
      actions: {
        copyWebhook: "Copier le webhook",
        newConnection: "Nouvelle connexion",
        copy: "Copier",
        save: "Enregistrer",
        saving: "Enregistrement...",
        rotating: "Rotation...",
        rotateVerifyToken: "Régénérer Verify Token",
        rotateSecrets: "Régénérer WebhookKey + Verify Token",
      },
      toasts: {
        copied: "Copié",
        connectionUpdated: "Connexion mise à jour.",
        connectionCreated: "Connexion créée.",
        connectionDeleted: "Connexion supprimée.",
        connectionSavedButMetaSubscribeFailed:
          "Connexion enregistrée, mais l'abonnement automatique sur Meta n'a pas pu être terminé. {{reason}}",
        metaSubscribeOk: "Abonnement sur Meta terminé.",
        metaSubscribeFailed: "Impossible de terminer l'abonnement sur Meta. {{reason}}",
        verifyTokenRotated: "Verify Token mis à jour. Mettez-le à jour sur Meta et vérifiez à nouveau.",
        secretsRotated: "WebhookKey et Verify Token mis à jour. Mettez-les à jour sur Meta et vérifiez à nouveau.",
      },
      modal: {
        editTitle: "Modifier la connexion WhatsApp API",
        newTitle: "Nouvelle connexion WhatsApp API",
      },
      form: {
        name: "Nom",
        phoneNumberId: "Phone Number ID",
        phoneNumberIdHelper: "Ex : 123456789012345",
        wabaIdOptional: "WABA ID",
        accessToken: "Access Token",
        accessTokenEditHint: "Access Token (laisser vide pour conserver)",
        useAsDefault: "Utiliser par défaut",
        cancel: "Annuler",
      },
      validation: {
        nameMin: "Le nom doit contenir au moins 2 caractères",
        nameRequired: "Le nom est obligatoire",
        phoneNumberIdRequired: "Phone Number ID est obligatoire",
        wabaIdRequired: "WABA ID est obligatoire",
        accessTokenRequired: "Access Token est obligatoire",
      },
      errors: {
        missingWabaId: "WABA ID manquant. Ajoutez-le et enregistrez à nouveau pour l'abonnement automatique sur Meta.",
        missingAccessToken: "Access Token manquant. Ajoutez-le et enregistrez à nouveau.",
        appNotSubscribed:
          "L'app n'apparaît pas abonnée au WABA. Vérifiez les permissions du token ou abonnez manuellement sur Meta.",
      },
      confirm: {
        deleteTitle: "Supprimer la connexion",
        deleteMessage: "Supprimer la connexion {{name}} ?",
      },
      rotateVerifyToken: {
        title: "Régénérer Verify Token",
        message:
          "Vous allez générer un nouveau Verify Token. L'ancien token ne sera plus utilisé. Ensuite, vous devez le mettre à jour dans Meta Developer et re-vérifier le webhook. Continuer ?",
      },
      rotateSecrets: {
        title: "Régénérer WebhookKey + Verify Token",
        message:
          "Vous allez générer un nouveau WebhookKey et un nouveau Verify Token. L'URL du webhook changera et l'ancien token ne sera plus utilisé. Ensuite, vous devez mettre à jour les deux dans Meta Developer et re-vérifier le webhook. Continuer ?",
      },
      table: {
        name: "Nom",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        meta: "Meta",
        default: "Par défaut",
        webhook: "Webhook",
        actions: "Actions",
      },
      values: {
        yes: "Oui",
        no: "Non",
        verified: "Vérifié",
        pending: "En attente",
        metaSubscribed: "Abonné",
        metaError: "Erreur",
        metaUnknown: "En attente",
      },
      empty: "Aucune connexion. Créez-en une pour commencer.",
      helper: {
        title: "Données Meta (uniques par client)",
        step1: "Dans Meta Developer, configurez le webhook avec :",
        webhookUrl: "Webhook URL :",
        verifyToken: "Verify Token :",
        step2: "Abonnez-vous à l'événement messages. Lors de l'enregistrement/activation, Klorum tente d'abonner votre app au WABA automatiquement.",
        step3: "Lorsque Meta vérifie, vous verrez le statut Vérifié.",
        step4: "Les messages entrants arriveront dans WhatsApp (Tickets) et vous pourrez répondre depuis le chat.",
        user: "Utilisateur :",
      },
      tooltips: {
        retryMetaSubscribe: "Réessayer l'abonnement sur Meta",
        edit: "Modifier",
        delete: "Supprimer",
      },
    },
    dashboard: {
      errors: {
        loadData: "Impossible de charger les données du tableau de bord.",
      },
      filters: {
        title: "Filtres",
      },
      export: {
        agentsSheet: "RapportAgents",
        agentsFile: "rapport-agents.xlsx",
        error: "Erreur lors de l'exportation vers Excel.",
      },
      charts: {
        errors: {
          loadTicketsInfo: "Impossible de charger les informations des tickets.",
        },
        perHour: {
          title: "Tickets par heure",
        },
        ticketsLabel: "Tickets",
        empty: {
          noData: "Aucune donnée à afficher.",
          noDataForPeriod: "Aucune donnée pour la période sélectionnée.",
        },
      },
      membership: {
        title: "Mon abonnement",
        details: "Voir les détails",
        availablePlansTitle: "Forfaits disponibles",
        availablePlansSubtitle:
          "Votre forfait actuel s'applique automatiquement aux limites et modules du système.",
        loadingPlans: "Chargement des forfaits...",
        noPublicPlans: "Aucun forfait public disponible pour le moment.",
        planLabel: "Forfait",
        activeBadge: "ACTIF",
        channelsLabel: "Canaux",
        buttons: {
          current: "Forfait actuel",
          upgrade: "Améliorer",
          view: "Voir",
        },
        license: {
          noExpiration: "Sans expiration",
          expiresToday: "Expire aujourd'hui",
          expiredOn: "Expiré le {{date}}",
          expiresOn: "Expire le {{date}}",
        },
      },
      channels: {
        titleOverline: "Canaux",
        title: "État des canaux",
        subtitle: "Connexions actives et dernière synchronisation par canal.",
        configureApis: "Configurer les API",
        loading: "Chargement de l'état des canaux...",
        empty: "Aucune information de canal disponible.",
        status: {
          connected: "Connecté",
          disconnected: "Déconnecté",
          error: "Erreur",
        },
        errors: {
          load: "Impossible de charger l'état des canaux.",
        },
      },
      analytics: {
        title: "Analytics (mois en cours)",
        period: "Période : {{from}} à {{to}}",
        chips: {
          unavailable: "Indisponible",
          realData: "Données réelles",
        },
        disabledMessage:
          "Votre forfait actuel n'inclut pas le module Analytics. Améliorez votre forfait pour voir ces métriques.",
        loading: "Chargement des analytics...",
        metrics: {
          monthlyRevenue: "Revenu (mois)",
          totalRevenue: "Revenu (total)",
          conversion: "Conversion",
          firstResponse: "1re réponse (min)",
          activeUsers: "Utilisateurs actifs",
          newLeads: "Nouveaux prospects",
          closings: "Affaires conclues",
        },
        activity: {
          title: "Activité récente",
          loading: "Chargement de l'activité...",
          empty: "Aucune activité récente disponible.",
          fallbackTitle: "Activité",
        },
        errors: {
          metrics: "Impossible de charger les métriques de l'entreprise.",
          activity: "Impossible de charger l'activité récente.",
        },
      },
    },
    flowBuilder: {
      defaultFlowName: "Nouveau flux",
      copySuffix: "(Copie)",
      list: {
        title: "Flux de conversation",
        addFlow: "Ajouter un flux",
        searchPlaceholder: "Rechercher un flux...",
        empty: "Vous n'avez pas encore de flux.",
        noMatches: "Aucun résultat pour votre recherche.",
        status: {
          active: "Actif",
          inactive: "Désactivé",
        },
        menu: {
          editName: "Modifier le nom",
          editFlow: "Modifier le flux",
          duplicate: "Dupliquer",
          delete: "Supprimer",
        },
        confirm: {
          deleteTitle: "Supprimer le flux {{name}} ?",
          deleteBody:
            "Êtes-vous sûr de vouloir supprimer ce flux ? Toutes les intégrations associées seront perdues.",
          duplicateTitle: "Dupliquer le flux {{name}} ?",
          duplicateBody: "Êtes-vous sûr de vouloir dupliquer ce flux ?",
        },
        toasts: {
          deleted: "Flux supprimé avec succès",
          duplicated: "Flux dupliqué avec succès",
        },
      },
      modals: {
        question: {
          titleCreate: "Ajouter une question au flux",
          titleEdit: "Modifier la question",
          fields: {
            message: "Message",
            answerKey: "Enregistrer la réponse comme",
          },
        },
        text: {
          titleCreate: "Ajouter un message au flux",
          titleEdit: "Modifier le message",
          fields: {
            message: "Message",
          },
        },
        image: {
          titleCreate: "Ajouter une image au flux",
          titleEdit: "Modifier l'image",
          buttons: {
            upload: "Téléverser une image",
          },
          errors: {
            fileTooLarge: "Fichier trop volumineux. Max 2 Mo.",
          },
          toasts: {
            created: "Image ajoutée avec succès.",
            updated: "Image mise à jour avec succès.",
          },
        },
        audio: {
          titleCreate: "Ajouter un audio au flux",
          titleEdit: "Modifier l'audio",
          buttons: {
            upload: "Téléverser un audio",
          },
          fields: {
            record: "Envoyer comme audio enregistré à l'instant",
          },
          fallback: "Votre navigateur ne prend pas en charge HTML5",
          errors: {
            fileTooLarge: "Fichier trop volumineux. Max 5 Mo.",
          },
          toasts: {
            created: "Audio ajouté avec succès.",
            updated: "Audio mis à jour avec succès.",
          },
        },
        video: {
          titleCreate: "Ajouter une vidéo au flux",
          titleEdit: "Modifier la vidéo",
          buttons: {
            upload: "Téléverser une vidéo",
          },
          warnings: {
            onlyMp4: "ATTENTION : vidéos MP4 uniquement.",
          },
          fallback: "Votre navigateur ne prend pas en charge HTML5",
          errors: {
            fileTooLarge: "Fichier trop volumineux. Max 20 Mo.",
          },
          toasts: {
            created: "Vidéo ajoutée avec succès.",
            updated: "Vidéo mise à jour avec succès.",
          },
        },
        openai: {
          titleCreate: "Ajouter OpenAI/Gemini au flux",
          titleEdit: "Modifier OpenAI/Gemini",
          voice: {
            text: "Texte",
          },
        },
        interval: {
          titleCreate: "Ajouter un intervalle au flux",
          titleEdit: "Modifier l'intervalle",
          fields: {
            seconds: "Temps en secondes",
          },
          errors: {
            required: "Ajoutez une valeur d'intervalle.",
            maxSeconds: "Temps maximum : 120 secondes.",
          },
        },
        condition: {
          titleCreate: "Ajouter une condition au flux",
          titleEdit: "Modifier la condition",
          fields: {
            key: "Champ de condition (saisissez une seule clé)",
            rule: "Règle de validation",
            value: "Valeur de la condition à analyser",
          },
        },
        ticket: {
          titleCreate: "Ajouter une file d'attente au flux",
          titleEdit: "Modifier la file d'attente",
          placeholders: {
            selectQueue: "Sélectionnez une file d'attente",
          },
          errors: {
            requiredQueue: "Sélectionnez une file d'attente.",
          },
        },
        menu: {
          titleCreate: "Ajouter un menu au flux",
          titleEdit: "Modifier le menu",
          fields: {
            message: "Message d'explication du menu",
          },
          buttons: {
            addOption: "Ajouter une option",
          },
          optionPrompt: "Saisissez {{number}}",
          placeholders: {
            option: "Saisissez une option",
          },
        },
        randomizer: {
          titleCreate: "Ajouter un randomiseur au flux",
          titleEdit: "Modifier le randomiseur",
          aria: {
            slider: "Pourcentage",
          },
          errors: {
            required: "Ajoutez un pourcentage.",
            maxPercent: "Pourcentage maximum : 100.",
          },
        },
        typebot: {
          titleCreate: "Ajouter Typebot au flux",
          titleEdit: "Modifier Typebot",
        },
        singleBlock: {
          titleCreate: "Ajouter du contenu au flux",
          titleEdit: "Modifier le contenu",
          elements: {
            text: "Texte",
            interval: "Intervalle",
            image: "Image",
            audio: "Audio",
            video: "Vidéo",
            document: "Document",
          },
          buttons: {
            uploadImage: "Téléverser une image",
            uploadAudio: "Téléverser un audio",
            uploadVideo: "Téléverser une vidéo",
            uploadDocument: "Téléverser un document",
          },
          fields: {
            message: "Message",
            seconds: "Temps en secondes",
            recordAudio: "Envoyer comme audio enregistré à l'instant",
            variables: "Variables",
          },
          file: {
            noFileSelected: "Aucun fichier sélectionné",
          },
          loading: {
            uploading: "Téléversement des fichiers et création du contenu...",
          },
          toasts: {
            saved: "Contenu enregistré avec succès.",
          },
          errors: {
            messageEmpty: "Le champ du message est vide.",
            intervalInvalid: "L'intervalle ne peut pas être 0 ni supérieur à 120.",
            fileTooLarge: "Fichier trop volumineux. Max {{maxMb}} Mo.",
            pendingUploads:
              "Supprimez les cartes vides ou téléversez les fichiers en attente.",
          },
        },
      },
    },
    flowBuilderCanvas: {
      back: "Retour",
      title: "FlowBuilder Canvas",
      testFlow: "Tester le flux",
      save: "Enregistrer",
      alerts: {
        saved: "Flux enregistré avec succès",
        saveError: "Erreur lors de l'enregistrement du flux",
        testSoon: "Fonction de test bientôt disponible",
        confirmDeleteNode: "Êtes-vous sûr de vouloir supprimer ce nœud ?",
      },
      nodeConfig: {
        sections: {
          basic: "Configuration de base",
          advanced: "Options avancées",
        },
        fields: {
          nodeName: "Nom du nœud",
          model: "Modèle",
          systemPrompt: "Prompt système",
          temperatureLabel: "Température : {{value}}",
          maxTokens: "Tokens max",
          intents: "Intentions possibles (séparées par des virgules)",
          confidenceLabel: "Seuil de confiance : {{value}}",
          webhookUrl: "URL du webhook",
          httpMethod: "Méthode HTTP",
          requireAuth: "Authentification requise",
          secretKey: "Clé secrète",
          scheduleType: "Type de planification",
          cronExpression: "Expression cron",
          messageTemplate: "Modèle de message",
          includeMedia: "Inclure un média",
          mediaUrl: "URL du média",
          emailSubject: "Sujet",
          emailBody: "Corps de l'e-mail (HTML)",
          fromEmail: "E-mail expéditeur",
          conditionType: "Type de condition",
          fieldToCheck: "Champ à vérifier",
          operator: "Opérateur",
          valueToCompare: "Valeur à comparer",
          jsExpression: "Expression JavaScript",
          continueOnError: "Continuer en cas d'erreur",
          retryOnFailure: "Réessayer en cas d'échec",
        },
        placeholders: {
          nodeName: "Saisissez le nom du nœud...",
          systemPrompt: "Vous êtes un assistant utile...",
          intents: "achat, question, réclamation...",
          secretKey: "Saisissez la clé secrète...",
          cronExpression: "0 9 * * * (Tous les jours à 9 h)",
          messageTemplate: "Bonjour {{name}}, merci de nous avoir contactés...",
          emailSubject: "Sujet de l'e-mail...",
          emailBody: "<h1>Bonjour {{name}}</h1><p>...</p>",
          fieldToCheck: "ex : user.age, message.text",
          valueToCompare: "Saisissez une valeur...",
        },
        defaults: {
          intents: "achat, question, réclamation, annulation",
        },
        options: {
          scheduleType: {
            cron: "Expression cron",
            interval: "Intervalle",
            specific: "Date/heure spécifique",
          },
          intervalUnit: {
            minutes: "Minutes",
            hours: "Heures",
            days: "Jours",
          },
          conditionType: {
            simple: "Simple (A == B)",
            multiple: "Multiples (AND/OR)",
            expression: "Expression JavaScript",
          },
          operator: {
            equals: "Égal (==)",
            notEquals: "Différent (!=)",
            greater: "Supérieur à (>)",
            less: "Inférieur à (<)",
            contains: "Contient",
            startsWith: "Commence par",
            endsWith: "Se termine par",
          },
        },
        helpers: {
          temperature:
            "Valeurs élevées = plus créatif. Valeurs faibles = plus déterministe.",
          cronExpression:
            "Exemple : \"0 9 * * *\" s'exécute tous les jours à 9 h 00",
          variables: "Utilisez {{variable}} pour les variables dynamiques",
        },
        empty: {
          noSpecificConfig:
            "Aucune configuration spécifique pour ce type de nœud.",
          connectHelp:
            "Faites glisser des connexions pour lier d'autres nœuds.",
        },
        confirmDelete: "Supprimer ce nœud ?",
      },
    },
    kanban: {
      ticketLabel: "Ticket n° {{id}}",
      filters: {
        startDate: "Date de début",
        endDate: "Date de fin",
      },
      toasts: {
        tagRemoved: "Étiquette retirée du ticket !",
        tagAdded: "Étiquette ajoutée au ticket !",
      },
      actions: {
        search: "Rechercher",
        viewTicket: "Voir le ticket",
        addColumns: "+ Ajouter des colonnes",
      },
    },
    moments: {
      title: "Tableau de bord des services",
    },
    todoList: {
      newTask: "Nouvelle tâche",
      add: "Ajouter",
      save: "Enregistrer",
    },
    facebookInstagram: {
      titleAll: "Facebook et Instagram",
      subtitle: "Gérez vos intégrations Meta",
      actions: {
        newConnection: "Nouvelle connexion",
        connectFacebook: "Connecter Facebook",
        connectInstagram: "Connecter Instagram",
      },
      meta: {
        title: "Données Meta (uniques par client)",
        step1: "1. Dans Meta Developer, configurez le produit Webhooks avec :",
        webhookUrl: "Webhook URL :",
        verifyToken: "Verify Token :",
        copy: "Copier",
        step2: "2. Abonnez-vous aux objets/champs :",
        objectWord: "objet",
        fieldsWord: "champs",
        step3:
          "3. Lorsque Meta vérifie, vous verrez le statut enregistré dans votre application. Ensuite, les messages entrants arriveront dans Tickets et vous pourrez répondre depuis le chat.",
        user: "Utilisateur :",
      },
      filters: {
        title: "Filtres",
        searchLabel: "Rechercher (nom ou ID)",
        category: "Catégorie",
        from: "Du",
        to: "Au",
        inactiveShort: "Inact.",
      },
      table: {
        title: "Connexions",
        empty: "Aucune connexion à afficher.",
        headers: {
          platform: "Plateforme",
          name: "Nom",
          id: "ID",
          category: "Catégorie",
          status: "Statut",
          webhook: "Webhook",
          created: "Créé",
          active: "Actif",
          actions: "Actions",
        },
      },
      labels: {
        pageId: "ID de la page",
        instagramAccountId: "ID du compte Instagram",
      },
      status: {
        connected: "Connectée",
        disconnected: "Déconnectée",
        error: "Erreur",
        verified: "Vérifié",
        pending: "En attente",
      },
      tooltips: {
        edit: "Modifier",
        disconnect: "Déconnecter",
      },
      dialog: {
        newTitle: "Nouvelle connexion {{platform}}",
        editTitle: "Modifier la connexion {{platform}}",
        info: "Cet écran crée une connexion API manuelle. Collez l'Access Token et l'ID correspondant.",
        fields: {
          name: "Nom",
          categoryOptional: "Catégorie (optionnel)",
          accessToken: "Access Token",
          accessTokenEditHint: "Access Token (laisser vide pour conserver)",
        },
        saving: "Enregistrement...",
      },
      validations: {
        selectValidChannel: "Sélectionnez un canal valide",
        nameRequired: "Le nom est obligatoire",
        idRequired: "{{idLabel}} est obligatoire",
        accessTokenRequired: "Access Token est obligatoire",
      },
      confirm: {
        disconnect: "Êtes-vous sûr de vouloir déconnecter ce compte ?",
      },
      toasts: {
        copied: "Copié",
        accountActivated: "Compte activé avec succès",
        accountDeactivated: "Compte désactivé avec succès",
        statusToggleError: "Erreur lors du changement de statut du compte",
        disconnectSuccess: "Compte déconnecté avec succès !",
        disconnectError: "Erreur lors de la déconnexion du compte",
        connectionUpdated: "Connexion mise à jour",
        connectionCreated: "Connexion créée",
        saveError: "Erreur lors de l'enregistrement de la connexion",
      },
    },
    salesDashboard: {
      title: "Tableau de bord des ventes",
      subtitle: "Bienvenue, {{name}} - Voici vos performances",
      errors: {
        load: "Erreur lors du chargement des données de vente.",
      },
      metrics: {
        totalLeads: "Total prospects",
        convertedClients: "Clients convertis",
        totalRevenue: "Revenu total",
        ranking: "Classement des vendeurs",
        thisMonth: "Ce mois-ci",
        cumulative: "Cumulé",
        conversionSubtitle: "{{rate}}% de conversion",
        rankingSubtitle: "Top 3 de l'équipe",
      },
      goal: {
        title: "Objectif mensuel",
        progress: "Progression : {{percent}}%",
        reached: "Objectif atteint ! 🎉",
        remaining: "Il reste {{amount}} pour atteindre l'objectif",
      },
      topProduct: {
        title: "Produit le plus vendu",
        salesThisMonth: "{{count}} ventes ce mois-ci",
        conversionRate: "Taux de conversion",
        avgValue: "Valeur moyenne",
      },
      quickActions: {
        title: "Actions rapides",
        viewLeads: "Voir mes prospects",
        registerClient: "Enregistrer un client",
        commissions: "Mes commissions",
        aiSales: "IA pour les ventes",
      },
    },
    teamDashboard: {
      title: "Tableau de bord de l'équipe",
      subtitle: "Suivez les performances de votre équipe de vente",
      errors: {
        load: "Erreur lors du chargement des données de l'équipe.",
      },
      metrics: {
        teamMembers: "Membres de l'équipe",
        activeMembersSubtitle: "{{count}} actifs",
        teamRevenue: "Revenu de l'équipe",
        thisMonth: "Ce mois-ci",
        topSeller: "Meilleur vendeur",
        topSellerSubtitle: "Meilleure performance",
        teamGoal: "Objectif de l'équipe",
      },
      goal: {
        title: "Progression de l'objectif de l'équipe",
        completed: "{{percent}}% terminé",
        reached: "🎉 Objectif d'équipe atteint !",
        remaining: "Il reste {{amount}} pour l'objectif mensuel",
      },
      table: {
        title: "Performance individuelle",
        headers: {
          seller: "Vendeur",
          leads: "Prospects",
          conversions: "Conversions",
          revenue: "Revenu",
          goal: "Objectif",
          performance: "Performance",
          status: "Statut",
          actions: "Actions",
        },
      },
      status: {
        active: "Actif",
        inactive: "Inactif",
      },
      tooltips: {
        viewDetails: "Voir les détails",
        call: "Appeler",
        email: "E-mail",
      },
      summary: {
        totalLeads: "Total prospects de l'équipe",
        totalConversions: "Total conversions",
        conversionRate: "Taux de conversion",
      },
    },
    commission: {
      title: "Mes commissions",
      subtitle: "Gérez et suivez vos gains",
      errors: {
        load: "Erreur lors du chargement des données de commissions.",
      },
      defaults: {
        client: "Client",
        plan: "Forfait",
      },
      period: {
        label: "Période",
        current: "Mois en cours",
        last: "Mois précédent",
        quarter: "Dernier trimestre",
        year: "Cette année",
        selected: "Période sélectionnée",
      },
      metrics: {
        totalEarned: "Total gagné",
        currentMonth: "Mois en cours",
        pendingPayout: "En attente de paiement",
        paid: "Payé",
        cumulative: "Cumulé",
        rateSubtitle: "Taux : {{rate}}%",
        toProcess: "À traiter",
        processed: "Traité",
      },
      goal: {
        title: "Objectif de commissions - {{period}}",
        progress: "Progression : {{percent}}%",
        reached: "🎉 Objectif atteint ! Excellent travail",
        remaining: "Il reste {{amount}} pour atteindre votre objectif mensuel",
        rateLabel: "Taux de commission",
      },
      table: {
        title: "Historique des commissions",
        headers: {
          client: "Client",
          plan: "Forfait",
          saleValue: "Montant de la vente",
          commission: "Commission",
          status: "Statut",
          date: "Date",
        },
      },
      status: {
        paid: "Payé",
        pending: "En attente",
      },
      summary: {
        totalPaid: "Total des commissions payées",
        totalPending: "Total des commissions en attente",
      },
    },
    checkout: {
      steps: {
        data: "Données",
        customize: "Personnaliser",
        review: "Vérifier",
      },
      gateways: {
        steps: {
          selectPlan: "Choisir un forfait",
          paymentMethod: "Moyen de paiement",
          confirm: "Confirmer",
        },
        errors: {
          loadPlans: "Impossible de charger les forfaits.",
          missingCustomerInfo: "Veuillez renseigner votre nom et votre e-mail.",
          initMercadoPago: "Impossible de démarrer le paiement avec MercadoPago.",
          processPayment: "Erreur lors du traitement du paiement.",
        },
        title: "Améliorez votre forfait",
        subtitle: "Choisissez le forfait idéal pour votre entreprise",
        billing: {
          monthly: "Mensuel",
          yearly: "Annuel",
          freeMonths: "{{count}} mois gratuits",
        },
        plan: {
          mostPopular: "Le plus populaire",
          perMonth: "/mois",
          perYear: "/an",
          savings: "Vous économisez {{amount}}",
          limits: {
            messagesPerMonth: "{{value}} messages/mois",
            channels: "{{value}} canaux",
            users: "{{value}} utilisateurs",
          },
        },
        billingInfo: {
          title: "Informations de facturation",
          fullName: "Nom complet",
          email: "E-mail",
        },
        summary: {
          title: "Résumé",
          plan: "Forfait {{plan}}",
          cycle: "Cycle : {{cycle}}",
        },
        paymentMethod: {
          title: "Moyen de paiement",
          mercadoPago: "MercadoPago (Pérou)",
          paypal: "PayPal (International)",
        },
        buttons: {
          payWithMercadoPago: "Payer avec MercadoPago",
          payWithPayPal: "Payer avec PayPal",
        },
        securityHint: "Paiement sécurisé. Vous pouvez annuler à tout moment.",
      },
      header: "Presque terminé !",
      notFound: "Introuvable.",
      buttons: {
        pay: "Payer",
        select: "Sélectionner",
        increase: "Augmenter",
        decrease: "Diminuer",
      },
      paymentHint: "Après avoir effectué le paiement, actualisez la page.",
      toasts: {
        subscriptionCreatedWaiting:
          "Abonnement créé avec succès. En attente de la confirmation du paiement.",
      },
      form: {
        fullName: {
          label: "Nom complet*",
          required: "Le nom complet est obligatoire",
        },
        lastName: {
          label: "Nom de famille*",
          required: "Le nom de famille est obligatoire",
        },
        address: {
          label: "Adresse*",
          required: "L'adresse est obligatoire",
        },
        city: {
          label: "Ville*",
          required: "La ville est obligatoire",
        },
        state: {
          label: "État/Région*",
          required: "L'état/région est obligatoire",
        },
        document: {
          label: "CPF/CNPJ*",
          required: "Le document est obligatoire",
          invalid: "Format de document invalide",
        },
        country: {
          label: "Pays*",
          required: "Le pays est obligatoire",
        },
        useAddressForPaymentDetails: {
          label: "Utiliser cette adresse pour les informations de paiement",
        },
        nameOnCard: {
          label: "Nom sur la carte*",
          required: "Le nom sur la carte est obligatoire",
        },
        cardNumber: {
          label: "Numéro de carte*",
          required: "Le numéro de carte est obligatoire",
          invalid: "Le numéro de carte n'est pas valide (ex. 4111111111111)",
        },
        expiryDate: {
          label: "Date d'expiration*",
          required: "La date d'expiration est obligatoire",
          invalid: "La date d'expiration n'est pas valide",
        },
        cvv: {
          label: "CVV*",
          required: "Le CVV est obligatoire",
          invalid: "Le CVV n'est pas valide (ex. 357)",
        },
      },
      plan: {
        perMonth: "/mois",
        users: "{{count}} Utilisateurs",
        connections: "{{count}} Connexions",
        queues: "{{count}} Files d'attente",
      },
      review: {
        title: "Résumé de l'abonnement",
        planDetails: {
          title: "Détails du forfait",
          users: "Utilisateurs : {{count}}",
          connections: "Connexions : {{count}}",
          queues: "Files d'attente : {{count}}",
          billing: "Facturation : Mensuelle",
        },
        paymentInfo: {
          title: "Informations de paiement",
          document: "CPF/CNPJ",
          total: "Total",
        },
      },
      success: {
        total: "TOTAL",
        copyQrCode: "Copier le code QR",
        instructions:
          "Pour terminer, payez en scannant ou en collant le code Pix ci-dessus.",
        licenseRenewed: "Votre licence a été renouvelée jusqu'au {{date}} !",
      },
    },
    modulesManager: {
      table: {
        key: "Clé",
        category: "Catégorie",
        addon: "Extension",
      },
      toasts: {
        loadError: "Impossible de charger les modules.",
        saved: "Module enregistré.",
        saveError: "Impossible d'enregistrer le module.",
        deactivated: "Module désactivé.",
        deactivateError: "Impossible de désactiver le module.",
      },
      confirm: {
        deactivateTitle: "Désactiver le module",
        deactivateMessage: "Voulez-vous désactiver ce module ?",
      },
    },
    flowImportModal: {
      title: "Importer un flux",
      instructions: "Sélectionnez un fichier .zip exporté par Flowbuilder.",
      noFile: "Aucun fichier sélectionné",
      buttons: {
        chooseFile: "Choisir un fichier",
        import: "Importer",
      },
      toasts: {
        selectZip: "Sélectionnez un fichier .zip",
        success: "Flux importé avec succès.",
        error: "Erreur lors de l'importation du flux.",
      },
    },
    chatList: {
      confirm: {
        deleteTitle: "Supprimer la conversation",
        deleteMessage: "Cette action est irréversible. Confirmer ?",
      },
    },
    planModulesManager: {
      form: {
        plan: "Forfait",
      },
      table: {
        module: "Module",
        category: "Catégorie",
        included: "Inclus",
      },
      buttons: {
        saveChanges: "Enregistrer les modifications",
      },
      toasts: {
        plansLoadError: "Impossible de charger les forfaits.",
        modulesLoadError: "Impossible de charger les modules du forfait.",
        saved: "Modules du forfait mis à jour.",
        saveError: "Impossible d'enregistrer les modules du forfait.",
      },
    },
    companyModulesManager: {
      table: {
        module: "Module",
        category: "Catégorie",
        plan: "Forfait",
        override: "Surcharge",
        effective: "Effectif",
      },
      override: {
        plan: "Utiliser le forfait",
        enable: "Activer",
        disable: "Désactiver",
      },
      buttons: {
        saveChanges: "Enregistrer les modifications",
      },
      toasts: {
        companiesLoadError: "Impossible de charger les entreprises.",
        modulesLoadError: "Impossible de charger les modules de l'entreprise.",
        saved: "Modules de l'entreprise mis à jour.",
        saveError: "Impossible de mettre à jour les modules.",
      },
    },
    contactNotesDialog: {
      toasts: {
        added: "Note ajoutée avec succès.",
        deleted: "Note supprimée avec succès.",
      },
      confirm: {
        deleteTitle: "Supprimer l'enregistrement",
        deleteMessage: "Voulez-vous vraiment supprimer cet enregistrement ?",
      },
    },
    contacts: {
      menu: {
        importExport: "Importer / Exporter",
      },
      importPage: {
        title: "Importer des contacts depuis un fichier",
      },
      toasts: {
        batchDeleted: "Contacts sélectionnés supprimés.",
        blocked: "Contact bloqué.",
        unblocked: "Contact débloqué.",
      },
      confirmationModal: {
        blockTitle: "Bloquer {{name}}",
        unblockTitle: "Débloquer {{name}}",
        chooseConnectionToImport:
          "Choisissez depuis quelle connexion importer les contacts.",
        batchDeleteTitle: "Supprimer {{count}} contacts",
        batchDeleteMessage:
          "Voulez-vous vraiment supprimer les contacts sélectionnés ? Cette action est irréversible.",
      },
      buttons: {
        deleteSelected: "Supprimer la sélection ({{count}})",
      },
      accessibility: {
        selectAll: "Sélectionner tous les contacts",
        selectContact: "Sélectionner le contact {{name}}",
      },
    },
    contactImport: {
      validateWhatsapp: "Valider les contacts sur WhatsApp",
      uploading: "Importation... veuillez patienter",
      buttons: {
        importContacts: "Importer des contacts",
      },
      fields: {
        name: "Nom",
        number: "Numéro",
        email: "Email",
        tags: "Tags",
      },
      errors: {
        missingNumberField: "Sélectionnez la colonne pour le champ \"Numéro\".",
        missingNameField: "Sélectionnez la colonne pour le champ \"Nom\".",
        noContactsSelected: "Sélectionnez au moins un contact à importer.",
        fieldAlreadySelected: "Le champ {{field}} est déjà sélectionné.",
      },
      toasts: {
        success: "Contacts importés avec succès.",
        successWithErrors:
          "Import terminé avec des avertissements. Certains contacts ont été ignorés.",
      },
      summary: {
        created: "{{count}} contacts créés",
        ignored:
          "{{count}} contacts ignorés (numéro invalide ou non sélectionnés pour mise à jour)",
      },
      file: {
        processing: "Traitement du fichier...",
        invalid: "Fichier invalide !",
      },
      dropzone: {
        title: "Cliquez ou glissez un fichier",
        note:
          "* Important : seuls les fichiers avec les extensions suivantes sont acceptés : xls, xlsx, csv, txt",
      },
      alt: {
        upload: "Téléverser un fichier",
      },
    },
    slaPolicies: {
      title: "SLA par canal",
      description:
        "Configure les temps de première réponse, de réponse suivante et de résolution par canal.",
      fields: {
        firstResponseMinutes: "Première réponse (min)",
        nextResponseMinutes: "Réponse suivante (min)",
        resolutionMinutes: "Résolution (min)",
      },
      buttons: {
        save: "Enregistrer SLA",
      },
      toasts: {
        loadError: "Erreur lors du chargement du SLA.",
        saved: "SLA mis à jour.",
        saveError: "Erreur lors de l'enregistrement du SLA.",
      },
    },
    ticketMessagesDialog: {
      errors: {
        exportTargetNotFound: "Élément introuvable pour l'exportation.",
      },
      buttons: {
        exportPdf: "Exporter en PDF",
      },
    },
    reports: {
      buttons: {
        exportExcel: "Exporter vers Excel",
      },
    },
    campaignPhraseModal: {
      title: {
        create: "Créer une campagne par phrase",
        edit: "Modifier la campagne par phrase",
      },
      fields: {
        name: "Nom",
        flow: "Flux",
        phrase: "Phrase",
      },
      placeholders: {
        flow: "Sélectionner un flux",
        connection: "Sélectionner une connexion",
      },
      buttons: {
        createCampaign: "Créer la campagne",
        saveCampaign: "Enregistrer la campagne",
      },
      toasts: {
        created: "Campagne créée avec succès.",
        updated: "Campagne mise à jour avec succès.",
      },
    },
    colorBoxModal: {
      title: "Sélectionner une couleur",
    },
    editMessageModal: {
      title: "Modifier le message",
      placeholders: {
        message: "Saisissez le message...",
      },
      aria: {
        messageInput: "Message modifié",
      },
    },
    flowDefault: {
      title: "Flux par défaut",
      confirm: {
        deleteMessage: "Voulez-vous vraiment supprimer ce flux ?",
      },
      sections: {
        welcome: {
          title: "Flux d'accueil",
          description:
            "Sélectionnez le flux à envoyer au début d'une conversation.",
        },
        defaultReply: {
          title: "Flux de réponse par défaut",
          description:
            "Sélectionnez le flux à utiliser lorsqu'il n'y a pas de correspondance de phrase.",
        },
      },
      placeholders: {
        selectFlow: "Sélectionner un flux",
      },
      toasts: {
        deleted: "Flux supprimé avec succès.",
        updated: "Flux par défaut mis à jour.",
      },
    },
    campaignsConfig: {
      sections: {
        intervals: "Intervalles",
      },
      errors: {
        noPermissionRedirect:
          "Cette entreprise n'a pas l'autorisation d'accéder à cette page. Redirection en cours.",
      },
    },
    campaigns: {
      settings: {
        seconds: "secondes",
      },
      dialog: {
        tabs: {
          message: "Message {{number}}",
        },
      },
      table: {
        notScheduled: "Non planifiée",
        notCompleted: "Non terminée",
      },
      status: {
        inactive: "Inactive",
        scheduled: "Planifiée",
        running: "En cours",
        canceled: "Annulée",
        completed: "Terminée",
      },
      actions: {
        stop: "Arrêter la campagne",
        restart: "Redémarrer la campagne",
      },
    },
    flowBuilderConfig: {
      title: "Dessinez votre flux",
      reminder: "N'oubliez pas d'enregistrer votre flux !",
      aria: {
        speedDial: "Ajouter un nœud",
      },
      toasts: {
        saved: "Flux enregistré avec succès.",
      },
      actions: {
        start: "Début",
        content: "Contenu",
        menu: "Menu",
        randomizer: "Randomiseur",
        interval: "Intervalle",
        ticket: "File",
        typebot: "TypeBot",
        openai: "OpenAI",
        question: "Question",
      },
      fallback: {
        html5: "Votre navigateur ne prend pas en charge HTML5",
      },
      units: {
        seconds: "secondes",
      },
      nodes: {
        start: {
          title: "Début du flux",
          description: "Ce bloc marque le début de votre flux.",
        },
        message: {
          title: "Message",
        },
        interval: {
          title: "Intervalle",
          seconds: "{{seconds}} secondes",
        },
        menu: {
          title: "Menu",
        },
        randomizer: {
          title: "Randomiseur",
        },
        audio: {
          title: "Audio",
          recordedNow: "Enregistré à l'instant",
          sent: "Audio envoyé",
        },
        image: {
          title: "Image",
          previewAlt: "Aperçu de l'image",
        },
        video: {
          title: "Vidéo",
        },
        condition: {
          title: "Condition",
        },
        singleBlock: {
          title: "Contenu",
        },
        ticket: {
          title: "File",
        },
        typebot: {
          title: "TypeBot",
          iconAlt: "Icône TypeBot",
        },
        openai: {
          title: "OpenAI/Gemini",
        },
        question: {
          title: "Question",
        },
      },
    },
    flowBuilderModal: {
      title: {
        create: "Ajouter un flux",
        edit: "Modifier le flux",
      },
    },
    buttonModal: {
      title: "Sélectionnez une option",
      select: {
        placeholder: "Sélectionner",
      },
      options: {
        list: "Liste",
        copy: "Copier",
        callMe: "Appelez-moi",
      },
      fields: {
        title: "Titre",
        description: "Description",
        message: "Message",
        buttonText: "Texte du bouton",
        url: "URL",
        copyText: "Texte à copier",
        phone: "Téléphone",
        value: "Valeur",
        image: "Image",
        name: "Nom",
      },
      buttons: {
        addOption: "Ajouter une nouvelle option",
      },
      list: {
        optionLabel: "Option {{number}}",
        defaultSectionTitle: "Options",
        defaultButtonText: "Cliquez ici",
      },
      url: {
        defaults: {
          title: "Bouton URL",
          description: "Message avec bouton",
          buttonText: "Ouvrir le lien",
          url: "https://exemple.com",
        },
      },
      pix: {
        keyType: {
          placeholder: "Type de clé",
          phone: "Téléphone",
          email: "E-mail",
          random: "Clé aléatoire",
        },
        fields: {
          key: "Clé Pix",
        },
      },
      errors: {
        invalidTicketId: "ID du ticket invalide.",
        noOptionSelected: "Sélectionnez une option.",
        processMessage: "Erreur lors du traitement du message.",
      },
    },
    queueOptions: {
      title: "Options",
      placeholders: {
        title: "Titre de l'option",
        message: "Saisissez le texte de l'option",
      },
      fallback: {
        undefinedTitle: "Titre non défini",
      },
    },
    nodePalette: {
      title: "Noeuds disponibles",
      nodeCount: "{{count}} noeuds professionnels",
      searchPlaceholder: "Rechercher des noeuds...",
      noResults: {
        title: "Aucun noeud trouvé",
        subtitle: "Essayez un autre terme",
      },
      categories: {
        trigger: {
          name: "Déclencheurs",
          description: "Démarrez votre flux automatiquement",
        },
        ai: {
          name: "IA et machine learning",
          description: "Intelligence artificielle avancée",
        },
        crm: {
          name: "CRM et ventes",
          description: "Gestion des clients et des ventes",
        },
        ecommerce: {
          name: "E-commerce et paiements",
          description: "Boutiques en ligne et paiements",
        },
        communication: {
          name: "Communication",
          description: "Messagerie et communication",
        },
        database: {
          name: "Bases de données",
          description: "Bases de données et stockage",
        },
        storage: {
          name: "Cloud et fichiers",
          description: "Stockage cloud",
        },
        analytics: {
          name: "Analyse et suivi",
          description: "Analyses et métriques",
        },
        marketing: {
          name: "Marketing et publicité",
          description: "Marketing et publicité",
        },
        logic: {
          name: "Logique et contrôle de flux",
          description: "Contrôle de flux et logique",
        },
        transform: {
          name: "Transformation de données",
          description: "Transformation des données",
        },
        action: {
          name: "Actions et automatisation",
          description: "Actions et automatisation",
        },
      },
      nodes: {
        trigger: {
          whatsapp_message: "Message WhatsApp",
          whatsapp_status: "Statut WhatsApp",
          telegram_message: "Message Telegram",
          email_received: "E-mail reçu",
          sms_received: "SMS reçu",
          webhook: "Webhook",
          schedule: "Planification/Cron",
          form_submit: "Envoi de formulaire",
          file_upload: "Téléversement de fichier",
          api_call: "Appel API",
          database_change: "Changement de base de données",
          payment_received: "Paiement reçu",
          order_placed: "Commande passée",
          new_contact: "Nouveau contact",
          calendar_event: "Événement calendrier",
          button_click: "Clic sur bouton",
          qr_scan: "Scan QR",
          voice_command: "Commande vocale",
        },
        ai: {
          gpt4: "Chat GPT-4",
          gpt4_vision: "GPT-4 Vision",
          claude: "Claude 3",
          gemini: "Google Gemini",
          dall_e: "Image DALL-E",
          whisper: "Audio Whisper",
          tts: "Synthèse vocale",
          intent_detection: "Détection d'intention",
          sentiment: "Analyse de sentiment",
          rag: "Requête RAG",
          summarize: "Résumé de texte",
          translate: "Traduction",
          classify: "Classification de texte",
          entity_extraction: "Extraction d'entités",
          embeddings: "Générer des embeddings",
          question_answer: "Système Q/R",
          content_moderate: "Modération de contenu",
          image_recognition: "Reconnaissance d'image",
          ocr: "OCR: extraction de texte",
          face_detection: "Détection de visage",
          object_detection: "Détection d'objets",
          speech_recognition: "Reconnaissance vocale",
          video_analysis: "Analyse vidéo",
          predictive: "Modèle prédictif",
          recommendation: "Moteur de recommandation",
        },
        crm: {
          salesforce_lead: "Lead Salesforce",
          salesforce_contact: "Contact Salesforce",
          hubspot_contact: "Contact HubSpot",
          hubspot_deal: "Deal HubSpot",
          pipedrive_deal: "Deal Pipedrive",
          pipedrive_activity: "Activité Pipedrive",
          zoho_lead: "Lead Zoho",
          zoho_account: "Compte Zoho",
          dynamics_contact: "Contact Dynamics",
          freshsales: "Freshsales",
          airtable: "Airtable",
          notion: "Base de données Notion",
          monday: "Monday.com",
          asana: "Tâche Asana",
          trello: "Carte Trello",
          jira: "Ticket Jira",
          zendesk: "Ticket Zendesk",
          intercom: "Message Intercom",
        },
        ecommerce: {
          shopify_order: "Commande Shopify",
          shopify_product: "Produit Shopify",
          shopify_customer: "Client Shopify",
          woocommerce_order: "Commande WooCommerce",
          woocommerce_product: "Produit WooCommerce",
          mercadolibre: "Mercado Libre",
          amazon: "Amazon FBA",
          ebay: "Annonce eBay",
          stripe_payment: "Paiement Stripe",
          stripe_subscription: "Abonnement Stripe",
          paypal: "Transaction PayPal",
          square: "Paiement Square",
          mercadopago: "Mercado Pago",
          conekta: "Paiement Conekta",
          wix_store: "Boutique Wix",
          squarespace: "Squarespace",
          bigcommerce: "BigCommerce",
          magento: "Magento",
          prestashop: "PrestaShop",
          shipment_tracking: "Suivi d'expédition",
        },
        communication: {
          whatsapp_send: "Envoi WhatsApp",
          whatsapp_template: "Modèle WhatsApp",
          whatsapp_media: "Média WhatsApp",
          telegram_send: "Envoi Telegram",
          telegram_bot: "Bot Telegram",
          slack_message: "Message Slack",
          slack_channel: "Canal Slack",
          discord_message: "Message Discord",
          discord_embed: "Embed Discord",
          email_smtp: "E-mail SMTP",
          email_template: "Modèle d'e-mail",
          sms_twilio: "SMS Twilio",
          sms_nexmo: "SMS Nexmo",
          voice_call: "Appel vocal",
          push_notification: "Notification push",
          teams_message: "Microsoft Teams",
          zoom_meeting: "Réunion Zoom",
          google_meet: "Google Meet",
          messenger_send: "Facebook Messenger",
          instagram_dm: "DM Instagram",
          twitter_dm: "DM Twitter",
          linkedin_message: "Message LinkedIn",
        },
        database: {
          postgresql: "PostgreSQL",
          mysql: "MySQL",
          mongodb: "MongoDB",
          redis: "Cache Redis",
          elasticsearch: "Elasticsearch",
          firebase_firestore: "Firebase Firestore",
          firebase_realtime: "Firebase Realtime",
          supabase: "Supabase",
          dynamodb: "AWS DynamoDB",
          cosmosdb: "Azure Cosmos DB",
          cassandra: "Cassandra",
          mariadb: "MariaDB",
          oracle: "Oracle DB",
          sql_server: "SQL Server",
          sqlite: "SQLite",
          couchdb: "CouchDB",
          influxdb: "InfluxDB",
          neo4j: "Graphe Neo4j",
        },
        storage: {
          google_drive: "Google Drive",
          google_sheets: "Google Sheets",
          dropbox: "Dropbox",
          s3: "AWS S3",
          azure_blob: "Azure Blob Storage",
          onedrive: "OneDrive",
          box: "Box",
          ftp: "Serveur FTP",
          sftp: "Serveur SFTP",
          github: "Dépôt GitHub",
          gitlab: "Dépôt GitLab",
          bitbucket: "Bitbucket",
        },
        analytics: {
          google_analytics: "Google Analytics",
          ga4_event: "Événement GA4",
          mixpanel: "Mixpanel",
          amplitude: "Amplitude",
          segment: "Segment (Track)",
          hotjar: "Événement Hotjar",
          posthog: "PostHog",
          heap: "Heap Analytics",
          facebook_pixel: "Facebook Pixel",
          google_tag: "Google Tag Manager",
          custom_event: "Événement personnalisé",
          ab_test: "Test A/B",
        },
        marketing: {
          facebook_ads: "Publicités Facebook",
          google_ads: "Publicités Google",
          instagram_ads: "Publicités Instagram",
          linkedin_ads: "Publicités LinkedIn",
          twitter_ads: "Publicités Twitter",
          mailchimp: "Campagne Mailchimp",
          sendgrid: "E-mail SendGrid",
          activecampaign: "ActiveCampaign",
          convertkit: "ConvertKit",
          hubspot_email: "E-mail HubSpot",
          klaviyo: "Klaviyo",
          brevo: "Brevo (Sendinblue)",
          tiktok_ads: "Publicités TikTok",
          youtube_ads: "Publicités YouTube",
          pinterest_ads: "Publicités Pinterest",
        },
        logic: {
          condition: "Condition If",
          switch: "Cas Switch",
          router: "Router",
          loop: "Boucle/Itérer",
          for_each: "Pour chaque",
          while: "Boucle While",
          filter: "Filtrer tableau",
          sort: "Trier tableau",
          merge: "Fusionner données",
          split: "Diviser données",
          aggregate: "Agréger",
          limit: "Limiter résultats",
          delay: "Délai/Attente",
          error_handler: "Gestionnaire d'erreurs",
          retry: "Relancer (retry)",
        },
        transform: {
          json_parse: "Parser JSON",
          json_stringify: "JSON Stringify",
          xml_parse: "Parser XML",
          csv_parse: "Parser CSV",
          data_mapper: "Mapper de données",
          text_extract: "Extraire texte (Regex)",
          text_replace: "Remplacer texte",
          hash: "Générateur de hash",
          encrypt: "Chiffrer données",
          decrypt: "Déchiffrer données",
          base64: "Base64 encoder/décoder",
          url_encode: "Encoder URL",
        },
        action: {
          send_message: "Envoyer message",
          create_ticket: "Créer ticket",
          tag_contact: "Taguer contact",
          update_contact: "Mettre à jour contact",
          create_task: "Créer tâche",
          send_email: "Envoyer e-mail",
          log_event: "Journaliser événement",
          webhook_call: "Appeler webhook",
          http_request: "Requête HTTP",
          graphql: "Requête GraphQL",
          run_script: "Exécuter JavaScript",
          python_script: "Exécuter Python",
          schedule_action: "Planifier action",
          trigger_flow: "Déclencher un autre flux",
          stop_flow: "Arrêter le flux",
        },
      },
    },
    allConnections: {
      table: {
        customer: "Client",
        connectedConnections: "Connexions connectées",
        disconnectedConnections: "Connexions déconnectées",
        totalConnections: "Total des connexions",
      },
    },
    webhooksPage: {
      title: "Webhooks",
      soon: "Bientôt disponible.",
    },
    helps: {
      settings: {
        title: "Titre",
      },
    },
    plans: {
      form: {
        queues: "Files",
        amount: "Valeur",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        internalChat: "Chat interne",
        externalApi: "API externe",
        kanban: "Kanban",
        openAi: "OpenAI",
        integrations: "Intégrations",
      },
    },
    invoices: {
      table: {
        status: "Statut",
        idLabel: "ID: {{id}}",
      },
      tooltips: {
        details: "Détails",
        users: "Utilisateurs",
        connections: "Connexions",
        queues: "Files",
        value: "Valeur",
        dueDate: "Échéance",
      },
      status: {
        paid: "Payée",
        overdue: "En retard",
        open: "Ouverte",
      },
      actions: {
        pay: "Payer",
        payNow: "Payer maintenant",
      },
      daysLeft: {
        overdueOne: "En retard de {{days}} jour",
        overdueMany: "En retard de {{days}} jours",
        dueToday: "Échéance aujourd'hui",
        dueInOne: "Échéance dans {{days}} jour",
        dueInMany: "Échéance dans {{days}} jours",
      },
    },
    buttonPreview: {
      toasts: {
        codeCopied: "Code copié.",
      },
      errors: {
        noContentToCopy: "Aucun contenu à copier.",
        noLinkAvailable: "Aucun lien disponible.",
        callsNotSupported: "Les appels ne sont pas pris en charge dans cet aperçu.",
      },
      empty: {
        noButtonsInSection: "Aucun bouton dans cette section.",
        noSectionsAvailable: "Aucune section disponible.",
      },
      alt: {
        preview: "Aperçu",
      },
    },
    schedules: {
      calendar: {
        date: "Date",
        time: "Heure",
        event: "Événement",
        allDay: "Toute la journée",
        week: "Semaine",
        workWeek: "Semaine de travail",
        day: "Jour",
        month: "Mois",
        yesterday: "Hier",
        tomorrow: "Demain",
        today: "Aujourd'hui",
        agenda: "Agenda",
        noEventsInRange: "Aucun événement sur cette période.",
        showMore: "+{{total}} de plus",
      },
    },
    layout: {
      errors: {
        accountAccessedElsewhere:
          "Cet utilisateur est déjà connecté sur un autre appareil. Vous allez être déconnecté.",
      },
    },
    messageOptionsMenu: {
      toasts: {
        reactionSent: "Réaction envoyée.",
      },
    },
    newTicketModal: {
      placeholders: {
        queue: "Sélectionner une file",
        connection: "Sélectionner une connexion",
      },
      errors: {
        queueRequired: "Sélectionnez une file pour continuer.",
      },
    },
    analytics: {
      title: "Analytique",
      subtitle: "Indicateurs et tendances de votre activité",
      toasts: {
        loadError: "Erreur lors du chargement de l'analytique.",
      },
      period: {
        label: "Période",
        options: {
          week: "Semaine",
          month: "Mois",
          quarter: "Trimestre",
          year: "Année",
        },
      },
      metrics: {
        totalRevenue: "Revenu total",
        totalLeads: "Total des prospects",
        conversionRate: "Taux de conversion",
        avgDealSize: "Montant moyen par affaire",
        vsPreviousPeriod: "{{value}} % vs période précédente",
      },
      monthlyTrends: {
        title: "Tendances mensuelles",
        revenueTrend: "Tendance du revenu",
        table: {
          month: "Mois",
          leads: "Prospects",
          conversions: "Conversions",
          conversionRate: "Taux",
          revenue: "Revenu",
        },
      },
      topProducts: {
        title: "Produits principaux",
        salesLabel: "{{count}} ventes",
      },
      leadSources: {
        title: "Sources de prospects",
        countLabel: "{{count}} prospects",
      },
    },
    campaignsPhrase: {
      toasts: {
        deleted: "Phrase supprimée avec succès.",
      },
    },
    messagesAPI: {
      toasts: {
        sent: "Message envoyé avec succès.",
      },
      labels: {
        endpoint: "Endpoint",
        method: "Méthode",
        headers: "En-têtes",
        body: "Corps",
        formData: "FormData",
        testSend: "Envoi test",
      },
      docs: {
        headers: {
          json: "Authorization: Bearer (jeton enregistré) et Content-Type (application/json)",
          formData:
            "Authorization: Bearer (jeton enregistré) et Content-Type (multipart/form-data)",
        },
        fields: {
          userIdHint: "ID utilisateur/agent ou \"\"",
          queueIdHint: "ID de la file ou \"\"",
          mediasHint: "fichier",
          sendSignatureHint: "Signer le message - true/false",
          closeTicketHint: "Fermer le ticket - true/false",
        },
      },
    },
    messageModal: {
      title: {
        add: "Nouveau message planifié",
        edit: "Modifier le message planifié",
      },
      success: {
        save: "Message planifié enregistré.",
      },
      placeholders: {
        connection: "Connexion",
        contacts: "Contacts",
        users: "Utilisateurs",
      },
      form: {
        createTicket: "Créer un ticket",
      },
    },
    listPreview: {
      modal: {
        title: "Liste de boutons",
      },
      fields: {
        selectedTitlePlaceholder: "Titre sélectionné",
      },
      a11y: {
        selectedTitle: "titre sélectionné",
      },
      alerts: {
        selectTitle: "Veuillez sélectionner un titre.",
        ticketIdNotFound: "Erreur : ticketId introuvable.",
        sendError: "Erreur lors de l'envoi du message. Réessayez.",
      },
    },
    scheduleModal: {
      statusTitle: {
        sendError: "Erreur d'envoi",
        messageWithStatus: "Message {{status}}",
      },
    },
  },
  it: {
    common: {
      save: "Salva",
      cancel: "Annulla",
      back: "Indietro",
      next: "Avanti",
      previous: "Precedente",
      create: "Crea",
      update: "Aggiorna",
      add: "Aggiungi",
      edit: "Modifica",
      import: "Importa",
      export: "Esporta",
      confirm: "Conferma",
      close: "Chiudi",
      delete: "Elimina",
      duplicate: "Duplica",
      refresh: "Aggiorna",
      search: "Cerca",
      configure: "Configura",
      upgradePlan: "Migliora piano",
      company: "Azienda",
      package: "Pacchetto",
      assignCredits: "Assegna crediti",
      copied: "Copiato",
      yes: "Sì",
      no: "No",
      active: "Attivo",
      inactive: "Inattivo",
      actions: "Azioni",
      status: "Stato",
      source: "Fonte",
      date: "Data",
      id: "ID",
      name: "Nome",
      email: "Email",
      phone: "Telefono",
      notes: "Note",
      description: "Descrizione",
      price: "Prezzo",
      tokens: "Token",
      clear: "Pulisci",
      deactivate: "Disattiva",
      activate: "Attiva",
      anErrorOccurred: "Si è verificato un errore.",
      loading: "Caricamento...",
      ok: "OK",
      total: "Totale",
      other: "Altro",
      send: "Invia",
      chat: "Chat",
      placeholders: {
        emailAddress: "Indirizzo email",
      },
      alt: {
        thumbnail: "Miniatura",
      },
      validation: {
        required: "Obbligatorio.",
        tooShort: "Troppo corto.",
        tooLong: "Troppo lungo.",
        passwordRequired: "La password è obbligatoria.",
        invalidEmail: "Email non valido.",
        apiKeyRequired: "La chiave API è obbligatoria.",
        voiceModeRequired: "La modalità voce è obbligatoria.",
        ratingRequired: "La valutazione è obbligatoria.",
        passwordsMustMatch: "Le password devono coincidere.",
        invalidOption: "Opzione non valida.",
        minValue: "Minimo {{min}}.",
        maxValue: "Massimo {{max}}.",
      },
      errors: {
        loadRecords: "Impossibile caricare l'elenco dei record.",
        noPermissionRedirect:
          "Questa azienda non ha l'autorizzazione per accedere a questa pagina. Reindirizzamento in corso.",
        operationFailed: "Operazione non riuscita.",
        operationFailedDuplicateOrInvalid:
          "Operazione non riuscita. Controlla i dati e riprova.",
      },
      toasts: {
        success: "Operazione completata con successo.",
        clickSaveToApplyChanges:
          'Fai clic su "Salva" per applicare le modifiche.',
      },
      confirmationModal: {
        deleteTitle: "Elimina record",
        deleteMessage: "Vuoi davvero eliminare questo record?",
      },
    },
    backendErrors: {
      plan_limit_exceeded:
        "Hai raggiunto il limite di connessioni del tuo abbonamento. Aggiorna il tuo piano per aggiungerne altre.",
    },
    connections: {
      table: {
        channel: "Canale",
      },
    },
    compaies: {
      table: {
        folderSize: "Dimensione cartella",
        totalFiles: "Totale file",
        lastFolderUpdate: "Ultimo aggiornamento cartella",
      },
    },
    qrCode: {
      waiting: "In attesa del QR code",
    },
    chatbots: {
      toasts: {
        saved: "Chatbot salvato con successo.",
        deleted: "Chatbot eliminato con successo.",
      },
      confirmationModal: {
        deleteMessage:
          "Sei sicuro? Tutte le opzioni interne verranno eliminate.",
      },
      validation: {
        optionNameMin:
          "Il nome dell'opzione deve contenere almeno 4 caratteri.",
        optionNameRequired: "Il nome dell'opzione è obbligatorio.",
        optionsRequired: "Devi aggiungere almeno un'opzione.",
      },
    },
    contactImportWpModal: {
      status: {
        completed: "Importazione completata con successo.",
        inProgress:
          "Importazione in corso {{current}} di {{total}}. Non uscire da questa schermata finché l'importazione non è completata.",
      },
    },
    tagsKanban: {
      form: {
        stage: "Fase Kanban",
      },
    },
    filters: {
      placeholders: {
        contacts: "Contatti",
        connections: "Connessioni",
        departments: "Dipartimenti",
        statusFilter: "Filtra per stato",
        tagsFilter: "Filtra per tag",
        tags: "Tag",
      },
    },
    tagsContainer: {
      errors: {
        tooShort: "Tag troppo corto.",
      },
    },
    tickets: {
      search: {
        filterConectionsOptions: {
          groups: "Gruppi",
        },
      },
      simulateIncoming: {
        channelFallback: "canale",
        body: "Messaggio di test ({{channel}})",
        menuLabel: "Simula messaggio in arrivo",
        toasts: {
          success: "Messaggio in arrivo simulato.",
        },
      },
    },
    messageUploadMedias: {
      placeholders: {
        caption: "Didascalia (opzionale)",
      },
      fallback: {
        unavailable: "Anteprima non disponibile",
      },
      alt: {
        image: "Immagine {{index}}",
      },
    },
    ticket: {
      chat: {
        searchPlaceholder: "Cerca in questa chat...",
      },
    },
    messagesList: {
      deletedMessage: "🚫 _Messaggio eliminato_",
      deletedText: "🚫 Messaggio eliminato",
      deletedByContactText: "🚫 Questo messaggio è stato eliminato dal contatto",
      forwarded: "Inoltrato",
      reacted: "Hai reagito... {{reaction}}",
      editedAt: "Modificato {{time}}",
      empty: {
        startConversation: "Di' ciao al tuo nuovo contatto!",
      },
      dragDrop: {
        dropHere: "Rilascia il file qui",
      },
      facebookPolicy24h:
        "Hai 24 ore per rispondere dopo aver ricevuto un messaggio, in base alle politiche di Facebook.",
    },
    recurrence: {
      title: "Ricorrenza",
      description:
        "Puoi inviare il messaggio in modo ricorrente e scegliere l'intervallo. Se è un invio una tantum, non modificare nulla in questa sezione.",
      interval: {
        label: "Intervallo",
        valueLabel: "Valore dell'intervallo",
        options: {
          days: "Giorni",
          weeks: "Settimane",
          months: "Mesi",
          minutes: "Minuti",
        },
      },
      sendCount: {
        label: "Invia quante volte",
      },
      businessDaysPolicy: {
        label: "Giorni non lavorativi",
        options: {
          normal: "Invia normalmente nei giorni non lavorativi",
          before: "Invia un giorno lavorativo prima",
          after: "Invia un giorno lavorativo dopo",
        },
      },
      showUser: "Mostra utente",
    },
    whatsappModal: {
      flowbuilder: {
        welcomeFlow: {
          title: "Flusso di benvenuto",
          description:
            "Questo flusso viene attivato solo per i nuovi contatti: persone che non sono nella tua lista contatti e che hanno inviato un messaggio.",
        },
        defaultResponseFlow: {
          title: "Flusso di risposta predefinita",
          description:
            "La risposta predefinita viene inviata con qualsiasi carattere diverso da una parola chiave. Attenzione: verrà attivata se la conversazione è già chiusa.",
        },
      },
    },
    ticketsList: {
      preview: {
        title: "Anteprima della conversazione",
      },
      loadingMessages: "Caricamento messaggi...",
      tooltips: {
        previewConversation: "Anteprima conversazione",
      },
      adClick: "Clic dell'annuncio",
    },
    userModal: {
      form: {
        profiles: {
          admin: "Amministratore",
          user: "Utente",
        },
      },
    },
    contactNotesEditModal: {
      title: "Modifica nota",
      fields: {
        note: "Nota",
      },
    },
    updateNotification: {
      title: "Nuova versione disponibile!",
      subtitle: "È disponibile un aggiornamento del sistema.",
      versionLabel: "Versione: {{version}}",
      instruction: 'Fai clic su "Aggiorna ora" per caricare la nuova versione.',
      buttons: {
        later: "Più tardi",
        updateNow: "Aggiorna ora",
      },
    },
    settings: {
      tabs: {
        sla: "SLA",
        schedules: "Orari",
        companies: "Aziende",
        modules: "Moduli",
        planModules: "Piano-Moduli",
        companyModules: "Moduli aziendali",
        aiTokens: "Token IA",
        whitelabel: "Whitelabel",
      },
      settings: {
        customMessages: {
          transferMessageDefault:
            `Il tuo ticket è stato trasferito al reparto \${queue.name}. Attendi, per favore...`,
        },
        options: {
          text: "Testo",
        },
      },
      whitelabel: {
        fields: {
          primaryColorLight: "Colore primario (modalità chiara)",
          primaryColorDark: "Colore primario (modalità scura)",
          systemName: "Nome del sistema",
          logoLight: "Logo chiaro",
          logoDark: "Logo scuro",
          favicon: "Favicon",
        },
        errors: {
          uploadImage: "Impossibile caricare l'immagine.",
        },
      },
    },
    aiTokens: {
      title: "Token IA",
      packages: {
        form: {
          name: "Nome",
          tokens: "Token",
          price: "Prezzo",
          active: "Attivo",
        },
        table: {
          name: "Nome",
          tokens: "Token",
          price: "Prezzo",
          active: "Attivo",
        },
        buttons: {
          clear: "Pulisci",
          save: "Salva",
          deactivate: "Disattiva",
          assignCredits: "Assegna crediti",
        },
        credit: {
          company: "Azienda",
          package: "Pacchetto IA",
        },
        confirm: {
          deactivateTitle: "Disattiva pacchetto",
          deactivateMessage: "Vuoi disattivare questo pacchetto IA?",
        },
        toasts: {
          companiesLoadError: "Impossibile caricare le aziende.",
          packagesLoadError: "Impossibile caricare i pacchetti.",
          packageSaved: "Pacchetto salvato.",
          packageSaveError: "Impossibile salvare il pacchetto.",
          packageDeactivated: "Pacchetto disattivato.",
          packageDeactivateError: "Impossibile disattivare il pacchetto.",
          selectCompanyAndPackage: "Seleziona azienda e pacchetto.",
          creditsAssigned: "Crediti IA assegnati.",
          creditsAssignError: "Impossibile assegnare crediti.",
        },
      },
    },
    leads: {
      title: "Gestione lead",
      subtitle: "Gestisci le tue opportunità di vendita",
      buttons: {
        refresh: "Aggiorna",
        new: "Nuovo lead",
        cancel: "Annulla",
        create: "Crea",
        update: "Aggiorna",
      },
      stats: {
        total: "Lead totali",
        new: "Nuovi",
        qualified: "Qualificati",
        contacted: "Contattati",
      },
      filters: {
        searchPlaceholder: "Cerca lead...",
        status: "Stato",
        source: "Fonte",
        all: "Tutti",
        allFeminine: "Tutte",
      },
      table: {
        name: "Nome",
        contact: "Contatto",
        status: "Stato",
        source: "Fonte",
        score: "Score",
        date: "Data",
        actions: "Azioni",
        empty: "Nessun lead da mostrare",
      },
      pagination: {
        rowsPerPage: "Righe per pagina",
        displayedRows: "{{from}}-{{to}} di {{count}}",
        moreThan: "più di {{to}}",
      },
      dialog: {
        addTitle: "Nuovo lead",
        editTitle: "Modifica lead",
      },
      form: {
        name: "Nome",
        nameRequired: "Il nome è obbligatorio",
        email: "Email",
        phone: "Telefono",
        phonePlaceholder: "+51987654321",
        status: "Stato",
        source: "Fonte",
        score: "Score (0-100)",
        notes: "Note",
      },
      confirm: {
        delete: "Sei sicuro di voler eliminare questo lead?",
      },
      status: {
        new: "Nuovo",
        contacted: "Contattato",
        qualified: "Qualificato",
        converted: "Convertito",
        lost: "Perso",
      },
      sources: {
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        website: "Sito web",
        referral: "Segnalazione",
        cold_call: "Chiamata",
        email: "Email",
        other: "Altro",
      },
      contactActions: {
        whatsapp: "WhatsApp",
        call: "Chiama",
        email: "Email",
      },
      toasts: {
        loadError: "Errore durante il caricamento dei lead.",
        saveError: "Errore durante il salvataggio del lead.",
        deleteError: "Errore durante l'eliminazione del lead.",
        updated: "Lead aggiornato con successo.",
        created: "Lead creato con successo.",
        deleted: "Lead eliminato con successo.",
      },
    },
    abTesting: {
      title: "Test A/B IA",
      subtitle: "Ottimizza le risposte IA con esperimenti controllati",
      actions: {
        refresh: "Aggiorna",
      },
      errors: {
        loadData: "Errore nel caricamento dei dati A/B Testing",
      },
      stats: {
        totalExperiments: "Totale esperimenti",
        activeLabel: "{{count}} attivi",
        totalImpressions: "Impression totali",
        conversions: "Conversioni",
        conversionRate: "Tasso di conversione",
      },
      table: {
        title: "Esperimenti",
        idLabel: "ID: {{id}}",
        headers: {
          experiment: "Esperimento",
          description: "Descrizione",
          variants: "Varianti",
          impressions: "Impression",
          status: "Stato",
          actions: "Azioni",
        },
        status: {
          active: "Attivo",
          stopped: "Fermato",
        },
        tooltips: {
          viewDetails: "Vedi dettagli",
          stopExperiment: "Ferma esperimento",
        },
      },
      dialog: {
        progressTitle: "Progresso esperimento",
        samples: "{{count}} campioni",
        goal: "Obiettivo: {{count}}",
        significant: "L'esperimento ha raggiunto la significatività statistica",
        winnerTitle: "Vincitore attuale: {{name}}",
        score: "Punteggio: {{score}}",
        variantsTitle: "Varianti",
        variantsHeaders: {
          variant: "Variante",
          impressions: "Impression",
          conversions: "Conversioni",
          conversionRate: "Tasso conv.",
          satisfaction: "Soddisfazione",
          escalations: "Escalation",
        },
        control: "Controllo",
        actions: {
          close: "Chiudi",
          stop: "Ferma esperimento",
        },
      },
    },
    registerClient: {
      title: "Registra nuovo cliente",
      subtitle: "Compila le informazioni per registrare un nuovo cliente",
      steps: {
        company: "Dati azienda",
        contact: "Persona di contatto",
        plan: "Piano e servizi",
      },
      industries: {
        retail: "Vendita al dettaglio",
        restaurant: "Ristorante",
        healthcare: "Sanità",
        education: "Istruzione",
        technology: "Tecnologia",
        services: "Servizi",
        ecommerce: "E-commerce",
        realEstate: "Immobiliare",
        other: "Altro",
      },
      company: {
        title: "Informazioni azienda",
        fields: {
          name: "Nome azienda",
          industry: "Settore",
          email: "Email azienda",
          phone: "Telefono azienda",
          address: "Indirizzo",
          website: "Sito web",
        },
      },
      contact: {
        title: "Persona di contatto",
        fields: {
          name: "Nome completo",
          position: "Ruolo/Posizione",
          email: "Email contatto",
          phone: "Telefono contatto",
        },
      },
      plan: {
        title: "Seleziona piano",
        includes: {
          users: "Utenti",
          connections: "Connessioni",
          queues: "Code",
        },
        perMonth: "/mese",
        billingCycle: "Ciclo di fatturazione",
        billingMonthly: "Mensile",
        billingAnnual: "Annuale (2 mesi gratis)",
      },
      addons: {
        title: "Servizi aggiuntivi",
        pricePerMonth: `+\${{amount}}/mese`,
      },
      notes: {
        title: "Note aggiuntive",
        placeholder: "Aggiungi eventuali note o commenti su questo cliente...",
      },
      total: {
        label: "Totale da fatturare",
        perYear: "/anno",
        perMonth: "/mese",
      },
      buttons: {
        back: "Indietro",
        next: "Avanti",
        submit: "Registra cliente",
      },
      toasts: {
        stepCompanyRequired: "Per favore completa tutti i campi obbligatori.",
        stepContactRequired: "Per favore completa i dati del contatto.",
        success: "Cliente registrato con successo!",
        error: "Errore durante la registrazione del cliente.",
      },
    },
    subscription: {
      free: "Gratis",
      license: {
        noExpiration: "Senza scadenza",
        expiresToday: "La tua licenza scade oggi",
        expiredOn: "Licenza scaduta il {{date}}",
        expiresIn: "La tua licenza scade tra {{days}} {{dayWord}} ({{date}})",
        day: "giorno",
        days: "giorni",
      },
      fields: {
        dueDate: "Scadenza",
        billingEmail: "Email di fatturazione",
        currentPlan: "Piano attuale",
        users: "Utenti",
        connections: "Connessioni",
        queues: "Code",
        price: "Prezzo",
      },
      upgrade: {
        title: "Migliora piano",
        button: "Aggiorna piano",
        updating: "Aggiornamento...",
      },
      contact: {
        button: "Abbonati ora",
      },
      toasts: {
        planUpdated: "Piano aggiornato con successo.",
      },
    },
    configApis: {
      title: "Connetti API",
      channels: {
        whatsappTitle: "WhatsApp Cloud API",
        facebookTitle: "Facebook Messenger",
        instagramTitle: "Instagram Messaging",
      },
      summary: {
        title: "Riepilogo",
        activeConnections: "Connessioni attive (API Meta):",
        planLimit: "Limite del tuo abbonamento:",
        limitReached: "Limite raggiunto: per aggiungere più connessioni, migliora il tuo piano.",
      },
      channelCard: {
        activeConnections: "Connessioni attive:",
        configure: "Configura",
        upgradePlan: "Migliora piano",
      },
      actions: {
        refresh: "Aggiorna",
      },
      subtitles: {
        whatsapp: "Phone Number ID + Access Token + Webhook",
        facebook: "Pagina + Access Token + Webhook",
        instagram: "Account + Access Token + Webhook",
      },
      empty: {
        title: "Connetti API",
        subtitle: "Il tuo piano non ha i moduli Meta abilitati.",
        button: "Vedi piani",
      },
    },
    whatsappApi: {
      title: "WhatsApp API",
      actions: {
        copyWebhook: "Copia webhook",
        newConnection: "Nuova connessione",
        copy: "Copia",
        save: "Salva",
        saving: "Salvataggio...",
        rotating: "Rotazione...",
        rotateVerifyToken: "Ruota Verify Token",
        rotateSecrets: "Ruota WebhookKey + Verify Token",
      },
      toasts: {
        copied: "Copiato",
        connectionUpdated: "Connessione aggiornata.",
        connectionCreated: "Connessione creata.",
        connectionDeleted: "Connessione eliminata.",
        connectionSavedButMetaSubscribeFailed:
          "Connessione salvata, ma non e' stato possibile completare la sottoscrizione automatica su Meta. {{reason}}",
        metaSubscribeOk: "Sottoscrizione su Meta completata.",
        metaSubscribeFailed: "Impossibile completare la sottoscrizione su Meta. {{reason}}",
        verifyTokenRotated: "Verify Token aggiornato. Aggiornalo su Meta e verifica di nuovo.",
        secretsRotated: "WebhookKey e Verify Token aggiornati. Aggiornali su Meta e verifica di nuovo.",
      },
      modal: {
        editTitle: "Modifica connessione WhatsApp API",
        newTitle: "Nuova connessione WhatsApp API",
      },
      form: {
        name: "Nome",
        phoneNumberId: "Phone Number ID",
        phoneNumberIdHelper: "Es: 123456789012345",
        wabaIdOptional: "WABA ID",
        accessToken: "Access Token",
        accessTokenEditHint: "Access Token (lascia vuoto per mantenere)",
        useAsDefault: "Usa come predefinita",
        cancel: "Annulla",
      },
      validation: {
        nameMin: "Il nome deve avere almeno 2 caratteri",
        nameRequired: "Il nome è obbligatorio",
        phoneNumberIdRequired: "Phone Number ID è obbligatorio",
        wabaIdRequired: "WABA ID e' obbligatorio",
        accessTokenRequired: "Access Token è obbligatorio",
      },
      errors: {
        missingWabaId: "Manca il WABA ID. Aggiungilo e salva di nuovo per la sottoscrizione automatica su Meta.",
        missingAccessToken: "Manca l'Access Token. Aggiungilo e salva di nuovo.",
        appNotSubscribed:
          "L'app non risulta sottoscritta al WABA. Verifica i permessi del token o sottoscrivi manualmente su Meta.",
      },
      confirm: {
        deleteTitle: "Elimina connessione",
        deleteMessage: "Eliminare la connessione {{name}}?",
      },
      rotateVerifyToken: {
        title: "Ruota Verify Token",
        message:
          "Stai per generare un nuovo Verify Token. Il token precedente non verrà più usato. Poi devi aggiornarlo in Meta Developer e ri-verificare il webhook. Continuare?",
      },
      rotateSecrets: {
        title: "Ruota WebhookKey + Verify Token",
        message:
          "Stai per generare un nuovo WebhookKey e un nuovo Verify Token. L'URL del webhook cambierà e il token precedente non verrà più usato. Poi devi aggiornare entrambi in Meta Developer e ri-verificare il webhook. Continuare?",
      },
      table: {
        name: "Nome",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        meta: "Meta",
        default: "Predefinita",
        webhook: "Webhook",
        actions: "Azioni",
      },
      values: {
        yes: "Sì",
        no: "No",
        verified: "Verificato",
        pending: "In attesa",
        metaSubscribed: "Sottoscritto",
        metaError: "Errore",
        metaUnknown: "In attesa",
      },
      empty: "Nessuna connessione. Creane una per iniziare.",
      helper: {
        title: "Dati per Meta (unici per cliente)",
        step1: "In Meta Developer, configura il webhook usando:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        step2: "Iscriviti all'evento messages. Quando salvi/attivi, Klorum prova a sottoscrivere automaticamente la tua app al WABA.",
        step3: "Quando Meta verifica, vedrai lo stato Verificato.",
        step4: "I messaggi in arrivo arriveranno su WhatsApp (Tickets) e potrai rispondere dalla chat.",
        user: "Utente:",
      },
      tooltips: {
        retryMetaSubscribe: "Riprova sottoscrizione su Meta",
        edit: "Modifica",
        delete: "Elimina",
      },
    },
    dashboard: {
      errors: {
        loadData: "Impossibile caricare i dati della dashboard.",
      },
      filters: {
        title: "Filtri",
      },
      export: {
        agentsSheet: "ReportAgenti",
        agentsFile: "report-agenti.xlsx",
        error: "Errore durante l'esportazione in Excel.",
      },
      charts: {
        errors: {
          loadTicketsInfo: "Impossibile caricare le informazioni dei ticket.",
        },
        perHour: {
          title: "Ticket per ora",
        },
        ticketsLabel: "Ticket",
        empty: {
          noData: "Nessun dato da mostrare.",
          noDataForPeriod: "Nessun dato per il periodo selezionato.",
        },
      },
      membership: {
        title: "Il mio abbonamento",
        details: "Visualizza dettagli",
        availablePlansTitle: "Piani disponibili",
        availablePlansSubtitle:
          "Il tuo piano attuale si applica automaticamente ai limiti e ai moduli del sistema.",
        loadingPlans: "Caricamento piani...",
        noPublicPlans: "Nessun piano pubblico disponibile al momento.",
        planLabel: "Piano",
        activeBadge: "ATTIVO",
        channelsLabel: "Canali",
        buttons: {
          current: "Piano attuale",
          upgrade: "Migliora",
          view: "Vedi",
        },
        license: {
          noExpiration: "Senza scadenza",
          expiresToday: "Scade oggi",
          expiredOn: "Scaduto il {{date}}",
          expiresOn: "Scade il {{date}}",
        },
      },
      channels: {
        titleOverline: "Canali",
        title: "Stato dei canali",
        subtitle: "Connessioni attive e ultima sincronizzazione per canale.",
        configureApis: "Configura API",
        loading: "Caricamento stato canali...",
        empty: "Nessuna informazione sui canali disponibile.",
        status: {
          connected: "Connesso",
          disconnected: "Disconnesso",
          error: "Errore",
        },
        errors: {
          load: "Impossibile caricare lo stato dei canali.",
        },
      },
      analytics: {
        title: "Analytics (mese corrente)",
        period: "Periodo: {{from}} a {{to}}",
        chips: {
          unavailable: "Non disponibile",
          realData: "Dati reali",
        },
        disabledMessage:
          "Il tuo piano attuale non include il modulo Analytics. Migliora il tuo piano per vedere queste metriche.",
        loading: "Caricamento analytics...",
        metrics: {
          monthlyRevenue: "Ricavi (mese)",
          totalRevenue: "Ricavi (totale)",
          conversion: "Conversione",
          firstResponse: "Prima risposta (min)",
          activeUsers: "Utenti attivi",
          newLeads: "Nuovi lead",
          closings: "Affari chiusi",
        },
        activity: {
          title: "Attività recente",
          loading: "Caricamento attività...",
          empty: "Nessuna attività recente disponibile.",
          fallbackTitle: "Attività",
        },
        errors: {
          metrics: "Impossibile caricare le metriche dell'azienda.",
          activity: "Impossibile caricare l'attività recente.",
        },
      },
    },
    flowBuilder: {
      defaultFlowName: "Nuovo flusso",
      copySuffix: "(Copia)",
      list: {
        title: "Flussi di conversazione",
        addFlow: "Aggiungi flusso",
        searchPlaceholder: "Cerca flusso...",
        empty: "Non hai ancora flussi.",
        noMatches: "Nessun risultato per la tua ricerca.",
        status: {
          active: "Attivo",
          inactive: "Disattivato",
        },
        menu: {
          editName: "Modifica nome",
          editFlow: "Modifica flusso",
          duplicate: "Duplica",
          delete: "Elimina",
        },
        confirm: {
          deleteTitle: "Eliminare il flusso {{name}}?",
          deleteBody:
            "Sei sicuro di voler eliminare questo flusso? Tutte le integrazioni correlate andranno perse.",
          duplicateTitle: "Duplicare il flusso {{name}}?",
          duplicateBody: "Sei sicuro di voler duplicare questo flusso?",
        },
        toasts: {
          deleted: "Flusso eliminato con successo",
          duplicated: "Flusso duplicato con successo",
        },
      },
      modals: {
        question: {
          titleCreate: "Aggiungi domanda al flusso",
          titleEdit: "Modifica domanda",
          fields: {
            message: "Messaggio",
            answerKey: "Salva risposta come",
          },
        },
        text: {
          titleCreate: "Aggiungi messaggio al flusso",
          titleEdit: "Modifica messaggio",
          fields: {
            message: "Messaggio",
          },
        },
        image: {
          titleCreate: "Aggiungi immagine al flusso",
          titleEdit: "Modifica immagine",
          buttons: {
            upload: "Carica immagine",
          },
          errors: {
            fileTooLarge: "File troppo grande. Max 2MB.",
          },
          toasts: {
            created: "Immagine aggiunta con successo.",
            updated: "Immagine aggiornata con successo.",
          },
        },
        audio: {
          titleCreate: "Aggiungi audio al flusso",
          titleEdit: "Modifica audio",
          buttons: {
            upload: "Carica audio",
          },
          fields: {
            record: "Invia come audio registrato sul momento",
          },
          fallback: "Il tuo browser non supporta HTML5",
          errors: {
            fileTooLarge: "File troppo grande. Max 5MB.",
          },
          toasts: {
            created: "Audio aggiunto con successo.",
            updated: "Audio aggiornato con successo.",
          },
        },
        video: {
          titleCreate: "Aggiungi video al flusso",
          titleEdit: "Modifica video",
          buttons: {
            upload: "Carica video",
          },
          warnings: {
            onlyMp4: "ATTENZIONE: solo video MP4.",
          },
          fallback: "Il tuo browser non supporta HTML5",
          errors: {
            fileTooLarge: "File troppo grande. Max 20MB.",
          },
          toasts: {
            created: "Video aggiunto con successo.",
            updated: "Video aggiornato con successo.",
          },
        },
        openai: {
          titleCreate: "Aggiungi OpenAI/Gemini al flusso",
          titleEdit: "Modifica OpenAI/Gemini",
          voice: {
            text: "Testo",
          },
        },
        interval: {
          titleCreate: "Aggiungi intervallo al flusso",
          titleEdit: "Modifica intervallo",
          fields: {
            seconds: "Tempo in secondi",
          },
          errors: {
            required: "Aggiungi un valore di intervallo.",
            maxSeconds: "Tempo massimo: 120 secondi.",
          },
        },
        condition: {
          titleCreate: "Aggiungi condizione al flusso",
          titleEdit: "Modifica condizione",
          fields: {
            key: "Campo condizione (digita solo 1 chiave)",
            rule: "Regola di validazione",
            value: "Valore della condizione da analizzare",
          },
        },
        ticket: {
          titleCreate: "Aggiungi coda al flusso",
          titleEdit: "Modifica coda",
          placeholders: {
            selectQueue: "Seleziona una coda",
          },
          errors: {
            requiredQueue: "Seleziona una coda.",
          },
        },
        menu: {
          titleCreate: "Aggiungi menu al flusso",
          titleEdit: "Modifica menu",
          fields: {
            message: "Messaggio di spiegazione del menu",
          },
          buttons: {
            addOption: "Aggiungi opzione",
          },
          optionPrompt: "Digita {{number}}",
          placeholders: {
            option: "Digita opzione",
          },
        },
        randomizer: {
          titleCreate: "Aggiungi randomizzatore al flusso",
          titleEdit: "Modifica randomizzatore",
          aria: {
            slider: "Percentuale",
          },
          errors: {
            required: "Aggiungi una percentuale.",
            maxPercent: "Percentuale massima: 100.",
          },
        },
        typebot: {
          titleCreate: "Aggiungi Typebot al flusso",
          titleEdit: "Modifica Typebot",
        },
        singleBlock: {
          titleCreate: "Aggiungi contenuto al flusso",
          titleEdit: "Modifica contenuto",
          elements: {
            text: "Testo",
            interval: "Intervallo",
            image: "Immagine",
            audio: "Audio",
            video: "Video",
            document: "Documento",
          },
          buttons: {
            uploadImage: "Carica immagine",
            uploadAudio: "Carica audio",
            uploadVideo: "Carica video",
            uploadDocument: "Carica documento",
          },
          fields: {
            message: "Messaggio",
            seconds: "Tempo in secondi",
            recordAudio: "Invia come audio registrato al momento",
            variables: "Variabili",
          },
          file: {
            noFileSelected: "Nessun file selezionato",
          },
          loading: {
            uploading: "Caricamento file e creazione del contenuto...",
          },
          toasts: {
            saved: "Contenuto salvato con successo.",
          },
          errors: {
            messageEmpty: "Il campo messaggio è vuoto.",
            intervalInvalid: "L'intervallo non può essere 0 o superiore a 120.",
            fileTooLarge: "File troppo grande. Max {{maxMb}}MB.",
            pendingUploads:
              "Elimina le schede vuote o carica i file in sospeso.",
          },
        },
      },
    },
    flowBuilderCanvas: {
      back: "Indietro",
      title: "FlowBuilder Canvas",
      testFlow: "Testa flusso",
      save: "Salva",
      alerts: {
        saved: "Flusso salvato con successo",
        saveError: "Errore durante il salvataggio del flusso",
        testSoon: "Funzione di test in arrivo",
        confirmDeleteNode: "Sei sicuro di voler eliminare questo nodo?",
      },
      nodeConfig: {
        sections: {
          basic: "Configurazione di base",
          advanced: "Opzioni avanzate",
        },
        fields: {
          nodeName: "Nome del nodo",
          model: "Modello",
          systemPrompt: "Prompt di sistema",
          temperatureLabel: "Temperatura: {{value}}",
          maxTokens: "Token max",
          intents: "Intent possibili (separati da virgola)",
          confidenceLabel: "Soglia di confidenza: {{value}}",
          webhookUrl: "URL webhook",
          httpMethod: "Metodo HTTP",
          requireAuth: "Richiede autenticazione",
          secretKey: "Chiave segreta",
          scheduleType: "Tipo di pianificazione",
          cronExpression: "Espressione cron",
          messageTemplate: "Template messaggio",
          includeMedia: "Includi media",
          mediaUrl: "URL media",
          emailSubject: "Oggetto",
          emailBody: "Corpo email (HTML)",
          fromEmail: "Email mittente",
          conditionType: "Tipo di condizione",
          fieldToCheck: "Campo da controllare",
          operator: "Operatore",
          valueToCompare: "Valore da confrontare",
          jsExpression: "Espressione JavaScript",
          continueOnError: "Continua in caso di errore",
          retryOnFailure: "Riprova in caso di errore",
        },
        placeholders: {
          nodeName: "Inserisci il nome del nodo...",
          systemPrompt: "Sei un assistente utile...",
          intents: "acquisto, domanda, reclamo...",
          secretKey: "Inserisci la chiave segreta...",
          cronExpression: "0 9 * * * (Ogni giorno alle 9:00)",
          messageTemplate: "Ciao {{name}}, grazie per averci contattato...",
          emailSubject: "Oggetto dell'email...",
          emailBody: "<h1>Ciao {{name}}</h1><p>...</p>",
          fieldToCheck: "es. user.age, message.text",
          valueToCompare: "Inserisci un valore...",
        },
        defaults: {
          intents: "acquisto, domanda, reclamo, cancellazione",
        },
        options: {
          scheduleType: {
            cron: "Espressione cron",
            interval: "Intervallo",
            specific: "Data/ora specifica",
          },
          intervalUnit: {
            minutes: "Minuti",
            hours: "Ore",
            days: "Giorni",
          },
          conditionType: {
            simple: "Semplice (A == B)",
            multiple: "Multiple (AND/OR)",
            expression: "Espressione JavaScript",
          },
          operator: {
            equals: "Uguale (==)",
            notEquals: "Diverso (!=)",
            greater: "Maggiore di (>)",
            less: "Minore di (<)",
            contains: "Contiene",
            startsWith: "Inizia con",
            endsWith: "Termina con",
          },
        },
        helpers: {
          temperature:
            "Valori alti = più creativo. Valori bassi = più deterministico.",
          cronExpression:
            'Esempio: "0 9 * * *" esegue ogni giorno alle 9:00',
          variables: "Usa {{variable}} per variabili dinamiche",
        },
        empty: {
          noSpecificConfig:
            "Nessuna configurazione specifica per questo tipo di nodo.",
          connectHelp:
            "Trascina le connessioni per collegare altri nodi.",
        },
        confirmDelete: "Eliminare questo nodo?",
      },
    },
    kanban: {
      ticketLabel: "Ticket n. {{id}}",
      filters: {
        startDate: "Data iniziale",
        endDate: "Data finale",
      },
      toasts: {
        tagRemoved: "Etichetta rimossa dal ticket!",
        tagAdded: "Etichetta aggiunta al ticket!",
      },
      actions: {
        search: "Cerca",
        viewTicket: "Vedi ticket",
        addColumns: "+ Aggiungi colonne",
      },
    },
    moments: {
      title: "Pannello di assistenza",
    },
    todoList: {
      newTask: "Nuova attività",
      add: "Aggiungi",
      save: "Salva",
    },
    facebookInstagram: {
      titleAll: "Facebook e Instagram",
      subtitle: "Gestisci le tue integrazioni Meta",
      actions: {
        newConnection: "Nuova connessione",
        connectFacebook: "Collega Facebook",
        connectInstagram: "Collega Instagram",
      },
      meta: {
        title: "Dati Meta (unici per cliente)",
        step1: "1. In Meta Developer, configura il prodotto Webhooks usando:",
        webhookUrl: "Webhook URL:",
        verifyToken: "Verify Token:",
        copy: "Copia",
        step2: "2. Iscriviti agli oggetti/campi:",
        objectWord: "oggetto",
        fieldsWord: "campi",
        step3:
          "3. Quando Meta verifica, vedrai lo stato salvato nell'app. Poi, i messaggi in arrivo arriveranno in Tickets e potrai rispondere dalla chat.",
        user: "Utente:",
      },
      filters: {
        title: "Filtri",
        searchLabel: "Cerca (nome o ID)",
        category: "Categoria",
        from: "Da",
        to: "A",
        inactiveShort: "Inatt.",
      },
      table: {
        title: "Connessioni",
        empty: "Nessuna connessione da mostrare.",
        headers: {
          platform: "Piattaforma",
          name: "Nome",
          id: "ID",
          category: "Categoria",
          status: "Stato",
          webhook: "Webhook",
          created: "Creato",
          active: "Attivo",
          actions: "Azioni",
        },
      },
      labels: {
        pageId: "ID della pagina",
        instagramAccountId: "ID account Instagram",
      },
      status: {
        connected: "Connessa",
        disconnected: "Disconnessa",
        error: "Errore",
        verified: "Verificato",
        pending: "In attesa",
      },
      tooltips: {
        edit: "Modifica",
        disconnect: "Disconnetti",
      },
      dialog: {
        newTitle: "Nuova connessione {{platform}}",
        editTitle: "Modifica connessione {{platform}}",
        info: "Questa schermata crea una connessione API manuale. Incolla l'Access Token e l'ID corrispondente.",
        fields: {
          name: "Nome",
          categoryOptional: "Categoria (opzionale)",
          accessToken: "Access Token",
          accessTokenEditHint: "Access Token (lascia vuoto per mantenere)",
        },
        saving: "Salvataggio...",
      },
      validations: {
        selectValidChannel: "Seleziona un canale valido",
        nameRequired: "Il nome è obbligatorio",
        idRequired: "{{idLabel}} è obbligatorio",
        accessTokenRequired: "Access Token è obbligatorio",
      },
      confirm: {
        disconnect: "Sei sicuro di voler disconnettere questo account?",
      },
      toasts: {
        copied: "Copiato",
        accountActivated: "Account attivato con successo",
        accountDeactivated: "Account disattivato con successo",
        statusToggleError: "Errore durante il cambio di stato dell'account",
        disconnectSuccess: "Account disconnesso con successo!",
        disconnectError: "Errore durante la disconnessione dell'account",
        connectionUpdated: "Connessione aggiornata",
        connectionCreated: "Connessione creata",
        saveError: "Errore durante il salvataggio della connessione",
      },
    },
    salesDashboard: {
      title: "Dashboard vendite",
      subtitle: "Benvenuto, {{name}} - Ecco le tue prestazioni",
      errors: {
        load: "Errore nel caricamento dei dati di vendita.",
      },
      metrics: {
        totalLeads: "Totale lead",
        convertedClients: "Clienti convertiti",
        totalRevenue: "Ricavi totali",
        ranking: "Classifica venditori",
        thisMonth: "Questo mese",
        cumulative: "Totale",
        conversionSubtitle: "{{rate}}% conversione",
        rankingSubtitle: "Top 3 del team",
      },
      goal: {
        title: "Obiettivo mensile",
        progress: "Avanzamento: {{percent}}%",
        reached: "Obiettivo raggiunto! 🎉",
        remaining: "Mancano {{amount}} per raggiungere l'obiettivo",
      },
      topProduct: {
        title: "Prodotto più venduto",
        salesThisMonth: "{{count}} vendite questo mese",
        conversionRate: "Tasso di conversione",
        avgValue: "Valore medio",
      },
      quickActions: {
        title: "Azioni rapide",
        viewLeads: "Vedi i miei lead",
        registerClient: "Registra cliente",
        commissions: "Le mie commissioni",
        aiSales: "IA per le vendite",
      },
    },
    teamDashboard: {
      title: "Dashboard team",
      subtitle: "Monitora le prestazioni del tuo team di vendita",
      errors: {
        load: "Errore nel caricamento dei dati del team.",
      },
      metrics: {
        teamMembers: "Membri del team",
        activeMembersSubtitle: "{{count}} attivi",
        teamRevenue: "Ricavi del team",
        thisMonth: "Questo mese",
        topSeller: "Miglior venditore",
        topSellerSubtitle: "Migliore performance",
        teamGoal: "Obiettivo del team",
      },
      goal: {
        title: "Avanzamento obiettivo del team",
        completed: "{{percent}}% completato",
        reached: "🎉 Obiettivo del team raggiunto!",
        remaining: "Mancano {{amount}} per l'obiettivo mensile",
      },
      table: {
        title: "Prestazioni individuali",
        headers: {
          seller: "Venditore",
          leads: "Lead",
          conversions: "Conversioni",
          revenue: "Ricavi",
          goal: "Obiettivo",
          performance: "Performance",
          status: "Stato",
          actions: "Azioni",
        },
      },
      status: {
        active: "Attivo",
        inactive: "Inattivo",
      },
      tooltips: {
        viewDetails: "Vedi dettagli",
        call: "Chiama",
        email: "Email",
      },
      summary: {
        totalLeads: "Totale lead del team",
        totalConversions: "Totale conversioni",
        conversionRate: "Tasso di conversione",
      },
    },
    commission: {
      title: "Le mie commissioni",
      subtitle: "Gestisci e monitora i tuoi guadagni",
      errors: {
        load: "Errore nel caricamento dei dati delle commissioni.",
      },
      defaults: {
        client: "Cliente",
        plan: "Piano",
      },
      period: {
        label: "Periodo",
        current: "Mese corrente",
        last: "Mese scorso",
        quarter: "Ultimo trimestre",
        year: "Quest'anno",
        selected: "Periodo selezionato",
      },
      metrics: {
        totalEarned: "Totale guadagnato",
        currentMonth: "Mese corrente",
        pendingPayout: "Pagamento in sospeso",
        paid: "Pagato",
        cumulative: "Totale",
        rateSubtitle: "Tasso: {{rate}}%",
        toProcess: "Da elaborare",
        processed: "Elaborato",
      },
      goal: {
        title: "Obiettivo commissioni - {{period}}",
        progress: "Avanzamento: {{percent}}%",
        reached: "🎉 Obiettivo raggiunto! Ottimo lavoro",
        remaining: "Mancano {{amount}} per raggiungere il tuo obiettivo mensile",
        rateLabel: "Tasso di commissione",
      },
      table: {
        title: "Storico commissioni",
        headers: {
          client: "Cliente",
          plan: "Piano",
          saleValue: "Valore vendita",
          commission: "Commissione",
          status: "Stato",
          date: "Data",
        },
      },
      status: {
        paid: "Pagato",
        pending: "In sospeso",
      },
      summary: {
        totalPaid: "Totale commissioni pagate",
        totalPending: "Totale commissioni in sospeso",
      },
    },
    checkout: {
      steps: {
        data: "Dati",
        customize: "Personalizza",
        review: "Rivedi",
      },
      gateways: {
        steps: {
          selectPlan: "Seleziona piano",
          paymentMethod: "Metodo di pagamento",
          confirm: "Conferma",
        },
        errors: {
          loadPlans: "Impossibile caricare i piani.",
          missingCustomerInfo: "Inserisci nome ed email.",
          initMercadoPago: "Impossibile avviare il pagamento con MercadoPago.",
          processPayment: "Errore durante l'elaborazione del pagamento.",
        },
        title: "Migliora il tuo piano",
        subtitle: "Scegli il piano perfetto per la tua attività",
        billing: {
          monthly: "Mensile",
          yearly: "Annuale",
          freeMonths: "{{count}} mesi gratis",
        },
        plan: {
          mostPopular: "Più popolare",
          perMonth: "/mese",
          perYear: "/anno",
          savings: "Risparmi {{amount}}",
          limits: {
            messagesPerMonth: "{{value}} messaggi/mese",
            channels: "{{value}} canali",
            users: "{{value}} utenti",
          },
        },
        billingInfo: {
          title: "Informazioni di fatturazione",
          fullName: "Nome completo",
          email: "Email",
        },
        summary: {
          title: "Riepilogo",
          plan: "Piano {{plan}}",
          cycle: "Ciclo: {{cycle}}",
        },
        paymentMethod: {
          title: "Metodo di pagamento",
          mercadoPago: "MercadoPago (Perù)",
          paypal: "PayPal (Internazionale)",
        },
        buttons: {
          payWithMercadoPago: "Paga con MercadoPago",
          payWithPayPal: "Paga con PayPal",
        },
        securityHint: "Pagamento sicuro. Puoi annullare quando vuoi.",
      },
      header: "Ci siamo quasi!",
      notFound: "Non trovato.",
      buttons: {
        pay: "Paga",
        select: "Seleziona",
        increase: "Aumenta",
        decrease: "Diminuisci",
      },
      paymentHint: "Dopo aver effettuato il pagamento, aggiorna la pagina.",
      toasts: {
        subscriptionCreatedWaiting:
          "Abbonamento creato correttamente. In attesa della conferma del pagamento.",
      },
      form: {
        fullName: {
          label: "Nome completo*",
          required: "Il nome completo è obbligatorio",
        },
        lastName: {
          label: "Cognome*",
          required: "Il cognome è obbligatorio",
        },
        address: {
          label: "Indirizzo*",
          required: "L'indirizzo è obbligatorio",
        },
        city: {
          label: "Città*",
          required: "La città è obbligatoria",
        },
        state: {
          label: "Stato/Provincia*",
          required: "Lo stato/provincia è obbligatorio",
        },
        document: {
          label: "CPF/CNPJ*",
          required: "Il documento è obbligatorio",
          invalid: "Formato documento non valido",
        },
        country: {
          label: "Paese*",
          required: "Il paese è obbligatorio",
        },
        useAddressForPaymentDetails: {
          label: "Usa questo indirizzo per i dati di pagamento",
        },
        nameOnCard: {
          label: "Nome sulla carta*",
          required: "Il nome sulla carta è obbligatorio",
        },
        cardNumber: {
          label: "Numero carta*",
          required: "Il numero carta è obbligatorio",
          invalid: "Il numero carta non è valido (es. 4111111111111)",
        },
        expiryDate: {
          label: "Data di scadenza*",
          required: "La data di scadenza è obbligatoria",
          invalid: "La data di scadenza non è valida",
        },
        cvv: {
          label: "CVV*",
          required: "Il CVV è obbligatorio",
          invalid: "Il CVV non è valido (es. 357)",
        },
      },
      plan: {
        perMonth: "/mese",
        users: "{{count}} Utenti",
        connections: "{{count}} Connessioni",
        queues: "{{count}} Code",
      },
      review: {
        title: "Riepilogo abbonamento",
        planDetails: {
          title: "Dettagli del piano",
          users: "Utenti: {{count}}",
          connections: "Connessioni: {{count}}",
          queues: "Code: {{count}}",
          billing: "Fatturazione: Mensile",
        },
        paymentInfo: {
          title: "Informazioni di pagamento",
          document: "CPF/CNPJ",
          total: "Totale",
        },
      },
      success: {
        total: "TOTALE",
        copyQrCode: "Copia codice QR",
        instructions:
          "Per completare, effettua il pagamento scansionando o incollando il codice Pix qui sopra.",
        licenseRenewed: "La tua licenza è stata rinnovata fino al {{date}}!",
      },
    },
    modulesManager: {
      table: {
        key: "Chiave",
        category: "Categoria",
        addon: "Componente aggiuntivo",
      },
      toasts: {
        loadError: "Impossibile caricare i moduli.",
        saved: "Modulo salvato.",
        saveError: "Impossibile salvare il modulo.",
        deactivated: "Modulo disattivato.",
        deactivateError: "Impossibile disattivare il modulo.",
      },
      confirm: {
        deactivateTitle: "Disattiva modulo",
        deactivateMessage: "Vuoi disattivare questo modulo?",
      },
    },
    flowImportModal: {
      title: "Importa flusso",
      instructions: "Seleziona un file .zip esportato da Flowbuilder.",
      noFile: "Nessun file selezionato",
      buttons: {
        chooseFile: "Scegli file",
        import: "Importa",
      },
      toasts: {
        selectZip: "Seleziona un file .zip",
        success: "Flusso importato con successo.",
        error: "Errore durante l'importazione del flusso.",
      },
    },
    chatList: {
      confirm: {
        deleteTitle: "Elimina conversazione",
        deleteMessage: "Questa azione non può essere annullata. Confermare?",
      },
    },
    planModulesManager: {
      form: {
        plan: "Piano",
      },
      table: {
        module: "Modulo",
        category: "Categoria",
        included: "Incluso",
      },
      buttons: {
        saveChanges: "Salva modifiche",
      },
      toasts: {
        plansLoadError: "Impossibile caricare i piani.",
        modulesLoadError: "Impossibile caricare i moduli del piano.",
        saved: "Moduli del piano aggiornati.",
        saveError: "Impossibile salvare i moduli del piano.",
      },
    },
    companyModulesManager: {
      table: {
        module: "Modulo",
        category: "Categoria",
        plan: "Piano",
        override: "Override",
        effective: "Effettivo",
      },
      override: {
        plan: "Usa piano",
        enable: "Abilita",
        disable: "Disabilita",
      },
      buttons: {
        saveChanges: "Salva modifiche",
      },
      toasts: {
        companiesLoadError: "Impossibile caricare le aziende.",
        modulesLoadError: "Impossibile caricare i moduli dell'azienda.",
        saved: "Moduli azienda aggiornati.",
        saveError: "Impossibile aggiornare i moduli.",
      },
    },
    contactNotesDialog: {
      toasts: {
        added: "Nota aggiunta con successo.",
        deleted: "Nota eliminata con successo.",
      },
      confirm: {
        deleteTitle: "Elimina record",
        deleteMessage: "Vuoi davvero eliminare questo record?",
      },
    },
    contacts: {
      menu: {
        importExport: "Importa / Esporta",
      },
      importPage: {
        title: "Importa contatti da file",
      },
      toasts: {
        batchDeleted: "Contatti selezionati eliminati.",
        blocked: "Contatto bloccato.",
        unblocked: "Contatto sbloccato.",
      },
      confirmationModal: {
        blockTitle: "Blocca {{name}}",
        unblockTitle: "Sblocca {{name}}",
        chooseConnectionToImport:
          "Scegli da quale connessione importare i contatti.",
        batchDeleteTitle: "Elimina {{count}} contatti",
        batchDeleteMessage:
          "Vuoi davvero eliminare i contatti selezionati? Questa azione non può essere annullata.",
      },
      buttons: {
        deleteSelected: "Elimina selezionati ({{count}})",
      },
      accessibility: {
        selectAll: "Seleziona tutti i contatti",
        selectContact: "Seleziona contatto {{name}}",
      },
    },
    contactImport: {
      validateWhatsapp: "Convalida contatti su WhatsApp",
      uploading: "Importazione... attendere",
      buttons: {
        importContacts: "Importa contatti",
      },
      fields: {
        name: "Nome",
        number: "Numero",
        email: "Email",
        tags: "Tag",
      },
      errors: {
        missingNumberField: "Seleziona la colonna per il campo \"Numero\".",
        missingNameField: "Seleziona la colonna per il campo \"Nome\".",
        noContactsSelected: "Seleziona almeno un contatto da importare.",
        fieldAlreadySelected: "Il campo {{field}} è già selezionato.",
      },
      toasts: {
        success: "Contatti importati con successo.",
        successWithErrors:
          "Importazione completata con avvisi. Alcuni contatti sono stati ignorati.",
      },
      summary: {
        created: "{{count}} contatti creati",
        ignored:
          "{{count}} contatti ignorati (numero non valido o non selezionati per aggiornamento)",
      },
      file: {
        processing: "Elaborazione file...",
        invalid: "File non valido!",
      },
      dropzone: {
        title: "Clicca o trascina un file",
        note:
          "* Importante: sono accettati solo file con estensioni: xls, xlsx, csv, txt",
      },
      alt: {
        upload: "Carica file",
      },
    },
    slaPolicies: {
      title: "SLA per canale",
      description:
        "Configura i tempi di prima risposta, risposta successiva e risoluzione per canale.",
      fields: {
        firstResponseMinutes: "Prima risposta (min)",
        nextResponseMinutes: "Risposta successiva (min)",
        resolutionMinutes: "Risoluzione (min)",
      },
      buttons: {
        save: "Salva SLA",
      },
      toasts: {
        loadError: "Errore durante il caricamento dello SLA.",
        saved: "SLA aggiornato.",
        saveError: "Errore durante il salvataggio dello SLA.",
      },
    },
    ticketMessagesDialog: {
      errors: {
        exportTargetNotFound: "Elemento non trovato per l'esportazione.",
      },
      buttons: {
        exportPdf: "Esporta in PDF",
      },
    },
    reports: {
      buttons: {
        exportExcel: "Esporta in Excel",
      },
    },
    campaignPhraseModal: {
      title: {
        create: "Crea campagna per frase",
        edit: "Modifica campagna per frase",
      },
      fields: {
        name: "Nome",
        flow: "Flusso",
        phrase: "Frase",
      },
      placeholders: {
        flow: "Seleziona un flusso",
        connection: "Seleziona una connessione",
      },
      buttons: {
        createCampaign: "Crea campagna",
        saveCampaign: "Salva campagna",
      },
      toasts: {
        created: "Campagna creata con successo.",
        updated: "Campagna aggiornata con successo.",
      },
    },
    colorBoxModal: {
      title: "Seleziona colore",
    },
    editMessageModal: {
      title: "Modifica messaggio",
      placeholders: {
        message: "Scrivi il messaggio...",
      },
      aria: {
        messageInput: "Messaggio modificato",
      },
    },
    flowDefault: {
      title: "Flussi predefiniti",
      confirm: {
        deleteMessage: "Vuoi davvero eliminare questo flusso?",
      },
      sections: {
        welcome: {
          title: "Flusso di benvenuto",
          description:
            "Seleziona il flusso da inviare all'inizio di una conversazione.",
        },
        defaultReply: {
          title: "Flusso di risposta predefinito",
          description:
            "Seleziona il flusso da usare quando non c'è corrispondenza di frase.",
        },
      },
      placeholders: {
        selectFlow: "Seleziona un flusso",
      },
      toasts: {
        deleted: "Flusso eliminato con successo.",
        updated: "Flussi predefiniti aggiornati.",
      },
    },
    campaignsConfig: {
      sections: {
        intervals: "Intervalli",
      },
      errors: {
        noPermissionRedirect:
          "Questa azienda non ha l'autorizzazione per accedere a questa pagina. Reindirizzamento in corso.",
      },
    },
    campaigns: {
      settings: {
        seconds: "secondi",
      },
      dialog: {
        tabs: {
          message: "Messaggio {{number}}",
        },
      },
      table: {
        notScheduled: "Non pianificata",
        notCompleted: "Non completata",
      },
      status: {
        inactive: "Inattiva",
        scheduled: "Pianificata",
        running: "In corso",
        canceled: "Annullata",
        completed: "Completata",
      },
      actions: {
        stop: "Ferma campagna",
        restart: "Riavvia campagna",
      },
    },
    flowBuilderConfig: {
      title: "Disegna il tuo flusso",
      reminder: "Non dimenticare di salvare il tuo flusso!",
      aria: {
        speedDial: "Aggiungi nodo",
      },
      toasts: {
        saved: "Flusso salvato con successo.",
      },
      actions: {
        start: "Inizio",
        content: "Contenuto",
        menu: "Menu",
        randomizer: "Randomizzatore",
        interval: "Intervallo",
        ticket: "Coda",
        typebot: "TypeBot",
        openai: "OpenAI",
        question: "Domanda",
      },
      fallback: {
        html5: "Il tuo browser non supporta HTML5",
      },
      units: {
        seconds: "secondi",
      },
      nodes: {
        start: {
          title: "Inizio del flusso",
          description: "Questo blocco segna l'inizio del tuo flusso.",
        },
        message: {
          title: "Messaggio",
        },
        interval: {
          title: "Intervallo",
          seconds: "{{seconds}} secondi",
        },
        menu: {
          title: "Menu",
        },
        randomizer: {
          title: "Randomizzatore",
        },
        audio: {
          title: "Audio",
          recordedNow: "Registrato al momento",
          sent: "Audio inviato",
        },
        image: {
          title: "Immagine",
          previewAlt: "Anteprima immagine",
        },
        video: {
          title: "Video",
        },
        condition: {
          title: "Condizione",
        },
        singleBlock: {
          title: "Contenuto",
        },
        ticket: {
          title: "Coda",
        },
        typebot: {
          title: "TypeBot",
          iconAlt: "Icona TypeBot",
        },
        openai: {
          title: "OpenAI/Gemini",
        },
        question: {
          title: "Domanda",
        },
      },
    },
    flowBuilderModal: {
      title: {
        create: "Aggiungi flusso",
        edit: "Modifica flusso",
      },
    },
    buttonModal: {
      title: "Seleziona un'opzione",
      select: {
        placeholder: "Seleziona",
      },
      options: {
        list: "Lista",
        copy: "Copia",
        callMe: "Chiamami",
      },
      fields: {
        title: "Titolo",
        description: "Descrizione",
        message: "Messaggio",
        buttonText: "Testo del pulsante",
        url: "URL",
        copyText: "Testo da copiare",
        phone: "Telefono",
        value: "Valore",
        image: "Immagine",
        name: "Nome",
      },
      buttons: {
        addOption: "Aggiungi nuova opzione",
      },
      list: {
        optionLabel: "Opzione {{number}}",
        defaultSectionTitle: "Opzioni",
        defaultButtonText: "Clicca qui",
      },
      url: {
        defaults: {
          title: "Pulsante URL",
          description: "Messaggio con pulsante",
          buttonText: "Apri link",
          url: "https://esempio.com",
        },
      },
      pix: {
        keyType: {
          placeholder: "Tipo di chiave",
          phone: "Telefono",
          email: "Email",
          random: "Chiave casuale",
        },
        fields: {
          key: "Chiave Pix",
        },
      },
      errors: {
        invalidTicketId: "ID ticket non valido.",
        noOptionSelected: "Seleziona un'opzione.",
        processMessage: "Errore durante l'elaborazione del messaggio.",
      },
    },
    queueOptions: {
      title: "Opzioni",
      placeholders: {
        title: "Titolo dell'opzione",
        message: "Inserisci il testo dell'opzione",
      },
      fallback: {
        undefinedTitle: "Titolo non definito",
      },
    },
    nodePalette: {
      title: "Nodi disponibili",
      nodeCount: "{{count}} nodi professionali",
      searchPlaceholder: "Cerca nodi...",
      noResults: {
        title: "Nessun nodo trovato",
        subtitle: "Prova un altro termine",
      },
      categories: {
        trigger: {
          name: "Attivatori",
          description: "Avvia il flusso automaticamente",
        },
        ai: {
          name: "IA e machine learning",
          description: "Intelligenza artificiale avanzata",
        },
        crm: {
          name: "CRM e vendite",
          description: "Gestione clienti e vendite",
        },
        ecommerce: {
          name: "E-commerce e pagamenti",
          description: "Negozi online e pagamenti",
        },
        communication: {
          name: "Comunicazione",
          description: "Messaggistica e comunicazione",
        },
        database: {
          name: "Database",
          description: "Database e archiviazione",
        },
        storage: {
          name: "Cloud e file",
          description: "Archiviazione cloud",
        },
        analytics: {
          name: "Analisi e tracciamento",
          description: "Analisi e metriche",
        },
        marketing: {
          name: "Marketing e pubblicità",
          description: "Marketing e pubblicità",
        },
        logic: {
          name: "Logica e controllo del flusso",
          description: "Controllo del flusso e logica",
        },
        transform: {
          name: "Trasformazione dei dati",
          description: "Trasformazione dei dati",
        },
        action: {
          name: "Azioni e automazione",
          description: "Azioni e automazione",
        },
      },
      nodes: {
        trigger: {
          whatsapp_message: "Messaggio WhatsApp",
          whatsapp_status: "Stato WhatsApp",
          telegram_message: "Messaggio Telegram",
          email_received: "Email ricevuta",
          sms_received: "SMS ricevuto",
          webhook: "Webhook",
          schedule: "Pianificazione/Cron",
          form_submit: "Invio modulo",
          file_upload: "Caricamento file",
          api_call: "Chiamata API",
          database_change: "Modifica database",
          payment_received: "Pagamento ricevuto",
          order_placed: "Ordine effettuato",
          new_contact: "Nuovo contatto",
          calendar_event: "Evento calendario",
          button_click: "Clic pulsante",
          qr_scan: "Scansione QR",
          voice_command: "Comando vocale",
        },
        ai: {
          gpt4: "Chat GPT-4",
          gpt4_vision: "GPT-4 Vision",
          claude: "Claude 3",
          gemini: "Google Gemini",
          dall_e: "Immagine DALL-E",
          whisper: "Audio Whisper",
          tts: "Sintesi vocale",
          intent_detection: "Rilevamento intento",
          sentiment: "Analisi del sentiment",
          rag: "Query RAG",
          summarize: "Sintesi testo",
          translate: "Traduzione",
          classify: "Classificazione testo",
          entity_extraction: "Estrazione entità",
          embeddings: "Genera embeddings",
          question_answer: "Sistema Q&A",
          content_moderate: "Moderazione contenuti",
          image_recognition: "Riconoscimento immagini",
          ocr: "OCR: estrazione testo",
          face_detection: "Rilevamento volto",
          object_detection: "Rilevamento oggetti",
          speech_recognition: "Riconoscimento vocale",
          video_analysis: "Analisi video",
          predictive: "Modello predittivo",
          recommendation: "Motore di raccomandazione",
        },
        crm: {
          salesforce_lead: "Lead Salesforce",
          salesforce_contact: "Contatto Salesforce",
          hubspot_contact: "Contatto HubSpot",
          hubspot_deal: "Trattativa HubSpot",
          pipedrive_deal: "Trattativa Pipedrive",
          pipedrive_activity: "Attività Pipedrive",
          zoho_lead: "Lead Zoho",
          zoho_account: "Account Zoho",
          dynamics_contact: "Contatto Dynamics",
          freshsales: "Freshsales",
          airtable: "Airtable",
          notion: "Database Notion",
          monday: "Monday.com",
          asana: "Attività Asana",
          trello: "Scheda Trello",
          jira: "Issue Jira",
          zendesk: "Ticket Zendesk",
          intercom: "Messaggio Intercom",
        },
        ecommerce: {
          shopify_order: "Ordine Shopify",
          shopify_product: "Prodotto Shopify",
          shopify_customer: "Cliente Shopify",
          woocommerce_order: "Ordine WooCommerce",
          woocommerce_product: "Prodotto WooCommerce",
          mercadolibre: "Mercado Libre",
          amazon: "Amazon FBA",
          ebay: "Inserzione eBay",
          stripe_payment: "Pagamento Stripe",
          stripe_subscription: "Abbonamento Stripe",
          paypal: "Transazione PayPal",
          square: "Pagamento Square",
          mercadopago: "Mercado Pago",
          conekta: "Pagamento Conekta",
          wix_store: "Negozio Wix",
          squarespace: "Squarespace",
          bigcommerce: "BigCommerce",
          magento: "Magento",
          prestashop: "PrestaShop",
          shipment_tracking: "Tracciamento spedizione",
        },
        communication: {
          whatsapp_send: "Invia WhatsApp",
          whatsapp_template: "Template WhatsApp",
          whatsapp_media: "Media WhatsApp",
          telegram_send: "Invia Telegram",
          telegram_bot: "Bot Telegram",
          slack_message: "Messaggio Slack",
          slack_channel: "Canale Slack",
          discord_message: "Messaggio Discord",
          discord_embed: "Embed Discord",
          email_smtp: "Email SMTP",
          email_template: "Template email",
          sms_twilio: "SMS Twilio",
          sms_nexmo: "SMS Nexmo",
          voice_call: "Chiamata vocale",
          push_notification: "Notifica push",
          teams_message: "Microsoft Teams",
          zoom_meeting: "Riunione Zoom",
          google_meet: "Google Meet",
          messenger_send: "Facebook Messenger",
          instagram_dm: "DM Instagram",
          twitter_dm: "DM Twitter",
          linkedin_message: "Messaggio LinkedIn",
        },
        database: {
          postgresql: "PostgreSQL",
          mysql: "MySQL",
          mongodb: "MongoDB",
          redis: "Cache Redis",
          elasticsearch: "Elasticsearch",
          firebase_firestore: "Firebase Firestore",
          firebase_realtime: "Firebase Realtime",
          supabase: "Supabase",
          dynamodb: "AWS DynamoDB",
          cosmosdb: "Azure Cosmos DB",
          cassandra: "Cassandra",
          mariadb: "MariaDB",
          oracle: "Oracle DB",
          sql_server: "SQL Server",
          sqlite: "SQLite",
          couchdb: "CouchDB",
          influxdb: "InfluxDB",
          neo4j: "Grafo Neo4j",
        },
        storage: {
          google_drive: "Google Drive",
          google_sheets: "Google Sheets",
          dropbox: "Dropbox",
          s3: "AWS S3",
          azure_blob: "Azure Blob Storage",
          onedrive: "OneDrive",
          box: "Box",
          ftp: "Server FTP",
          sftp: "Server SFTP",
          github: "Repo GitHub",
          gitlab: "Repo GitLab",
          bitbucket: "Bitbucket",
        },
        analytics: {
          google_analytics: "Google Analytics",
          ga4_event: "Evento GA4",
          mixpanel: "Mixpanel",
          amplitude: "Amplitude",
          segment: "Segment (Track)",
          hotjar: "Evento Hotjar",
          posthog: "PostHog",
          heap: "Heap Analytics",
          facebook_pixel: "Facebook Pixel",
          google_tag: "Google Tag Manager",
          custom_event: "Evento personalizzato",
          ab_test: "Test A/B",
        },
        marketing: {
          facebook_ads: "Annunci Facebook",
          google_ads: "Annunci Google",
          instagram_ads: "Annunci Instagram",
          linkedin_ads: "Annunci LinkedIn",
          twitter_ads: "Annunci Twitter",
          mailchimp: "Campagna Mailchimp",
          sendgrid: "Email SendGrid",
          activecampaign: "ActiveCampaign",
          convertkit: "ConvertKit",
          hubspot_email: "Email HubSpot",
          klaviyo: "Klaviyo",
          brevo: "Brevo (Sendinblue)",
          tiktok_ads: "Annunci TikTok",
          youtube_ads: "Annunci YouTube",
          pinterest_ads: "Annunci Pinterest",
        },
        logic: {
          condition: "Condizione If",
          switch: "Caso Switch",
          router: "Router",
          loop: "Loop/Itera",
          for_each: "Per ogni",
          while: "Loop While",
          filter: "Filtra array",
          sort: "Ordina array",
          merge: "Unisci dati",
          split: "Dividi dati",
          aggregate: "Aggrega",
          limit: "Limita risultati",
          delay: "Ritardo/Attesa",
          error_handler: "Gestore errori",
          retry: "Riprova",
        },
        transform: {
          json_parse: "Parser JSON",
          json_stringify: "JSON Stringify",
          xml_parse: "Parser XML",
          csv_parse: "Parser CSV",
          data_mapper: "Mappatura dati",
          text_extract: "Estrai testo (Regex)",
          text_replace: "Sostituisci testo",
          hash: "Generatore hash",
          encrypt: "Cifra dati",
          decrypt: "Decifra dati",
          base64: "Base64 codifica/decodifica",
          url_encode: "Codifica URL",
        },
        action: {
          send_message: "Invia messaggio",
          create_ticket: "Crea ticket",
          tag_contact: "Tag contatto",
          update_contact: "Aggiorna contatto",
          create_task: "Crea attività",
          send_email: "Invia email",
          log_event: "Registra evento",
          webhook_call: "Chiama webhook",
          http_request: "Richiesta HTTP",
          graphql: "Query GraphQL",
          run_script: "Esegui JavaScript",
          python_script: "Esegui Python",
          schedule_action: "Pianifica azione",
          trigger_flow: "Avvia un altro flusso",
          stop_flow: "Ferma flusso",
        },
      },
    },
    allConnections: {
      table: {
        customer: "Cliente",
        connectedConnections: "Connessioni connesse",
        disconnectedConnections: "Connessioni disconnesse",
        totalConnections: "Totale connessioni",
      },
    },
    webhooksPage: {
      title: "Webhooks",
      soon: "Prossimamente.",
    },
    helps: {
      settings: {
        title: "Titolo",
      },
    },
    plans: {
      form: {
        queues: "Code",
        amount: "Valore",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        internalChat: "Chat interno",
        externalApi: "API esterna",
        kanban: "Kanban",
        openAi: "OpenAI",
        integrations: "Integrazioni",
      },
    },
    invoices: {
      table: {
        status: "Stato",
        idLabel: "ID: {{id}}",
      },
      tooltips: {
        details: "Dettagli",
        users: "Utenti",
        connections: "Connessioni",
        queues: "Code",
        value: "Valore",
        dueDate: "Scadenza",
      },
      status: {
        paid: "Pagata",
        overdue: "Scaduta",
        open: "Aperta",
      },
      actions: {
        pay: "Paga",
        payNow: "Paga ora",
      },
      daysLeft: {
        overdueOne: "Scaduta da {{days}} giorno",
        overdueMany: "Scaduta da {{days}} giorni",
        dueToday: "Scade oggi",
        dueInOne: "Scade tra {{days}} giorno",
        dueInMany: "Scade tra {{days}} giorni",
      },
    },
    buttonPreview: {
      toasts: {
        codeCopied: "Codice copiato.",
      },
      errors: {
        noContentToCopy: "Nessun contenuto da copiare.",
        noLinkAvailable: "Nessun link disponibile.",
        callsNotSupported: "Le chiamate non sono supportate in questa anteprima.",
      },
      empty: {
        noButtonsInSection: "Nessun pulsante in questa sezione.",
        noSectionsAvailable: "Nessuna sezione disponibile.",
      },
      alt: {
        preview: "Anteprima",
      },
    },
    schedules: {
      calendar: {
        date: "Data",
        time: "Ora",
        event: "Evento",
        allDay: "Tutto il giorno",
        week: "Settimana",
        workWeek: "Settimana lavorativa",
        day: "Giorno",
        month: "Mese",
        yesterday: "Ieri",
        tomorrow: "Domani",
        today: "Oggi",
        agenda: "Agenda",
        noEventsInRange: "Nessun evento in questo intervallo.",
        showMore: "+{{total}} altri",
      },
    },
    layout: {
      errors: {
        accountAccessedElsewhere:
          "Questo utente è già connesso su un altro dispositivo. Verrai disconnesso.",
      },
    },
    messageOptionsMenu: {
      toasts: {
        reactionSent: "Reazione inviata.",
      },
    },
    newTicketModal: {
      placeholders: {
        queue: "Seleziona una coda",
        connection: "Seleziona una connessione",
      },
      errors: {
        queueRequired: "Seleziona una coda per continuare.",
      },
    },
    analytics: {
      title: "Analitiche",
      subtitle: "Metriche e tendenze del tuo business",
      toasts: {
        loadError: "Errore nel caricamento delle analitiche.",
      },
      period: {
        label: "Periodo",
        options: {
          week: "Settimana",
          month: "Mese",
          quarter: "Trimestre",
          year: "Anno",
        },
      },
      metrics: {
        totalRevenue: "Ricavi totali",
        totalLeads: "Lead totali",
        conversionRate: "Tasso di conversione",
        avgDealSize: "Valore medio affare",
        vsPreviousPeriod: "{{value}}% vs periodo precedente",
      },
      monthlyTrends: {
        title: "Andamento mensile",
        revenueTrend: "Trend dei ricavi",
        table: {
          month: "Mese",
          leads: "Lead",
          conversions: "Conversioni",
          conversionRate: "Tasso",
          revenue: "Ricavi",
        },
      },
      topProducts: {
        title: "Prodotti principali",
        salesLabel: "{{count}} vendite",
      },
      leadSources: {
        title: "Fonti lead",
        countLabel: "{{count}} lead",
      },
    },
    campaignsPhrase: {
      toasts: {
        deleted: "Frase eliminata con successo.",
      },
    },
    messagesAPI: {
      toasts: {
        sent: "Messaggio inviato con successo.",
      },
      labels: {
        endpoint: "Endpoint",
        method: "Metodo",
        headers: "Header",
        body: "Corpo",
        formData: "FormData",
        testSend: "Invio di prova",
      },
      docs: {
        headers: {
          json: "Authorization: Bearer (token registrato) e Content-Type (application/json)",
          formData:
            "Authorization: Bearer (token registrato) e Content-Type (multipart/form-data)",
        },
        fields: {
          userIdHint: "ID utente/agente o \"\"",
          queueIdHint: "ID della coda o \"\"",
          mediasHint: "file",
          sendSignatureHint: "Firmare il messaggio - true/false",
          closeTicketHint: "Chiudere il ticket - true/false",
        },
      },
    },
    messageModal: {
      title: {
        add: "Nuovo messaggio programmato",
        edit: "Modifica messaggio programmato",
      },
      success: {
        save: "Messaggio programmato salvato.",
      },
      placeholders: {
        connection: "Connessione",
        contacts: "Contatti",
        users: "Utenti",
      },
      form: {
        createTicket: "Crea ticket",
      },
    },
    listPreview: {
      modal: {
        title: "Lista pulsanti",
      },
      fields: {
        selectedTitlePlaceholder: "Titolo selezionato",
      },
      a11y: {
        selectedTitle: "titolo selezionato",
      },
      alerts: {
        selectTitle: "Seleziona un titolo.",
        ticketIdNotFound: "Errore: ticketId non trovato.",
        sendError: "Errore durante l'invio del messaggio. Riprova.",
      },
    },
    scheduleModal: {
      statusTitle: {
        sendError: "Errore di invio",
        messageWithStatus: "Messaggio {{status}}",
      },
    },
  },
};
